// Library Imports
import React, { Component } from "react";
import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import * as moment from "moment";
import FileBase64 from "react-file-base64";
import ReactPlayer from "react-player";
import Modal from "react-responsive-modal";
import $ from "jquery";
import loadable from "@loadable/component";
// Service Imports
import { RegisterUserService } from "../../services/registration.service";
import { RegionManagementService } from "../../services/regionManagement.service";
import { ReattemptTestService } from "../../services/reattemptTest.service";
import { getExperienceList } from "../../services/distributor.service";
import { fetchProcessType, getAMCMaster } from "../../services/fetchLearners";
import { LookUpService } from "../../services/lookupService";
// Other Imports
import {
  success,
  error,
  successNotification,
  errorNotification,
  warning,
  warningNotification,
  info,
  infoNotification,
  success1,
  successNotification1,
} from "../notification/notifications";
import { PopUpPortal } from "../../containers/popups/PopUpPortal";
import {
  FirstMessage,
  SecondMessage,
  ThirdMessage,
} from "../learner-dashboard/NotificationMessage";
import LoadingFallback from "../loadingFallBack";
import { AADHAR_WARNING_MESSAGES } from "../../global/global_var";
// Asset Imports
require("moment-precise-range-plugin");
const mapping = require("../../assets/pdf/EUIN Mapping form.pdf");
const fresh = require("../../assets/pdf/EUIN Fresh Form.pdf");
const renewal = require("../../assets/pdf/EUIN Renewal Form.pdf");
const UserProfileComplitionBarCommon = loadable(
  () => import("./userProfileComplitionBarCommon"),
  {
    fallback: <LoadingFallback />,
  },
);

export const TextValidationMesg = "you must enter the text";
export let validateStatus = "DRAFTED";
const currProf = [
  {
    codeValueId: 1071,
    codeValue: "Financial Distributor",
  },
  {
    codeValueId: 1072,
    codeValue: "Information Technology",
  },
  {
    codeValueId: 1073,
    codeValue: "Medicine",
  },
  {
    codeValueId: 1074,
    codeValue: "Engineering",
  },
  {
    codeValueId: 1075,
    codeValue: "Education",
  },
  {
    codeValueId: 1076,
    codeValue: "Govt. Employee",
  },
  {
    codeValueId: 1077,
    codeValue: "Other",
  },
];

class UserProfile extends Component {
  constructor(props) {
    super(props);
    let suspendStartDt = this.props?.personnelData?.dob
      ? this.props?.personnelData?.dob?.split(" ")
      : "";
    let suspendStartDate =
      suspendStartDt !== "" ? suspendStartDt[0]?.split("/") : "";

    this.suspendStartDate2 =
      suspendStartDate !== ""
        ? suspendStartDate[2] +
          "-" +
          suspendStartDate[1] +
          "-" +
          suspendStartDate[0]
        : "";
    let year, month, day;
    year = suspendStartDate[2];
    month = suspendStartDate[1];
    day = suspendStartDate[0];
    const professionalQualification1 =
      props.personnelData.learnerProfessionalQualification || [];

    const professionalQualification2 = professionalQualification1.map(
      (item) => ({
        ...item,
        designation: item?.designation?.slice(0, 50) || "",
        companyName: item?.companyName?.slice(0, 250) || "",
        dateOfJoining: ["1021", 1021].includes(item.occupation)
          ? ""
          : item.dateOfJoining
            ? (() => {
                const [day, month, yearWithTime] =
                  item.dateOfJoining.split("/");
                const year = yearWithTime.split(" ")[0];
                return `${year}-${month}-${day}`;
              })()
            : null,
      }),
    );
    if (this.props.personnelData.certificateValidUpto != undefined) {
      let nismDt = this.props.personnelData.certificateValidUpto.split(" ");
      let nismDate = nismDt[0].split("/");

      this.nismDate2 = nismDate[2] + "-" + nismDate[1] + "-" + nismDate[0];
    }

    if (this.props.personnelData.enrollmentDate != undefined) {
      let enrollDt = this.props.personnelData.enrollmentDate.split(" ");
      let enrollDate = enrollDt[0].split("/");

      this.enrollDate2 =
        enrollDate[2] + "-" + enrollDate[1] + "-" + enrollDate[0];
    }

    if (this.props.personnelData.euinValidUpto != undefined) {
      let euinDt = this.props.personnelData.euinValidUpto.split(" ");
      let euinDate = euinDt[0].split("/");
      this.euinDate2 = euinDate[2] + "-" + euinDate[1] + "-" + euinDate[0];
    }

    if (this.props.personnelData.learnerProfessionalQualification) {
      let learnerProfessionalQualification =
        this.props.personnelData.learnerProfessionalQualification;
      learnerProfessionalQualification.map((ele, index) => {});
    }

    //seperate the incoming address to the permanr address and correspondence address
    let peraddress;
    // let corsAddress;
    this.props.addressData.forEach(function (addr) {
      if (addr.addressType == "permanent") {
        peraddress = addr;
      }
    });
    // this.props.addressData.forEach(function (addr) {
    //   if (addr.addressType == "correspondence") {
    //     corsAddress = addr;
    //   }
    // });
    let addressFlag = false;

    var todaydate = new Date();
    this.state = {
      today: moment(todaydate).format("YYYY-MM-DD"),
      show: false,
      isEditable: false,
      dob: this.suspendStartDate2,
      aadharNumber: this.props.personnelData.aadharNumber,
      perAddressType: peraddress ? peraddress.addressType : "",
      perAddressID: peraddress ? peraddress.addressId : "",
      perStreet: peraddress ? peraddress.street : "",
      perStreet2: peraddress ? peraddress.street2 : "",
      perStreet3: peraddress ? peraddress.street3 : "",
      perPostalCode: peraddress ? peraddress.postalCode : "",
      peraddressproof1: this.props?.personnelData?.proofOfAddress || "",
      percityId: peraddress
        ? [0, "0", "", null, undefined].includes(peraddress.cityId)
          ? ""
          : peraddress.cityId
        : "",
      perCityName: peraddress ? peraddress.city : "",
      perstateId: peraddress
        ? [0, "0", "", null, undefined].includes(peraddress.stateId)
          ? ""
          : peraddress.stateId
        : "",
      perStateName: peraddress ? peraddress.state : "",
      percountryId: peraddress !== undefined ? peraddress.countryId : 1,
      perCountryName: peraddress ? peraddress.country : "",
      stateListForOffice: [],
      cityListForOffice: [],
      officeStreet: this.props.personnelData?.officeAddress?.street || "",
      officeStreet2: this.props.personnelData?.officeAddress?.street2 || "",
      officeStreet3: this.props.personnelData?.officeAddress?.street3 || "",
      officePostalCode:
        this.props.personnelData?.officeAddress?.postalCode || "",
      officecityId: [0, "0", "", null, undefined].includes(
        this.props.personnelData?.officeAddress?.cityId,
      )
        ? ""
        : this.props.personnelData?.officeAddress?.cityId,
      officestateId: [0, "0", "", null, undefined].includes(
        this.props.personnelData?.officeAddress?.stateId,
      )
        ? ""
        : this.props.personnelData?.officeAddress?.stateId,
      officecountryId: this.props.personnelData?.officeAddress?.countryId || 1,
      learnerFatherDOB: this.suspendStartDateFatherBirthDate2,
      learnerMotherDOB: this.suspendStartDateMotherBirthDate2,
      resumeDocumentName: "",
      countryList: [],
      stateListForPer: [],
      cityListForPer: [],
      employeTypeForParents: [],
      checkAddressFlag: "",
      listOfYear: [],
      addressFlag: addressFlag,
      processType: "",
      newLearnerDetails: "",
      whoareu: [],
      occupation: [],
      year: year || "",
      month: month || "",
      day: day || "",
      ValidationState: "DRAFTED",
      educationalQualificationDocument: [],
      corAddressProof: "",
      perAddressProof: "",
      currentDate: "",
      panCardData: "",
      adharCardData: "",
      ProfilePhotoData: "",
      addressPoofCardData: "",
      videoResumeData: "",
      ResumeDocumentData: "",
      pancardTempURL: "",
      newAdharCardUrl: "",
      newAddressProof: "",
      AuualCome: [],
      nameOfMutual: [],
      currentProfession: [],
      loading1: "none",
      loading: false,
      listOfYear1: [],
      listOfMonth: [],
      listOfDay: [],
      listOfYear2: [],
      certificateYear: [],
      isCertificate: this.props.personnelData.isCertificate,
      certificateNumber: this.props.personnelData.nismRegistrationNo
        ? this.props.personnelData.nismRegistrationNo
        : "",
      certificateValidUpto: this.nismDate2,
      enrollmentNumber: this.props.personnelData.enrollmentNumber
        ? this.props.personnelData.enrollmentNumber
        : "",
      enrollmentDate: this.enrollDate2,
      euinNumber: this.props.personnelData.euinNumber,
      euinValidUpto: this.euinDate2,
      companyList: [],
      userDetailList: [],
      companyNameOther: "",
      selectedCompanyId: parseInt(this.props.personnelData.companyName),
      otherCompanyName: this.props.personnelData.otherCompanyName,
      euinyear1: "",
      orgCompanyName: "",
      isMandateUser: this.props.personnelData.isMandateUser,
      assignedUserMandateName: "",
      userId: "",
      assignedUserMandateName: localStorage.getItem("assignedUserMandateName"),
      getExperienceList: [],
      saveDraftBtnDisabled: false,
      submitBtnDisabled: false,
      submitHDFCBtnDisabled: false,
      saveDraftHDFCBtnDisabled: false,
      empNo: this.props?.personnelData?.empNo || "",
      gender: this.props?.personnelData?.gender || "",
      salutation: this.props?.personnelData?.salutation || "",
      firstName: this.props?.personnelData?.firstName?.slice(0, 70) || "",
      middleName: this.props?.personnelData?.middleName || "",
      lastName: this.props?.personnelData?.lastName || "",
      fatherName: this.props?.personnelData?.learnerFatherName || "",
      maritalStatus: this.props?.personnelData?.maritalStatus || "",
      secondaryEmailID: this.props?.personnelData?.secondaryEmailID || "",
      addressTypeMark:
        this.props.addressData &&
        this.props.addressData[0]?.addressTypeMark === "permanent"
          ? true
          : false,
      maskedAadhaar: [
        "",
        null,
        undefined,
        "null",
        "undefined",
        false,
        "false",
      ].includes(this.props?.personnelData?.maskAadharUploadDate)
        ? false
        : true,
      preferredExamLocation:
        this.props.personnelData?.executionTracker[0]?.additionalDetails
          ?.stateId || "",
      preferredExamLocationState: "",
      preferredExamCenter:
        this.props.personnelData?.executionTracker[0]?.additionalDetails
          ?.center || "",
      learnerQualification:
        this.props?.personnelData?.learnerQualification?.map((ele) => ({
          ...ele,
          instituteName: ele?.instituteName?.slice(0, 70),
        })),
      professionalQualification2: professionalQualification2,
      document: [],
      panCardURL: this.props?.personnelData?.panCardURL || "",
      panCardName: this.props?.personnelData?.panCardURL
        ? this.getFileNameFromUrl(this.props?.personnelData?.panCardURL)
        : "",
      documentSizeCheckForPanCard: false,
      documentTypeCheckForPANImage: false,
      documentNameValidation: false,
      addressProofCardURL: this.props?.personnelData?.proofOfAddressURL || "",
      addressProofName: this.props?.personnelData?.proofOfAddressURL
        ? this.getFileNameFromUrl(this.props?.personnelData?.proofOfAddressURL)
        : "",
      documentTypeCheckForaddressProofCardURLImage: false,
      documentSizeCheckForaddressProofCardURLCard: false,
      AressProofDocumentNameValidation: false,
      profilePhotoURL: this.props?.personnelData?.profilePhotoURL || "",
      profilePhotoName: this.props?.personnelData?.profilePhotoURL
        ? this.getFileNameFromUrl(this.props?.personnelData?.profilePhotoURL)
        : "",
      documentSizeCheckForProfileCheck: false,
      documentTypeCheckForProfileImage: false,
      profileImageDocumentNameValidation: false,
      signatureImgUrl: this.props?.personnelData?.signatureUrl || "",
      signatureImgName: this.props?.personnelData?.signatureUrl
        ? this.getFileNameFromUrl(this.props?.personnelData?.signatureUrl)
        : "",
      documentTypeCheckForSignature: false,
      documentSizeCheckForSignature: false,
      mandateDetails: JSON.parse(localStorage.getItem("mandateDetails")),
    };
  }

  submitHandler(e) {
    e.preventDefault();
  }
  titleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
  goto(url) {
    var e = document.getElementById(url);
    e.scrollIntoView(true);
  }
  replaceAll(str, find, replace) {
    var escapedFind = find.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    return str.replace(new RegExp(escapedFind, "g"), replace);
  }
  getFileNameFromUrl(url) {
    if (!url) return "";
    const cleanUrl = url.split("?")[0];
    const fileName = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);
    return decodeURIComponent(fileName);
  }
  getMandateName = () => {
    var PersonnelData;
    if (
      ["", null, undefined, "null", "undefined"].includes(
        localStorage.getItem("PersonnelData"),
      )
    ) {
      PersonnelData = this.props.personnelData;
    } else {
      PersonnelData = JSON.parse(localStorage.getItem("PersonnelData"));
    }

    let dataValidate = {
      companyName:
        PersonnelData?.responseObject?.companyName ||
        PersonnelData?.companyName,
      otherCompanyName:
        PersonnelData?.responseObject?.mandateId || PersonnelData?.mandateId,
    };
    RegionManagementService.checkMandateDetails(dataValidate, (otherRes) => {
      if (otherRes.status === "success") {
        this.setState({
          preferredMandateName:
            otherRes?.responseObject?.mandateEntity[0].mandateName,
        });
      } else {
        warning(otherRes.reasonText, warningNotification);
        this.setState({ preferredMandateName: "" });
      }
    });
    if (
      (PersonnelData?.responseObject?.executionTracker &&
        PersonnelData?.responseObject?.executionTracker.length > 0) ||
      (PersonnelData?.executionTracker &&
        PersonnelData?.executionTracker.length > 0)
    ) {
      let stateId = PersonnelData?.responseObject?.executionTracker[0]
        ?.additionalDetails?.stateId
        ? PersonnelData?.responseObject?.executionTracker[0]?.additionalDetails
            ?.stateId
        : PersonnelData?.executionTracker[0]?.additionalDetails?.stateId
          ? PersonnelData?.executionTracker[0]?.additionalDetails?.stateId
          : "";
      if (!["", null, undefined].includes(stateId)) {
        RegionManagementService.getCenter("stateId=" + stateId, (res) => {
          if (res.status === "success") {
            this.setState({ preferredExamCenterList: res.responseListObject });
          } else {
            warning(res.reasonText, warningNotification);
          }
        });
      }
    }
  };
  componentDidMount() {
    this.getMandateName();
    window.$("#Hdfc-Mandate").modal("hide");
    setTimeout(() => {
      RegionManagementService.getCompanyList((res) => {
        let company = [];
        for (let i = 0; i < res.responseListObject.length; i++) {
          let obj = {};
          obj["value"] = res.responseListObject[i].companyId;
          obj["label"] = res.responseListObject[i].companyName;
          company.push(obj);
        }
        this.setState({
          companyList: res.responseListObject,
        });
      });

      var year = new Date().getFullYear();
      year = year - 18;
      var listOfYear = [];
      for (var i = 0; i < 100; i++) {
        var current = year - i;
        listOfYear.push(current);
      }

      var yearcerti = new Date().getFullYear();
      yearcerti = 2010;
      var listOfCertificateYear = [];
      for (var i = 0; i < 100; i++) {
        var current = yearcerti + i;
        listOfCertificateYear.push(current);
      }

      var year1 = new Date().getFullYear();
      year1 = year1;
      var listOfYear2 = [];
      for (var i = 0; i < 100; i++) {
        var current1 = year1 - i;
        listOfYear2.push(current1);
      }
      var listOfMonth = [];

      var listOfMonth = [
        { key: 1, value: "Jan" },
        { key: 2, value: "Feb" },
        { key: 3, value: "Mar" },
        { key: 4, value: "Apr" },
        { key: 5, value: "May" },
        { key: 6, value: "Jun" },
        { key: 7, value: "Jul" },
        { key: 8, value: "Aug" },
        { key: 9, value: "Sep" },
        { key: 10, value: "Oct" },
        { key: 11, value: "Nov" },
        { key: 12, value: "Dec" },
      ];

      var listOfDay = [];
      for (var i = 1; i <= 31; i++) {
        listOfDay.push(i);
      }
      this.setState({ listOfMonth: listOfMonth });
      this.setState({ listOfYear1: listOfYear });
      this.setState({ listOfDay: listOfDay });
      this.setState({ listOfYear2: listOfYear2 });
      this.setState({ certificateYear: listOfCertificateYear });
      this.setState({ loading1: "block" });
      this.setState({ loading: true });
      window.addEventListener("scroll", (e) => onScroll(e), true);

      LookUpService.getOccuption("codeTypeId=101&sortOrder=ASC", (res) => {
        this.setState({
          whoareu: res.responseListObject,
        });
        this.setState({ loading: false });
        this.setState({ loading1: "none" });
      });

      LookUpService.getWhoareu("codeTypeId=102&sortOrder=ASC", (res) => {
        this.setState({
          occupation: res.responseListObject,
        });
        this.setState({ loading: false });
        this.setState({ loading1: "none" });
      });

      LookUpService.getWhoareu("codeTypeId=105&sortOrder=ASC", (res) => {
        this.setState({
          AuualCome: res.responseListObject,
        });
        this.setState({ loading: false });
        this.setState({ loading1: "none" });
      });

      LookUpService.getWhoareu("codeTypeId=106&sortOrder=ASC", (res) => {
        this.setState({
          AddressProof: res.responseListObject,
        });
        this.setState({ loading: false });
        this.setState({ loading1: "none" });
      });
      LookUpService.getLookingFor("codeTypeId=107&sortOrder=ASC", (res) => {
        this.setState({
          currentProfession: res.responseListObject,
        });
        this.setState({ loading: false });
        this.setState({ loading1: "none" });
      });
      getExperienceList((res) => {
        if (res.status === "success") {
          this.setState({ getExperienceList: res.responseListObject });
        } else {
          error(res.reasonText, errorNotification);
        }
      });
      function onScroll(event) {
        if ($("section#create-user").offset() !== undefined) {
          var scrollPos = $("section#create-user").offset().top;
          $("section.page-section").each(function () {
            var scrollid = $(this).attr("id");
            var scrollPos = $("section#" + scrollid).offset().top;
            if (scrollPos > 100 && scrollPos < 300) {
              $("#topheader .tab li").removeClass("active");
              $("a[href='#" + [scrollid] + "']")
                .parent("li")
                .addClass("active");
            }
          });
        }
      }

      //qulification year dropdown bind start  here
      var year = new Date().getFullYear();

      var listOfYear = [];
      for (var i = 0; i < 100; i++) {
        var current = year - i;
        listOfYear.push(current);
        this.setState({ listOfYear: listOfYear });
      }
      //qulification year dropdown bind ends  here

      RegionManagementService.getCountry((res) => {
        this.setState({
          countryList: res.responseListObject,
        });
        RegionManagementService.getState("countryId=1", (res) => {
          this.setState({
            stateListForCor: res.responseListObject,
            preferredExamLocationList: res.responseListObject,
          });
          this.setState({ loading: false });
          this.setState({ loading1: "none" });
        });
        RegionManagementService.getState("countryId=1", (res) => {
          this.setState({
            stateListForPer: res.responseListObject,
            stateListForOffice: res.responseListObject,
          });
          this.setState({ loading: false });
          this.setState({ loading1: "none" });
        });
        RegionManagementService.getCity(
          "stateId=" + this.state.perstateId,
          (res) => {
            this.setState({
              cityListForPer: res.responseListObject,
            });
            this.setState({ loading: false });
            this.setState({ loading1: "none" });
          },
        );
        RegionManagementService.getCity(
          "stateId=" + this.state.officestateId,
          (res) => {
            this.setState({
              cityListForOffice: res.responseListObject,
            });
          },
        );
      });
      RegisterUserService.getEmployeType((res) => {
        this.setState({
          employeTypeForParents: res.responseListObject,
        });
        this.setState({ loading: false });
        this.setState({ loading1: "none" });
      });
      fetchProcessType(
        "learnerPartyID=" + localStorage.getItem("userid-Token"),
        (res) => {
          if (res.status === "success") {
            this.setState({
              processType: res.responseObject.lookingFor,
              newLearnerDetails: res.responseObject,
            });
            this.setState({ loading: false });
            this.setState({ loading1: "none" });
          }
        },
      );

      getAMCMaster((res) => {
        this.setState({
          nameOfMutual: res.responseListObject,
        });
        this.setState({ loading: false });
        this.setState({ loading1: "none" });
      });

      RegionManagementService.getLearnerCompany(
        "learnerID=" + this.props.personnelData.learnerID,
        (companyresponse) => {
          this.setState({
            orgCompanyName: companyresponse.responseObject.companyName,
          });
          if (
            this.state.orgCompanyName === "Other" ||
            this.state.orgCompanyName == "OTHER" ||
            this.state.orgCompanyName === "other"
          ) {
            this.props.personnelData.arn = "";
          } else {
            this.props.personnelData.arn = this.props.personnelData.arn;
          }
        },
      );

      RegionManagementService.learnerMandateDetails(
        "learnerID=" +
          this.props.personnelData.learnerID +
          "&learnerPartyID=" +
          this.props.personnelData.learnerPartyID +
          "&mandateUserId=" +
          "&learnerMandateId=",
        (resM) => {
          let mandateId = "";
          let mandateUserId = "";
          let assignedUserMandateName = "";
          if (resM.status === "success") {
            for (let i = 0; i < resM.responseListObject.length; i++) {
              mandateUserId = resM.responseListObject[i].mandateUserId;
              mandateId = resM.responseListObject[i].mandateId;
            }
            this.setState({ mandateId: mandateId });
            this.setState({ mandateUserId: mandateUserId });
            if (
              mandateId !== "" ||
              mandateId !== null ||
              mandateId !== undefined
            ) {
              RegionManagementService.getUserMandateById(
                "mandateId=" + mandateId,
                (mandateres) => {
                  if (mandateres.status === "success") {
                    assignedUserMandateName =
                      mandateres.responseObject.mandateName;
                    this.setState({
                      assignedUserMandateName: assignedUserMandateName,
                    });
                  }
                },
              );
            }
          }
        },
      );

      RegionManagementService.getUserId(
        "searchText=" + this.props.personnelData.emailID,
        (userResponse) => {
          let userId = "";
          for (let i = 0; i < userResponse.responseListObject.length; i++) {
            userId = userResponse.responseListObject[i].userId;
          }
          this.setState({ userId: userId.toString() });
          if (
            this.props.personnelData.learnerEuinOption ===
              "EUIN Renewal and mapping" ||
            this.props.personnelData.learnerEuinOption === "Only Mapping"
          ) {
            window.$("#opt12").modal("hide");
          }
        },
      );
    }, 100);
  }

  onChangeParameter(selected, setFieldValue) {
    setFieldValue("companyId", selected.value);
    this.setState({ companyNameOther: selected.label });
  }

  getWords(monthCount) {
    function getPlural(number, word) {
      return (number === 1 && word.one) || word.other;
    }

    var months = { one: "month", other: "months" },
      years = { one: "year", other: "years" },
      m = monthCount % 12,
      y = Math.floor(monthCount / 12),
      result = [];
    m && result.push(m);
    return result;
  }
  diff_years(date, toDate) {
    date = date.split("-");
    toDate = toDate.split("-");
    var today = new Date(toDate[0], toDate[1], toDate[2]);
    var year = today.getFullYear();
    var month = today.getMonth();
    var day = today.getDate();
    var yy = parseInt(date[0]);
    var mm = parseInt(date[1]);
    var dd = parseInt(date[2]);
    var years, months, days;
    // months
    months = month - mm;
    if (day < dd) {
      months = months - 1;
    }
    // years
    years = year - yy;
    if (month * 100 + day < mm * 100 + dd) {
      years = years - 1;
      months = months + 12;
    }
    // days
    days = Math.floor(
      (today.getTime() - new Date(yy + years, mm + months - 1, dd).getTime()) /
        (24 * 60 * 60 * 1000),
    );
    return years + "." + months;
  }
  diff_months(dt2, dt1) {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60 * 60 * 24 * 7 * 4;
    return Math.abs(Math.round(diff));
  }

  checkName(name) {
    name = name.split(".");
    var regexp1 = new RegExp("^[0-9A-Za-z- ]+$");
    //    var url = "http://www.website.com/page.php?data=" + document.getElementById("url").value;
    if (!regexp1.test(name[0])) {
      return false;
    } else {
      return true;
    }
  }
  removeByAttr = (arr, attr, value) => {
    var i = arr.length;
    while (i--) {
      if (arr[i] && arr[i][attr] === value) {
        arr.splice(i, 1);
      }
    }
  };
  WhyTheFillForm = () => {
    window.$("#roadmap1").modal("show");
  };

  onWhyTheFillFormCloseModal = () => {
    this.setState({ linkModalloading: false, showWhyTheFillForm: false });
  };

  isValidDate = (fromDate, toDate) => {
    if (fromDate !== "") {
      let fromDate1 = fromDate.split("-");
      if (fromDate1[1] == 2 && fromDate1[2] > 29) {
        warning("Please select valid Date", warningNotification);
        return false;
      } else if (
        !(
          (fromDate1[0] % 4 == 0 && fromDate1[0] % 100 != 0) ||
          fromDate1[0] % 400 == 0
        ) &&
        fromDate1[1] == 2 &&
        fromDate1[2] > 28
      ) {
        warning("Please select valid Date", warningNotification);
        return;
      } else if (
        fromDate1[1] == 4 ||
        fromDate1[1] == 6 ||
        fromDate1[1] == 9 ||
        fromDate1[1] == 11
      ) {
        if (fromDate1[2] > 30) {
          warning("Please select valid Date", warningNotification);
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }

    if (toDate !== "") {
      let toDate1 = fromDate.split("-");
      if (toDate1[1] == 2 && toDate1[2] > 29) {
        warning("Please select valid Date", warningNotification);
        return false;
      } else if (
        !(
          (toDate1[0] % 4 == 0 && toDate1[0] % 100 != 0) ||
          toDate1[0] % 400 == 0
        ) &&
        toDate1[2] > 28
      ) {
        warning("Please select valid Date", warningNotification);
        return;
      } else if (
        toDate1[1] == 4 ||
        toDate1[1] == 6 ||
        toDate1[1] == 9 ||
        toDate1[1] == 11
      ) {
        if (toDate1[2] > 30) {
          warning("Please select valid Date", warningNotification);
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  };

  updateCommonWeightage = async (key, value, values, section) => {
    let DOB =
      values["day"] +
      "/" +
      values["month"] +
      "/" +
      values["year"] +
      " " +
      "00:00:00";
    if (
      ["", null, undefined, NaN, "NaN"].includes(values["day"]) ||
      ["", null, undefined, NaN, "NaN"].includes(values["month"]) ||
      ["", null, undefined, NaN, "NaN"].includes(values["year"])
    ) {
      DOB = "";
    }
    let userProfileCompletedData = {
      empNo: values?.empNo,
      mobileNo: values?.mobileNo,
      emailID: values?.emailID,
      gender: values?.gender,
      salutation: values?.salutation,
      firstName: values?.firstName,
      middleName: values?.middleName,
      lastName: values?.lastName,
      fatherName: values?.fatherName,
      maritalStatus: values?.maritalStatus,
      secondaryEmailID: values?.secondaryEmailID,
      dob: DOB,
      panNumber: values?.panNumber,
      panCardURL: values?.panCardURL,
      officeStreet: values?.officeStreet,
      officeStreet2: values?.officeStreet2,
      officeStreet3: values?.officeStreet3,
      officecountryId: values?.officecountryId,
      officestateId: values?.officestateId,
      officecityId: values?.officecityId,
      officePostalCode: values?.officePostalCode,
      ARNNO: values?.ARNNO,
      orgCompanyName: this.props?.personnelData?.companyName,
      profilePhotoURL: values?.profilePhotoURL,
      signatureImgUrl: values?.signatureImgUrl,
    };
    if (values.preferredMandateName === "NISM") {
      userProfileCompletedData = {
        ...userProfileCompletedData,
        preferredExamLocation: values.preferredExamLocation,
        preferredExamCenter: values.preferredExamCenter,
      };
    }
    if ([11024, "11024"].includes(values.peraddressproof1)) {
      userProfileCompletedData = {
        ...userProfileCompletedData,
        maskedAadhaar: values.maskedAadhaar,
      };
    }
    let occupationValue1 = (values?.professionalQualification?.[0] || "")
      ?.occupation;
    let userProfileAddressData = {
      addressTypeMark: values?.addressTypeMark,
      perStreet: values?.perStreet,
      perStreet2: values?.perStreet2,
      perStreet3: values?.perStreet3,
      percountryId: values?.percountryId,
      perstateId: values?.perstateId,
      percityId: values?.percityId,
      perPostalCode: values?.perPostalCode,
      peraddressproof1: values?.peraddressproof1,
      addressProofURL: values?.addressProofCardURL,
    };
    let EducationalDetails = {
      learnerQualificationpassingYear: (values?.learnerQualification?.[0] || "")
        ?.passingYear,
      learnerQualificationqualificationType: (
        values?.learnerQualification?.[0] || ""
      )?.qualificationType,
      learnerQualificationinstituteName: (
        values?.learnerQualification?.[0] || ""
      )?.instituteName,
      learnerQualificationpercentage: (values?.learnerQualification?.[0] || "")
        ?.percentage,
    };
    let EmploymentDetails = {};
    let NISMandEnrollDetails = {};
    let EUINDetails = {};

    const occupationValue = (values?.professionalQualification?.[0] || "")
      ?.occupation;

    const isStudent = [1021, "1021"].includes(occupationValue) ? true : false;
    if (isStudent) {
      EmploymentDetails = {
        ...EmploymentDetails,
        professionalQualificationoccupation: (
          values?.professionalQualification?.[0] || ""
        )?.occupation,
      };
    } else {
      EmploymentDetails = {
        ...EmploymentDetails,
        professionalQualificationoccupation: (
          values?.professionalQualification?.[0] || ""
        )?.occupation,
        professionalQualificationcompanyName: (
          values?.professionalQualification?.[0] || ""
        )?.companyName,
        professionalQualificationdesignation: (
          values?.professionalQualification?.[0] || ""
        )?.designation,
        professionalQualificationtotalExperience: (
          values?.professionalQualification?.[0] || ""
        )?.totalExperience,
        professionalQualificationdateOfJoining: (
          values?.professionalQualification?.[0] || ""
        )?.dateOfJoining,
      };
    }

    var obj1 = userProfileCompletedData;
    var keys1 = await Object?.keys(obj1);
    var filtered1 = await keys1?.filter(function (key) {
      var value = obj1[key] || obj1.key;
      return (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0)
      );
    });
    var obj2 = userProfileAddressData;
    var keys2 = await Object?.keys(obj2);
    var filtered2 = await keys2?.filter(function (key) {
      var value = obj2[key] || obj2.key;
      return (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0)
      );
    });
    var obj3 = EducationalDetails;
    var keys3 = await Object?.keys(obj3);
    var filtered3 = await keys3?.filter(function (key) {
      var value = obj3[key] || obj3.key;
      return (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0)
      );
    });
    var obj4 = EmploymentDetails;
    var keys4 = await Object?.keys(obj4);
    var filtered4 = await keys4?.filter(function (key) {
      var value = obj4[key] || obj4.key;
      return (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0)
      );
    });
    var obj5 = NISMandEnrollDetails;
    var keys5 = await Object?.keys(obj5);
    var filtered5 = await keys5?.filter(function (key) {
      var value = obj5[key] || obj5.key;
      return (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0)
      );
    });
    var obj6 = EUINDetails;
    var keys6 = Object.keys(obj6);
    var filtered6 = keys6?.filter(function (key) {
      var value = obj6[key] || obj6.key;
      return (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0)
      );
    });
    let numer, denom;
    let personalN = (await filtered1) ? Object.keys(filtered1)?.length : 0;
    let addressN = (await filtered2) ? Object.keys(filtered2)?.length : 0;
    let educationN = (await filtered3) ? Object.keys(filtered3)?.length : 0;
    let employmentN = (await filtered4) ? Object.keys(filtered4)?.length : 0;
    let NISMandEnrollN = (await filtered5) ? Object.keys(filtered5)?.length : 0;
    let EUINDetailsN = (await filtered6) ? Object.keys(filtered6)?.length : 0;
    numer =
      personalN +
      addressN +
      educationN +
      employmentN +
      NISMandEnrollN +
      EUINDetailsN;

    let personalD = (await obj1)
      ? Object.keys(obj1)?.length
      : [11024, "11024"].includes(values.peraddressproof1)
        ? 28
        : 27;
    let addressD = (await obj2) ? Object.keys(obj2)?.length : 10;
    let educationD = (await obj3) ? Object.keys(obj3)?.length : 4;
    let employmentD = (await obj4)
      ? Object.keys(obj4)?.length
      : [1021, "1021"].includes(occupationValue1)
        ? 1
        : 5;
    let NISMandEnrollD = (await obj5) ? Object.keys(obj5)?.length : 0;
    let EUINDetailsD = obj6 ? Object.keys(obj6)?.length : 0;

    denom =
      personalD +
      addressD +
      educationD +
      employmentD +
      NISMandEnrollD +
      EUINDetailsD;
    let combinedper = Math.round((numer / denom) * 100);
    console.log(
      "vkd-this.props",
      this.props.personnelData,
      this.props.addressData,
    );
    console.log("vkd-personal", key, userProfileCompletedData, obj1, keys1);
    console.log("vkd-address", key, userProfileAddressData, obj2, keys2);
    console.log("vkd-eduction", key, EducationalDetails, obj3, keys3);
    console.log("vkd-employment", key, EmploymentDetails, obj4, keys4);
    console.log("vkd-nism", key, NISMandEnrollDetails, obj5, keys5);
    console.log("vkd euin", key, EUINDetails, obj6, keys6);
    console.log(
      "vkd-numerator",
      key,
      personalN,
      addressN,
      educationN,
      employmentN,
      NISMandEnrollN,
      EUINDetailsN,
      numer,
    );
    console.log(
      "vkd-denominator",
      key,
      personalD,
      addressD,
      educationD,
      employmentD,
      NISMandEnrollD,
      EUINDetailsD,
      denom,
    );
    console.log("vkd-percentage", key, combinedper);
    let profileComplitionPercent = ["", null, undefined, NaN, "NaN"]?.includes(
      combinedper,
    )
      ? 0
      : combinedper > 100
        ? 100
        : combinedper;

    await localStorage.setItem("ProfilePercent", profileComplitionPercent);

    await localStorage.setItem(
      "profilecomlitionvalue",
      profileComplitionPercent,
    );
  };

  handleClose = () => {
    window.$("#Hdfc-Mandate").modal("hide");
  };
  toIntOrEmpty = (v) => {
    const n = parseInt(v, 10);
    return isNaN(n) ? "" : n;
  };
  handleNormalizeOnBlur = (fieldName, setFieldValue, values) => (e) => {
    const normalized = e.target.value.trim().replace(/\s+/g, " ");
    this.setState({ [fieldName]: normalized || "" });
    setFieldValue(fieldName, normalized);
    this.updateCommonWeightage(fieldName, normalized, values);
  };
  render() {
    console.log("NISM User Profile Debug", {
      Props: this.props,
      State: this.state,
    });
    var roledata = this.props.userRoleAccess;
    const menuItems = [
      { label: "Profile Instructions", route: "distributor-profile" },
      { label: "Personal Details", route: "create-user" },
      { label: "Address Details", route: "create-address" },
      { label: "Office Address Details", route: "office-address" },
      { label: "Educational Details", route: "educational-details" },
      { label: "Professional Details", route: "create-qualification" },
      ![undefined, "NISM"].includes(this.state.assignedUserMandateName) && {
        label: "NISM Certificate Details",
        route: "NISMCertificate",
      },
      ![undefined, "NISM"].includes(this.state.assignedUserMandateName) && {
        label: "EUIN Details",
        route: "EUINDetails",
      },
      (this.state.preferredMandateName === "NISM" ||
        ["", null].includes(this.props?.personnelData?.learnerEuinOption)) && {
        label: "Preferred NISM Exam Location",
        route: "Preferred-NISM-Exam-Location",
      },
      { label: "ARN Details", route: "ARNDetails" },
      { label: "Profile Details", route: "create-profile" },
    ].filter(Boolean);
    const professionalQualification1 =
      this.props.personnelData.learnerProfessionalQualification;
    const professionalQualification2 = professionalQualification1.map(
      (item) => {
        return {
          ...item,
          designation: item?.designation?.slice(0, 50),
          companyName: item?.companyName?.slice(0, 250),
          dateOfJoining: ["1021", 1021].includes(item.occupation)
            ? ""
            : item.dateOfJoining
              ? (() => {
                  const [day, month, yearWithTime] =
                    item.dateOfJoining.split("/");
                  const year = yearWithTime.split(" ")[0];
                  return `${year}-${month}-${day}`;
                })()
              : null,
        };
      },
    );
    console.log("vkd professionalQualification2", professionalQualification2);

    return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          condition1:
            localStorage.getItem("roleId") == 6 ||
            localStorage.getItem("roleId") == 7,
          learnerPartyID: localStorage.getItem("userid-Token"),
          learnerID: this.props.personnelData.learnerID,
          stateListForOffice: this.state.stateListForOffice,
          cityListForOffice: this.state.cityListForOffice,
          learnerQualification: this.state?.learnerQualification,
          empNo: this.state.empNo,
          mobileNo: this.props.personnelData.mobileNo,
          emailID: this.props.personnelData.emailID,
          gender: this.state.gender,
          salutation: this.state.salutation,
          firstName: this.state.firstName,
          middleName: this.state.middleName,
          lastName: this.state.lastName,
          fatherName: this.state.fatherName,
          maritalStatus: this.state.maritalStatus,
          secondaryEmailID: this.state.secondaryEmailID,
          dob: this.state.dob,
          // year: this.state.dob.split("-")[0],
          // day: parseInt(this.state.dob.split("-")[2], 10),
          // month: parseInt(this.state.dob.split("-")[1], 10),
          year: this.state.year,
          day: this.toIntOrEmpty(this.state.day),
          month: this.toIntOrEmpty(this.state.month),
          panNumber: this.props.personnelData.panNumber,
          contactNo: this.props.personnelData.contactNo,
          aadharNumber: this.props.personnelData.aadharNumber,
          perAddressType: this.state.perAddressType,
          perAddressID: this.state.perAddressID,
          addressTypeMark: this.state.addressTypeMark,
          perStreet: this.state?.perStreet?.slice(0, 40),
          perStreet2: this.state?.perStreet2?.slice(0, 40),
          perStreet3: this.state?.perStreet3?.slice(0, 40),
          percountryId: this.state.percountryId || 1,
          perstateId: this.state.perstateId,
          percityId: this.state.percityId,
          perPostalCode: this.state.perPostalCode,
          peraddressproof1: this.state.peraddressproof1,
          maskedAadhaar: this.state.maskedAadhaar,
          officeStreet: this.state?.officeStreet?.slice(0, 40),
          officeStreet2: this.state?.officeStreet2?.slice(0, 40),
          officeStreet3: this.state?.officeStreet3?.slice(0, 40),
          officestateId: this.state.officestateId,
          officecountryId: this.state.officecountryId,
          officecityId: this.state.officecityId,
          officePostalCode: this.state.officePostalCode,
          isCertificate: this.props.personnelData.isCertificate,
          certificateNumber: this.state.certificateNumber,
          certificateValidUpto: this.state.certificateValidUpto,
          enrollmentNumber: this.state.enrollmentNumber,
          enrollmentDate: this.state.enrollmentDate,
          nismyear: this.state.certificateValidUpto
            ? this.state.certificateValidUpto.split("-")[0]
            : "",
          nismday: this.state.certificateValidUpto
            ? parseInt(this.state.certificateValidUpto.split("-")[2], 10)
            : "",
          nismmonth: this.state.certificateValidUpto
            ? parseInt(this.state.certificateValidUpto.split("-")[1], 10)
            : "",
          enrollmentyear: this.state.enrollmentDate
            ? this.state.enrollmentDate.split("-")[0]
            : "",
          enrollmentday: this.state.enrollmentDate
            ? parseInt(this.state.enrollmentDate.split("-")[2], 10)
            : "",
          enrollmentmonth: this.state.enrollmentDate
            ? parseInt(this.state.enrollmentDate.split("-")[1], 10)
            : "",
          selectedCompanyId: parseInt(this.props.personnelData.companyName),
          otherCompanyName: this.state.otherCompanyName,
          orgCompanyName: this.state.orgCompanyName,
          euinValidUpto: this.state.euinValidUpto,
          euinyear: this.state.euinValidUpto
            ? this.state.euinValidUpto.split("-")[0]
            : "",
          euinday: this.state.euinValidUpto
            ? parseInt(this.state.euinValidUpto.split("-")[2], 10)
            : "",
          euinmonth: this.state.euinValidUpto
            ? parseInt(this.state.euinValidUpto.split("-")[1], 10)
            : "",
          resumeDocumentURL: this.props.personnelData.resumeDocumentURL,
          resumeDocumentNameDuringEdit: this.props.personnelData
            .resumeDocumentURL
            ? (this.props.personnelData.resumeDocumentURL || "").substring(
                (this.props.personnelData.resumeDocumentURL || "").lastIndexOf(
                  "/",
                ) + 1,
                (this.props.personnelData.resumeDocumentURL || "").length,
              )
            : "",
          resumeDocumentNameDuringEditName: this.replaceAll(
            this.replaceAll(
              this.replaceAll(
                this.props.personnelData.resumeDocumentURL
                  ? this.props.personnelData.resumeDocumentURL
                      .split("?")[0]
                      .substring(
                        (
                          this.props.personnelData.resumeDocumentURL || ""
                        ).lastIndexOf("/") + 1,
                      )
                  : "",
                "%29",
                "",
              ),
              "%28",
              "",
            ),
            "%20",
            "",
          ),
          resumeVideoURL: this.props.personnelData.resumeVideoURL,
          chequePhotoURL: this.props.personnelData.chequePhotoURL,
          aadharCardURL: this.props.personnelData.aadharCardURL,
          BackaadharCardBackURL: this.props.personnelData.aadharCardBackURL,
          panCardURL: this.state?.panCardURL,
          panCardName: this.state?.panCardName,
          addressProofCardURL: this.state?.addressProofCardURL,
          addressProofName: this.state?.addressProofName,
          profilePhotoURL: this.state?.profilePhotoURL,
          profilePhotoName: this.state?.profilePhotoName,
          signatureImgUrl: this.state?.signatureImgUrl,
          signatureImgName: this.state?.signatureImgName,
          panpdfName: this.replaceAll(
            this.replaceAll(
              this.replaceAll(
                this.props.personnelData.panCardURL
                  ? this.props.personnelData.panCardURL
                      .split("?")[0]
                      .substring(
                        (this.props.personnelData.panCardURL || "").lastIndexOf(
                          "/",
                        ) + 1,
                      )
                  : "",
                "%29",
                "",
              ),
              "%28",
              "",
            ),
            "%20",
            "",
          ),
          addressProofName1: this.replaceAll(
            this.replaceAll(
              this.replaceAll(
                this.props.personnelData.proofOfAddressURL
                  ? this.props.personnelData.proofOfAddressURL
                      .split("?")[0]
                      .substring(
                        (
                          this.props.personnelData.proofOfAddressURL || ""
                        ).lastIndexOf("/") + 1,
                      )
                  : "",
                "%29",
                "",
              ),
              "%28",
              "",
            ),
            "%20",
            "",
          ),
          aadharpdfName: this.replaceAll(
            this.replaceAll(
              this.replaceAll(
                this.props.personnelData.aadharCardURL
                  ? this.props.personnelData.aadharCardURL
                      .split("?")[0]
                      .substring(
                        (
                          this.props.personnelData.aadharCardURL || ""
                        ).lastIndexOf("/") + 1,
                      )
                  : "",
                "%29",
                "",
              ),
              "%28",
              "",
            ),
            "%20",
            "",
          ),
          backaadharpdfName: this.replaceAll(
            this.replaceAll(
              this.replaceAll(
                this.props.personnelData.aadharCardBackURL
                  ? this.props.personnelData.aadharCardBackURL
                      .split("?")[0]
                      .substring(
                        (
                          this.props.personnelData.aadharCardBackURL || ""
                        ).lastIndexOf("/") + 1,
                      )
                  : "",
                "%29",
                "",
              ),
              "%28",
              "",
            ),
            "%20",
            "",
          ),
          aadharCardBackURL: this.props.personnelData.aadharCardBackURL,
          learnerFatherName: this.props.personnelData.learnerFatherName,
          learnerFatherDOB: this.state.learnerFatherDOB,
          learnerFatherEmployementType:
            this.props.personnelData.learnerFatherEmployementType,
          learnerFatherCompanyName:
            this.props.personnelData.learnerFatherCompanyName,
          learnerMotherName: this.props.personnelData.learnerMotherName,
          learnerMotherDOB: this.state.learnerMotherDOB,
          learnerMotherEmployementType:
            this.props.personnelData.learnerMotherEmployementType,
          learnerMotherCompanyName:
            this.props.personnelData.learnerMotherCompanyName,
          checkAddressFlag: this.state.checkAddressFlag,
          document: this.state.document,
          resumeDocumentName: "",
          panCardDocumentName: "",
          aadharCardDocumentName: "",
          documentSizeCheckForPanCard: this.state.documentSizeCheckForPanCard,
          documentTypeCheckForPANImage: this.state.documentTypeCheckForPANImage,
          documentNameValidation: this.state.documentNameValidation,
          documentTypeCheckForaddressProofCardURLImage:
            this.state.documentTypeCheckForaddressProofCardURLImage,
          documentSizeCheckForaddressProofCardURLCard:
            this.state.documentSizeCheckForaddressProofCardURLCard,
          AressProofDocumentNameValidation:
            this.state.AressProofDocumentNameValidation,
          documentSizeCheckForProfileCheck:
            this.state.documentSizeCheckForProfileCheck,
          documentTypeCheckForProfileImage:
            this.state.documentTypeCheckForProfileImage,
          profileImageDocumentNameValidation:
            this.state.profileImageDocumentNameValidation,
          documentTypeCheckForSignature:
            this.state.documentTypeCheckForSignature,
          documentSizeCheckForSignature:
            this.state.documentSizeCheckForSignature,
          documentSizeCheckForChequeCheck: false,
          documentTypeCheckForChequeImage: false,
          documentTypeCheckForResume: false,
          documentSizeCheckForResume: false,
          documentTypeCheckForAadharImage: false,
          documentSizeCheckForVideoCheck: false,
          documentSizeCheckForAadharCard: false,
          documentTypeCheckForVideo: false,
          countryList: this.state.countryList,
          stateListForPer: this.state.stateListForPer,
          cityListForPer: this.state.cityListForPer,
          addressFlag: this.state.addressFlag,
          downloadResumeAfterSelecting: "",
          whoareu: this.props.personnelData.learnerType,
          bankName: this.props.personnelData.bankName,
          branch: this.props.personnelData.branchName,
          branchAddress: this.props.personnelData.branchAddress,
          accountType: this.props.personnelData.accountType,
          acccountNumber: this.props.personnelData.accountNumber,
          ARNNO: this.props.personnelData.arn || this.props?.arnNo,
          NameOfARNHolder: this.props.personnelData.nameOfARNHolder,
          passportNumber: this.props.personnelData.passportNumber,
          applicantSpouseFather: this.props.personnelData.applicantSpouseFather,
          // professionalQualification: professionalQualification2,
          professionalQualification: this.state.professionalQualification2,
          ARNuserFeilds: this.props.personnelData.nameOfMutualFundEmpanelled,
          CPEDetails: this.props.personnelData.learnerCpeDetails,
          ifscCode: this.props.personnelData.ifscCode,
          submitStatus: "",
          profileCompletion: "26",
          edudocument: [],
          PanValidation: false,
          euinNumber: this.props.personnelData.euinNumber,
          applicationStatus: this.props.personnelData.applicationStatus,
          currentProfession: this.props.personnelData.learnerProfession,
          sameasAboveCount: 0,
          disabledForCielops:
            localStorage.getItem("roleId") == 6 ||
            localStorage.getItem("roleId") == 7
              ? true
              : false,
          currProfessionList:
            this.props.personnelData.learnerType == "1013" ||
            this.props.personnelData.learnerType == "1015"
              ? currProf
              : [],
          disablecurreProf:
            this.props.personnelData.learnerType == "1013" ||
            this.props.personnelData.learnerType == "1015"
              ? false
              : true,
          nameOfCurrProf:
            this.props.personnelData.learnerType == "1015"
              ? "Last Profession"
              : "Current Profession",
          disabledprofDetails: false,
          listOfMonth: this.state.listOfMonth,
          listOfDay: this.state.listOfDay,
          tolistOfDay: this.state.listOfDay,
          tolistOfMonth: this.state.listOfMonth,
          fromlistOfDay: this.state.listOfDay,
          fromlistOfMonth: this.state.listOfMonth,
          preferredExamLocation: this.state.preferredExamLocation,
          preferredExamLocationState: this.state.preferredExamLocationState,
          preferredExamCenter: this.state.preferredExamCenter,
          preferredExamLocationList: this.state.preferredExamLocationList,
          preferredExamCenterList: this.state.preferredExamCenterList || [],
          preferredMandateName: this.state.preferredMandateName,
          learnerEuinOption:
            this.props?.learnerEuinOption ||
            localStorage.getItem("learnerEuinOption1"),
        }}
        validationSchema={() =>
          Yup.lazy((values) => {
            const isCPF = values.submitStatus === "SUBMITTED";
            return isCPF
              ? Yup.object().shape({
                  whoareu: Yup.string().required(
                    "You must select a who are you field",
                  ),
                  empNo: Yup.string().required(
                    "You must specify a Employee Number",
                  ),
                  mobileNo: Yup.string()
                    .required("You must specify a Mobile Number")
                    .matches(
                      /^[6-9]\d{9}$/,
                      "Please enter the valid mobile number",
                    ),
                  emailID: Yup.string()
                    .required("You must specify a Email ID")
                    .email("Please enter the valid email ID"),
                  gender: Yup.string().required("You must specify a Gender"),
                  salutation: Yup.string(),
                  firstName: Yup.string()
                    .required("You must specify a First Name")
                    .max(70, "First Name not more than 70 characters")
                    .matches(
                      /^\S([a-zA-Z .']{1,70})?$/,
                      "Characters, dot(.), and apostrophe are allowed.",
                    ),
                  middleName: Yup.string().matches(
                    /^\S([a-zA-Z .']{1,50})?$/,
                    "Characters, dot(.), and apostrophe are allowed.",
                  ),
                  lastName: Yup.string()
                    .required("You must specify a Last Name")
                    .matches(
                      /^\S([a-zA-Z .']{1,50})?$/,
                      "Characters, dot(.), and apostrophe are allowed.",
                    ),
                  fatherName: Yup.string()
                    .required("You must specify a Father's Name")
                    .matches(
                      /^\S([a-zA-Z .']{1,50})?$/,
                      "Characters, dot(.), and apostrophe are allowed.",
                    ),
                  maritalStatus: Yup.string().required(
                    "You must specify Marital Status",
                  ),
                  secondaryEmailID: Yup.string().when("condition1", {
                    is: (condition1) => (condition1 ? true : false),
                    then: Yup.string(),
                    otherwise: Yup.string()
                      .required("You must specify Official Email ID")
                      .email("Please enter the valid official email ID"),
                  }),
                  day: Yup.string().required("You must specify Day"),
                  month: Yup.string().required("You must specify Month"),
                  year: Yup.string().required("You must specify Year"),
                  panNumber: Yup.string()
                    .required("You must specify a Pan Number")
                    .matches(
                      /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
                      "Please enter the valid PAN number with capital letters",
                    ),
                  aadharNumber: Yup.string()
                    .required("You must specify a Aadhaar number")
                    .matches(
                      /^\d{12}$/,
                      "Please enter the valid Aadhaar number",
                    ),
                  perStreet: Yup.string()
                    .required("You must specify a Current House Number")
                    .max(40, "Current House Number not more than 40 characters")
                    .matches(
                      /^\S([a-zA-Z0-9 ,.-]{1,40})?$/,
                      "Characters, Number, comma(,), dot(.), hypen(-) and space are allowed.",
                    ),
                  perStreet2: Yup.string()
                    .matches(
                      /^\S([a-zA-Z0-9 ,.-]{1,40})?$/,
                      "Characters, Number, comma(,), dot(.), hypen(-) and space are allowed.",
                    )
                    .max(40, "Current Street not more than 40 characters"),
                  perStreet3: Yup.string()
                    .matches(
                      /^\S([a-zA-Z0-9 ,.-]{1,40})?$/,
                      "Characters, Number, comma(,), dot(.), hypen(-) and space are allowed.",
                    )
                    .max(40, "Current Town not more than 40 characters"),
                  percountryId: Yup.string().required(
                    "You must specify a Country",
                  ),
                  perstateId: Yup.string().required("You must specify a State"),
                  percityId: Yup.string().required("You must specify a City"),
                  perPostalCode: Yup.string()
                    .required("You must specify a PIN Code")
                    .matches(/^[0-9]\d{5}$/, "Please enter the valid PIN code"),
                  peraddressproof1: Yup.string().required(
                    "You must specify a address proof",
                  ),
                  officeStreet: Yup.string()
                    .required("You must specify Address 1")
                    .max(40, "Address 1 not more than 40 characters")
                    .matches(
                      /^[A-Za-z0-9@#():,'".\[\]-][A-Za-z0-9@#():,'".\[\] -]{0,39}$/,
                      "Please enter valid Address 1",
                    ),
                  officeStreet2: Yup.string()
                    .required("You must specify Address 2")
                    .max(40, "Address 2 not more than 40 characters")
                    .matches(
                      /^[A-Za-z0-9@#():,'".\[\]-][A-Za-z0-9@#():,'".\[\] -]{0,39}$/,
                      "Please enter valid Address 2",
                    ),
                  officeStreet3: Yup.string()
                    .required("You must specify Address 3")
                    .max(40, "Address 3 not more than 40 characters")
                    .matches(
                      /^[A-Za-z0-9@#():,'".\[\]-][A-Za-z0-9@#():,'".\[\] -]{0,39}$/,
                      "Please enter valid Address 3",
                    ),
                  officecountryId: Yup.string().required(
                    "You must specify Country",
                  ),
                  officestateId: Yup.string().required(
                    "You must specify State",
                  ),
                  officecityId: Yup.string().required("You must specify City"),
                  officePostalCode: Yup.string()
                    .required("You must specify PIN Code")
                    .matches(/^[0-9]\d{5}$/, "Please enter valid PIN Code"),
                  euinNumber: Yup.string().matches(
                    /^[a-zA-Z0-9-]{4,20}$/,
                    "Please enter the valid EUIN Number",
                  ),
                  preferredExamLocation: Yup.string().when(
                    "preferredMandateName",
                    {
                      is: (preferredMandateName) =>
                        preferredMandateName === "NISM" ? true : false,
                      then: Yup.string().required(
                        "You must specify a Preferred Exam Location",
                      ),
                      otherwise: Yup.string(),
                    },
                  ),
                  preferredExamCenter: Yup.string().when(
                    "preferredMandateName",
                    {
                      is: (preferredMandateName) =>
                        preferredMandateName === "NISM" ? true : false,
                      then: Yup.string().required(
                        "You must specify a Preferred Exam Center",
                      ),
                      otherwise: Yup.string(),
                    },
                  ),
                  certificateNumber: Yup.string().matches(
                    /^[a-zA-Z0-9-]{4,20}$/,
                    "Please enter the valid NISM Registration Number",
                  ),
                  enrollmentNumber: Yup.string().matches(
                    /^[a-zA-Z0-9-]{4,20}$/,
                    "Please enter valid enrollment Number",
                  ),
                  ARNNO: Yup.string().matches(
                    /^[a-zA-Z0-9-]{4,20}$/,
                    "Please enter the valid ARN Number",
                  ),
                  NameOfARNHolder: Yup.string().matches(
                    /^[a-zA-Z ]{1,15}$/,
                    TextValidationMesg,
                  ),
                })
              : Yup.object().shape({
                  empNo: Yup.string().required(
                    "You must specify a Employee Number",
                  ),
                  emailID: Yup.string().email(
                    "Please enter the valid email ID",
                  ),
                  mobileNo: Yup.string().matches(
                    /^[6-9]\d{9}$/,
                    "Please enter the valid mobile number",
                  ),
                  gender: Yup.string(),
                  firstName: Yup.string()
                    .matches(
                      /^\S([a-zA-Z .']{1,70})?$/,
                      "Characters, dot(.), and apostrophe are allowed.",
                    )
                    .max(70, "First Name not more than 70 characters"),
                  middleName: Yup.string().matches(
                    /^\S([a-zA-Z .']{1,50})?$/,
                    "Characters, dot(.), and apostrophe are allowed.",
                  ),
                  lastName: Yup.string().matches(
                    /^\S([a-zA-Z .']{1,50})?$/,
                    "Characters, dot(.), and apostrophe are allowed.",
                  ),
                  fatherName: Yup.string().matches(
                    /^\S([a-zA-Z .']{1,50})?$/,
                    "Characters, dot(.), and apostrophe are allowed.",
                  ),
                  maritalStatus: Yup.string(),
                  secondaryEmailID: Yup.string().email(
                    "Please enter the valid official email ID",
                  ),
                  day: Yup.string().required("You must specify Day"),
                  month: Yup.string().required("You must specify Month"),
                  year: Yup.string().required("You must specify Year"),
                  panNumber: Yup.string().matches(
                    /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
                    "Please enter the valid PAN number with capital letters",
                  ),
                  professionalQualification: Yup.array().of(
                    Yup.object().shape({
                      occupation: Yup.string(),
                      companyName: Yup.string().matches(
                        /^[a-zA-Z ]{1,250}$/,
                        TextValidationMesg,
                      ),
                    }),
                  ),
                  aadharNumber: Yup.string().matches(
                    /^\d{12}$/,
                    "Please enter the valid Aadhaar number",
                  ),
                  corPostalCode: Yup.string().matches(
                    /^[0-9]\d{5}$/,
                    "Please enter the valid PIN code",
                  ),
                  perStreet: Yup.string()
                    .max(40, "Current House Number not more than 40 characters")
                    .matches(
                      /^\S([a-zA-Z0-9 ,.-]{1,40})?$/,
                      "Characters, Number, comma(,), dot(.), hypen(-) and space are allowed.",
                    ),
                  perStreet2: Yup.string()
                    .matches(
                      /^\S([a-zA-Z0-9 ,.-]{1,40})?$/,
                      "Characters, Number, comma(,), dot(.), hypen(-) and space are allowed.",
                    )
                    .max(40, "Current Street not more than 40 characters"),
                  perStreet3: Yup.string()
                    .matches(
                      /^\S([a-zA-Z0-9 ,.-]{1,40})?$/,
                      "Characters, Number, comma(,), dot(.), hypen(-) and space are allowed.",
                    )
                    .max(40, "Current Town not more than 40 characters"),
                  perPostalCode: Yup.string().matches(
                    /^[0-9]\d{5}$/,
                    "Please enter the valid PIN code",
                  ),
                  officeStreet: Yup.string()
                    .max(40, "Address 1 not more than 40 characters")
                    .matches(
                      /^[A-Za-z0-9@#():,'".\[\]-][A-Za-z0-9@#():,'".\[\] -]{0,39}$/,
                      "Please enter valid Address 1",
                    ),
                  officeStreet2: Yup.string()
                    .max(40, "Address 2 not more than 40 characters")
                    .matches(
                      /^[A-Za-z0-9@#():,'".\[\]-][A-Za-z0-9@#():,'".\[\] -]{0,39}$/,
                      "Please enter valid Address 2",
                    ),
                  officeStreet3: Yup.string()
                    .max(40, "Address 3 not more than 40 characters")
                    .matches(
                      /^[A-Za-z0-9@#():,'".\[\]-][A-Za-z0-9@#():,'".\[\] -]{0,39}$/,
                      "Please enter valid Address 3",
                    ),
                  officePostalCode: Yup.string().matches(
                    /^[0-9]\d{5}$/,
                    "Please enter valid PIN Code",
                  ),
                  euinNumber: Yup.string().matches(
                    /^[a-zA-Z0-9-]{4,20}$/,
                    "Please enter the valid EUIN Number",
                  ),
                  certificateNumber: Yup.string().matches(
                    /^[a-zA-Z0-9-]{4,20}$/,
                    "Please enter the valid NISM Registration Number",
                  ),
                  enrollmentNumber: Yup.string().matches(
                    /^[a-zA-Z0-9-]{4,20}$/,
                    "Please enter valid enrollment Number",
                  ),
                  ARNNO: Yup.string().matches(
                    /^[a-zA-Z0-9-]{4,20}$/,
                    "Please enter the valid ARN Number",
                  ),
                  NameOfARNHolder: Yup.string().matches(
                    /^[a-zA-Z ]{1,15}$/,
                    TextValidationMesg,
                  ),
                });
          })
        }
        onSubmit={async (values) => {
          window.$("#Hdfc-Mandate").modal("hide");
          let NISMDATE = "";
          let EUINDATE = "";
          let ENROLLMENTDATE = "";
          let arncount = 0;
          let nismcount = 0;
          let enrollcount = 0;
          let euincount = 0;
          let nismDateMessage = "";
          let enrollmentDateMessage = "";
          let euinDateMessage = "";
          let nismCertificateDateMessage = "";
          let enrollmentNumberDateMessage = "";
          let euinCertificateDateMessage = "";
          let empNoMessage = "";
          let DOB =
            values["day"] +
            "/" +
            values["month"] +
            "/" +
            values["year"] +
            " " +
            "00:00:00";
          if (
            ["", null, undefined, NaN, "NaN"].includes(values["day"]) ||
            ["", null, undefined, NaN, "NaN"].includes(values["month"]) ||
            ["", null, undefined, NaN, "NaN"].includes(values["year"])
          ) {
            DOB = "";
          }
          console.log("dateofb", DOB);
          if (
            isNaN(parseInt(values["nismday"])) ||
            isNaN(parseInt(values["nismmonth"])) ||
            isNaN(parseInt(values["nismyear"]))
          ) {
            NISMDATE = "";
          } else {
            var today = new Date();

            let nismDate2 =
              values["nismyear"] +
              "-" +
              values["nismmonth"] +
              "-" +
              values["nismday"];
            let mydate = new Date(nismDate2);

            var diff = mydate.getTime() - today.getTime();

            var daydiff = diff / (1000 * 60 * 60 * 24);

            if (daydiff > 1461) {
              nismDateMessage =
                "NISM Certificate expiry date entered is incorrect.  Please enter valid NISM certificate expiry date.";
            } else {
              NISMDATE =
                values["nismday"] +
                "/" +
                values["nismmonth"] +
                "/" +
                values["nismyear"] +
                " " +
                "00:00:00";
            }
          }
          if (
            isNaN(parseInt(values["nismday"])) ||
            isNaN(parseInt(values["nismmonth"])) ||
            isNaN(parseInt(values["nismyear"]))
          ) {
            NISMDATE = "";
          } else {
            var today = new Date();

            let nismDate2 =
              values["nismyear"] +
              "-" +
              values["nismmonth"] +
              "-" +
              values["nismday"];
            let mydate = new Date(nismDate2);

            var diff = mydate.getTime() - today.getTime();

            var daydiff = diff / (1000 * 60 * 60 * 24);

            if (daydiff > 1461) {
              nismDateMessage =
                "NISM Certificate expiry date entered is incorrect.  Please enter valid NISM certificate expiry date.";
            } else {
              NISMDATE =
                values["nismday"] +
                "/" +
                values["nismmonth"] +
                "/" +
                values["nismyear"] +
                " " +
                "00:00:00";
            }
          }
          if (
            isNaN(parseInt(values["enrollmentday"])) ||
            isNaN(parseInt(values["enrollmentmonth"])) ||
            isNaN(parseInt(values["enrollmentyear"]))
          ) {
            ENROLLMENTDATE = "";
          } else {
            var today = new Date();

            let enrollDate2 =
              values["enrollmentyear"] +
              "-" +
              values["enrollmentmonth"] +
              "-" +
              values["enrollmentday"];
            let mydate = new Date(enrollDate2);

            var diff = mydate.getTime() - today.getTime();

            var daydiff = diff / (1000 * 60 * 60 * 24);

            ENROLLMENTDATE =
              values["enrollmentday"] +
              "/" +
              values["enrollmentmonth"] +
              "/" +
              values["enrollmentyear"] +
              " " +
              "00:00:00";
          }
          if (
            isNaN(parseInt(values["enrollmentday"])) ||
            isNaN(parseInt(values["enrollmentmonth"])) ||
            isNaN(parseInt(values["enrollmentyear"]))
          ) {
            ENROLLMENTDATE = "";
          } else {
            var today = new Date();

            let enrollDate2 =
              values["enrollmentyear"] +
              "-" +
              values["enrollmentmonth"] +
              "-" +
              values["enrollmentday"];
            let mydate = new Date(enrollDate2);

            var diff = mydate.getTime() - today.getTime();

            var daydiff = diff / (1000 * 60 * 60 * 24);

            ENROLLMENTDATE =
              values["enrollmentday"] +
              "/" +
              values["enrollmentmonth"] +
              "/" +
              values["enrollmentyear"] +
              " " +
              "00:00:00";
          }
          if (
            isNaN(parseInt(values["euinday"])) ||
            isNaN(parseInt(values["euinmonth"])) ||
            isNaN(parseInt(values["euinyear"]))
          ) {
            EUINDATE = "";
          } else {
            var today = new Date();
            let euinDate2 =
              values["euinyear"] +
              "-" +
              values["euinmonth"] +
              "-" +
              values["euinday"];
            let mydate = new Date(euinDate2);

            var diff = mydate.getTime() - today.getTime();

            var daydiff = diff / (1000 * 60 * 60 * 24);

            EUINDATE =
              values["euinday"] +
              "/" +
              values["euinmonth"] +
              "/" +
              values["euinyear"] +
              " " +
              "00:00:00";
          }

          if (values.euinNumber !== "" && values.euinNumber != undefined) {
            euincount = (values.euinNumber.match(/-/g) || []).length;
          }
          if (
            values.certificateNumber !== "" &&
            values.certificateNumber != undefined
          ) {
            nismcount = (values.certificateNumber.match(/-/g) || []).length;
          }
          if (
            values.enrollmentNumber !== "" &&
            values.enrollmentNumber != undefined
          ) {
            enrollcount = (values.enrollmentNumber.match(/-/g) || []).length;
          }
          if (values.ARNNO !== "" && values.ARNNO != undefined) {
            arncount = (values.ARNNO.match(/-/g) || []).length;
          }

          if (
            values.certificateNumber !== "" &&
            values.certificateNumber !== undefined
          ) {
            if (NISMDATE === "") {
              nismCertificateDateMessage =
                "If you entered a NISM Certificate Number, you must also submit a NISM Validity Date, and vice versa.";
            }
          }

          if (NISMDATE !== "") {
            if (
              values.certificateNumber === "" ||
              values.certificateNumber === undefined
            ) {
              nismCertificateDateMessage =
                "If you entered a NISM Certificate Validity Date, you must also submit a NISM Certificate Number, and vice versa.";
            }
          }

          if (
            values.enrollmentNumber !== "" &&
            values.enrollmentNumber !== undefined
          ) {
            if (ENROLLMENTDATE === "") {
              enrollmentNumberDateMessage =
                "If you entered a Enrollment Number, you must also submit a Enrollment Date, and vice versa.";
            }
          }

          if (ENROLLMENTDATE !== "") {
            if (
              values.enrollmentNumber === "" ||
              values.enrollmentNumber === undefined
            ) {
              enrollmentNumberDateMessage =
                "If you entered a Enrollment Date, you must also submit a Enrollment Number, and vice versa.";
            }
          }

          if (
            this.state.isMandateUser === 1 &&
            (values.empNo === "" || values.empNo === undefined)
          ) {
            empNoMessage = "Please provide Employee No.";
          }

          let DOB1 =
            values["year"] + "-" + values["month"] + "-" + values["day"];
          let fromDate1 = "";
          if (
            values["year"] === undefined ||
            values["year"] === "" ||
            values["month"] === undefined ||
            values["month"] === "" ||
            values["day"] === undefined ||
            values["day"] === ""
          ) {
            warning("Please select Birth Date.", warningNotification);
          } else if (nismcount > 4) {
            error(
              "Please provide valid NISM Registration Date",
              errorNotification,
            );
          } else if (enrollcount > 4) {
            error(
              "Please provide valid NISM Registration Date",
              errorNotification,
            );
          } else if (euincount > 4) {
            error("Please provide valid EUIN Number", errorNotification);
          } else if (arncount > 4) {
            error("Please provide valid ARN Number", errorNotification);
          } else if (nismDateMessage !== "") {
            error(nismDateMessage, errorNotification);
          } else if (enrollmentDateMessage !== "") {
            error(enrollmentDateMessage, errorNotification);
          } else if (euinDateMessage !== "") {
            error(euinDateMessage, errorNotification);
          } else if (nismCertificateDateMessage !== "") {
            error(nismCertificateDateMessage, errorNotification);
          } else if (enrollmentNumberDateMessage !== "") {
            error(enrollmentNumberDateMessage, errorNotification);
          } else if (euinCertificateDateMessage !== "") {
            error(euinCertificateDateMessage, errorNotification);
          } else if (empNoMessage !== "") {
            error(empNoMessage, errorNotification);
          } else {
            let isValidDOB = this.isValidDate(DOB1, "");

            if (isValidDOB) {
              let valData = [];
              let docData = [];
              let docData1 = [];
              let docData2 = [];
              let docData3 = [];
              let doc_temp = [];
              let doc_temp1 = [];
              let doc_temp2 = [];
              let doc_temp3 = [];
              let doc_temp4 = [];
              let eduQualificationvalData = [];

              let isValidflag = true;

              if (isValidflag) {
                if (
                  values.submitStatus === "SUBMITTED" &&
                  values.hasOwnProperty("professionalQualification") &&
                  values.professionalQualification !== "" &&
                  values.professionalQualification !== 0
                ) {
                  if (values.professionalQualification.length > 0) {
                    values.professionalQualification.map((ele) => {
                      if (ele.occupation == "1021") {
                        valData.push(ele.occupation);
                        valData.push("test");
                        valData.push("test");
                        valData.push("test");
                        valData.push("test");
                      } else {
                        valData.push(ele.occupation);
                        valData.push(ele.companyName);
                        valData.push(ele.designation);
                        valData.push(ele.totalExperience);
                        valData.push(ele.dateOfJoining);
                      }
                    });
                  } else {
                    valData.push("");
                    valData.push("");
                    valData.push("");
                    valData.push("");
                    valData.push("");
                  }
                }

                if (
                  values.submitStatus === "SUBMITTED" &&
                  values.hasOwnProperty("learnerQualification") &&
                  values.learnerQualification !== "" &&
                  values.learnerQualification !== 0
                ) {
                  if (values.learnerQualification.length > 0) {
                    values.learnerQualification.map((ele) => {
                      eduQualificationvalData.push(ele.instituteName);

                      eduQualificationvalData.push(ele.passingYear);
                      if (ele.percentage <= 100) {
                        eduQualificationvalData.push(ele.percentage);
                      } else {
                        eduQualificationvalData.push("InvalidPercentage");
                      }
                      eduQualificationvalData.push(ele.qualificationType);
                    });
                  } else {
                    eduQualificationvalData.push("");
                    eduQualificationvalData.push("");
                    eduQualificationvalData.push("");
                    eduQualificationvalData.push("");
                  }
                }

                if (
                  values.submitStatus === "SUBMITTED" &&
                  (values.addressProofCardURL === undefined ||
                    values.signatureImgUrl === undefined ||
                    values.panCardURL === undefined ||
                    values.aadharCardURL === undefined ||
                    values.aadharCardBackURL === undefined)
                ) {
                  if (values.document.length > 0) {
                    for (let i = 0; i < values.document.length; i++) {
                      if (values.document[i].documentType == "AddressProof") {
                        doc_temp3.push(values.document[i]);
                      }

                      if (values.document[i].documentType == "PanCard") {
                        doc_temp.push(values.document[i]);
                      }

                      if (values.document[i].documentType == "AadharCard") {
                        doc_temp1.push(values.document[i]);
                      }
                      if (
                        values.document[i].documentType == "AadharCardBackSide"
                      ) {
                        doc_temp2.push(values.document[i]);
                      }

                      if (values.document[i].documentType == "ProfilePhoto") {
                        doc_temp4.push(values.document[i]);
                      }
                    }
                  }
                }

                if (doc_temp.length == 0 && values.panCardURL == undefined) {
                  docData3.push("requiredPanCard");
                }
                if (doc_temp1.length == 0) {
                  docData1.push("requiredAadharCard");
                }
                if (
                  doc_temp3.length == 0 &&
                  values.addressProofCardURL == undefined
                ) {
                  docData.push("requiredAddressProof");
                }

                if (doc_temp2.length == 0) {
                  docData1.push("requiredAadharCardBackSide");
                }
                if (
                  doc_temp4.length == 0 &&
                  values.profilePhotoURL == undefined
                ) {
                  docData2.push("requiredProilePhoto");
                }
                if (
                  doc_temp.length == 0 &&
                  values.signatureImgUrl == undefined
                ) {
                  docData3.push("requiredLearnerSignature");
                }
                if (["", null, undefined].includes(values.signatureImgUrl)) {
                  docData3.push("requiredLearnerSignature");
                }

                let pan =
                  values.panCardURL === undefined && values.whoareu !== 1011
                    ? true
                    : false;
                console.log("valData:::", valData);
                const fieldValidations = [
                  ["firstName", "First Name", 70],
                  ["perStreet", "Current House Number", 40],
                  ["perStreet2", "Current Street", 40],
                  ["perStreet3", "Current Town", 40],
                  ["officeStreet", "Address 1", 40],
                  ["officeStreet2", "Address 2", 40],
                  ["officeStreet3", "Address 3", 40],
                ];

                for (const [field, label, max] of fieldValidations) {
                  if (values[field]?.length > max) {
                    warning(
                      `${label} not more than ${max} characters.`,
                      warningNotification,
                    );
                    return;
                  }
                }

                // Check dynamic arrays
                if (Array.isArray(values.learnerQualification)) {
                  for (const ele of values.learnerQualification) {
                    if (ele.instituteName?.length > 70) {
                      warning(
                        "University/College Name not more than 70 characters.",
                        warningNotification,
                      );
                      return;
                    }
                  }
                }

                if (Array.isArray(values.professionalQualification)) {
                  for (const ele of values.professionalQualification) {
                    if (ele?.companyName?.length > 250) {
                      warning(
                        "Company Name not more than 250 characters.",
                        warningNotification,
                      );
                      return;
                    }
                    if (ele?.designation?.length > 50) {
                      warning(
                        "Designation not more than 50 characters.",
                        warningNotification,
                      );
                      return;
                    }
                  }
                }
                // ! Warning For PAN Card Upload
                if (
                  values.submitStatus === "SUBMITTED" &&
                  values.panCardURL === undefined &&
                  docData3.length > 0
                ) {
                  if (docData3.length > 0) {
                    if (docData3.includes("requiredPanCard")) {
                      warning(
                        "Please upload all required documents-Pan Card",
                        warningNotification,
                      );
                      return;
                    }
                  } else {
                    warning(
                      "Please upload all required documents-Pan Card",
                      warningNotification,
                    );
                    return;
                  }
                }
                // ! Warning For Address Proof Upload
                if (
                  values.submitStatus === "SUBMITTED" &&
                  values.addressProofCardURL === undefined &&
                  docData.length > 0
                ) {
                  if (docData.length > 0) {
                    if (docData.includes("requiredAddressProof")) {
                      warning(
                        "Please upload all required documents-Address Proof",
                        warningNotification,
                      );
                      return;
                    }
                  } else {
                    warning(
                      "Please upload all required documents-Address Proof",
                      warningNotification,
                    );
                    return;
                  }
                }
                // ! Warning For Educational Qualification
                if (
                  eduQualificationvalData.includes(undefined) === true ||
                  eduQualificationvalData.includes("") == true ||
                  eduQualificationvalData.includes(null) == true
                ) {
                  warning(
                    "please fill mandatory Fields of Educational Qualification",
                    warningNotification,
                  );
                  return;
                } else if (
                  eduQualificationvalData.includes("InvalidPercentage") === true
                ) {
                  warning("please Enter Valid Percentage", warningNotification);
                  return;
                }
                // ! Warning For Professional Qualification (Occupation Details)
                if (values?.professionalQualification?.length > 3) {
                  warning(
                    "The Maximum Limit for Occupation Details is 3.",
                    warningNotification,
                  );
                  return;
                }
                if (
                  valData.includes("") === true ||
                  valData.includes(undefined) === true ||
                  valData.includes(0) ||
                  valData.includes(null)
                ) {
                  warning(
                    "Please fill all the mandatory details for Occupation Details.",
                    warningNotification,
                  );
                  return;
                }
                // ! Warning For Profile Photo Upload
                if (
                  values.submitStatus === "SUBMITTED" &&
                  values.profilePhotoURL === undefined &&
                  docData2.length > 0
                ) {
                  if (docData2.length > 0) {
                    if (docData2.includes("requiredProilePhoto")) {
                      warning(
                        "Please upload all required documents-Profile Photo",
                        warningNotification,
                      );
                      return;
                    }
                  } else {
                    warning(
                      "Please upload all required documents-Profile Photo",
                      warningNotification,
                    );
                    return;
                  }
                }
                // ! Warning For Signature Image Upload
                if (
                  !["", null, undefined, "NISM"].includes(
                    this.state?.mandateDetails?.mandateName,
                  ) &&
                  values.submitStatus === "SUBMITTED" &&
                  ["", null, undefined].includes(values.signatureImgUrl) &&
                  docData3.length > 0
                ) {
                  if (docData3.length > 0) {
                    if (docData3.includes("requiredLearnerSignature")) {
                      warning(
                        "Please upload all required documents-Learner Signature",
                        warningNotification,
                      );
                      return;
                    }
                  } else {
                    warning(
                      "Please upload all required documents-Learner Signature",
                      warningNotification,
                    );
                    return;
                  }
                }
                //! Check Validation of All Uploaded Files
                const validExtensions = ["jpg", "jpeg", "png"];

                const checkImageFormat = (fileName, label) => {
                  const ext = fileName?.split(".").pop()?.toLowerCase();
                  // ❌ Invalid extension
                  if (!validExtensions.includes(ext)) {
                    warning(
                      `Invalid Image Format - ${label}`,
                      warningNotification,
                    );
                    return false;
                  }
                  // ❌ Block double extensions (e.g., abc.jpg.png)
                  const regex = new RegExp(
                    `^[^.]+\\.(${validExtensions.join("|")})$`,
                    "i",
                  );
                  if (!regex.test(fileName)) {
                    warning(
                      `Only single extension is allowed in file - ${label}.`,
                      warningNotification,
                    );
                    return false;
                  }
                  return true;
                };
                // 🔍 Files to validate
                const filesToCheck = [
                  { name: values.panCardName, label: "Pan Card" },
                  { name: values.addressProofName, label: "Address Proof" },
                  { name: values.profilePhotoName, label: "Profile Photo" },
                ];
                if (
                  !["", null, undefined, "NISM"].includes(
                    this.state?.mandateDetails?.mandateName,
                  )
                ) {
                  filesToCheck.push({
                    name: values.signatureImgName,
                    label: "Learner Signature",
                  });
                }

                for (const { name, label } of filesToCheck) {
                  if (name && !checkImageFormat(name, label)) return;
                }
                // ✅ Filter documents (removes invalid ones & duplicates silently)
                const isValidImage = (fileName) => {
                  const regex = new RegExp(
                    `^[^.]+\\.(${validExtensions.join("|")})$`,
                    "i",
                  );
                  return regex.test(fileName);
                };

                var seen = new Set();
                var documentArr =
                  values.document &&
                  values.document.filter((doc) => {
                    const key = `${
                      doc.documentType
                    }|${doc.documentName.toLowerCase()}`;
                    if (!isValidImage(doc.documentName) || seen.has(key)) {
                      return false;
                    }
                    seen.add(key);
                    return true;
                  });

                console.log("documentArr", documentArr);

                // ! Final Submit

                if (
                  values.hasOwnProperty("learnerQualification") &&
                  values.learnerQualification !== ""
                ) {
                  values.learnerQualification.map((ele) => {
                    delete ele.learnerQualificationID;
                  });
                }

                if (
                  values.hasOwnProperty("CPEDetails") &&
                  values.CPEDetails !== "" &&
                  values.CPEDetails !== 0
                ) {
                  values.CPEDetails.map((ele) => {
                    if (
                      moment(
                        ele.dateOfPassingTest,
                        "YYYY-MM-DD",
                        true,
                      ).isValid() == true ||
                      moment(ele.dateOfCpe, "YYYY-MM-DD", true).isValid() ==
                        true
                    ) {
                      ele.dateOfPassingTest = moment(
                        ele.dateOfPassingTest,
                      ).format("DD/MM/YYYY HH:mm:ss");
                      ele.dateOfCpe = moment(ele.dateOfCpe).format(
                        "DD/MM/YYYY HH:mm:ss",
                      );
                    }
                  });
                }
                if ([11024, "11024"].includes(values.peraddressproof1)) {
                  if (
                    [
                      "",
                      null,
                      undefined,
                      "null",
                      "undefined",
                      false,
                      "false",
                    ].includes(values.maskedAadhaar) &&
                    values.submitStatus === "SUBMITTED"
                  ) {
                    warning(
                      "Please Select CheckBox for Masked Aadhaar.",
                      warningNotification,
                    );
                    return;
                  }
                }
                // Generate the filename with the format dd/mm/yyyy hh:mm:ss
                const todayDate = new Date();
                const options = {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  hour12: false,
                  timeZone: "Asia/Kolkata",
                };
                const formatter = new Intl.DateTimeFormat("en-IN", options);
                const parts = formatter.formatToParts(todayDate);

                let dateFormatted = "";
                let timeFormatted = "";

                parts.forEach(({ type, value }) => {
                  if (type === "day" || type === "month" || type === "year") {
                    dateFormatted += dateFormatted ? `/${value}` : value; // Append with "/" separator
                  } else if (
                    type === "hour" ||
                    type === "minute" ||
                    type === "second"
                  ) {
                    timeFormatted += timeFormatted ? `:${value}` : value; // Append with ":" separator
                  }
                });

                const finalFormattedDate = `${dateFormatted} ${timeFormatted}`;
                const maskAadharUploadDate =
                  [11024, "11024"].includes(values.peraddressproof1) &&
                  [true, "true"].includes(values.maskedAadhaar)
                    ? finalFormattedDate
                      ? finalFormattedDate
                      : ""
                    : "";

                let address = [];
                let perAddress = {
                  addressType: "permanent",

                  addressTypeMark: values.addressTypeMark ? "permanent" : "",
                  addressId: values.perAddressID,
                  street: values?.perStreet?.trim(),
                  street2: values?.perStreet2?.trim(),
                  street3: values?.perStreet3?.trim(),
                  cityId: values.percityId,
                  stateId: values.perstateId,
                  countryId: values.percountryId,
                  postalCode: values?.perPostalCode,
                };
                let officeAddress = {
                  street: values?.officeStreet?.trim(),
                  street2: values?.officeStreet2?.trim(),
                  street3: values?.officeStreet3?.trim(),
                  countryId: values.officecountryId,
                  stateId: values.officestateId,
                  cityId: values.officecityId,
                  postalCode: values?.officePostalCode,
                };

                address.push(perAddress);

                values.certificateValidUpto = NISMDATE;
                values.enrollmentDate = ENROLLMENTDATE;

                await this.updateCommonWeightage("", "", values);
                let updatedPercentage = await localStorage.getItem(
                  "profilecomlitionvalue",
                );
                values.professionalQualification &&
                  values.professionalQualification.map((ele) => {
                    if (
                      ele.hasOwnProperty("learneProfessionalrQualificationID")
                    ) {
                      delete ele.learneProfessionalrQualificationID;
                    }
                  });
                const {
                  learnerEuinOption,
                  submitStatus,
                  preferredExamLocation,
                  preferredExamCenter,
                } = values;
                const isEmpty = (val) => ["", null].includes(val);

                if (isEmpty(learnerEuinOption)) {
                  if (submitStatus === "SUBMITTED") {
                    if (isEmpty(preferredExamLocation)) {
                      warning(
                        "You must specify Preferred Exam Location",
                        warningNotification,
                      );
                      return;
                    }
                    if (isEmpty(preferredExamCenter)) {
                      warning(
                        "You must specify Preferred Exam Center",
                        warningNotification,
                      );
                      return;
                    }
                  }
                }
                let isSponsored = JSON?.parse(
                  localStorage?.getItem("mandateDetails"),
                )?.isSponsored;
                let data = {
                  learnerEuinOption:
                    this.state?.newLearnerDetails?.learnerEuinOption,
                  userID: this.state.userId,
                  partyID: localStorage.getItem("userid-Token"),
                  learnerPartyID: values.learnerPartyID,
                  learnerID: values.learnerID,
                  roleID: localStorage.getItem("roleId"),
                  mobileNo: values.mobileNo,
                  emailID: values.emailID,
                  gender: values.gender,
                  maritalStatus: values.maritalStatus,
                  firstName: values.firstName,
                  middleName: values.middleName,
                  lastName: values.lastName,
                  contactNo: "",
                  secondaryEmailID: values.secondaryEmailID,
                  dob: DOB,
                  isMandateUser: this.props.personnelData.isMandateUser,
                  mandateId: this.props.personnelData.mandateId,
                  empNo: values.empNo,
                  panNumber: values.panNumber,
                  aadharNumber: values.aadharNumber,
                  learnerFatherName: values.learnerFatherName
                    ? values.learnerFatherName
                    : " ",
                  learnerFatherDOB: values.learnerFatherDOB
                    ? moment(values.learnerFatherDOB).format(
                        "DD/MM/YYYY HH:mm:ss",
                      )
                    : " ",
                  learnerFatherEmployementType:
                    values.learnerFatherEmployementType
                      ? values.learnerFatherEmployementType
                      : 0,
                  learnerFatherCompanyName: values.learnerFatherCompanyName
                    ? values.learnerFatherCompanyName
                    : " ",
                  learnerMotherName: values.learnerMotherName
                    ? values.learnerMotherName
                    : " ",
                  learnerMotherDOB: values.learnerMotherDOB
                    ? moment(values.learnerMotherDOB).format(
                        "DD/MM/YYYY HH:mm:ss",
                      )
                    : " ",
                  learnerMotherEmployementType:
                    values.learnerMotherEmployementType
                      ? values.learnerMotherEmployementType
                      : 0,
                  learnerMotherCompanyName: values.learnerMotherCompanyName
                    ? values.learnerMotherCompanyName
                    : " ",
                  learnerQualification:
                    values.learnerQualification.length != 0
                      ? values.learnerQualification.filter((x) => !!x)
                      : [],
                  address,
                  officeAddress,
                  isActive: 1,
                  document: documentArr || [],
                  resumeDocumentURL: values.resumeDocumentURL,
                  resumeVideoURL: values.resumeVideoURL,
                  passportNumber: "",
                  bankName: "Default Bank",
                  branchName: "Default Branch",
                  branchAddress: "Default Address",
                  accountType: "1",
                  accountNumber: "00000000000",
                  arn: values.ARNNO,
                  nameOfARNHolder: values.NameOfARNHolder,
                  nameOfMutualFundEmpanelled:
                    values.ARNuserFeilds !== undefined
                      ? values.ARNuserFeilds.filter((x) => !!x)
                      : null,
                  postalCode: values.perPostalCode,
                  salutation: values.salutation,
                  learnerProfessionalQualification:
                    values.professionalQualification !== "" &&
                    values.professionalQualification !== 0
                      ? values.professionalQualification
                          .filter((x) => !!x)
                          .map((item) => {
                            return {
                              ...item,
                              dateOfJoining: ["1021", 1021].includes(
                                item.occupation,
                              )
                                ? ""
                                : item.dateOfJoining
                                  ? (() => {
                                      const date = new Date(item.dateOfJoining);
                                      const now = new Date();

                                      const day = String(
                                        date.getDate(),
                                      ).padStart(2, "0");
                                      const month = String(
                                        date.getMonth() + 1,
                                      ).padStart(2, "0"); // Month is 0-based
                                      const year = date.getFullYear();

                                      const hours = String(
                                        now.getHours(),
                                      ).padStart(2, "0");
                                      const minutes = String(
                                        now.getMinutes(),
                                      ).padStart(2, "0");
                                      const seconds = String(
                                        now.getSeconds(),
                                      ).padStart(2, "0");

                                      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
                                    })()
                                  : null,
                            };
                          })
                      : null,
                  learnerFatherName: values.fatherName,
                  applicantSpouseFather: "",
                  learnerCpeDetails:
                    values.CPEDetails !== "" && values.CPEDetails !== 0
                      ? values.CPEDetails.filter((x) => !!x)
                      : null,
                  proofOfAddress: values.peraddressproof1,
                  proofOfAddressURL:
                    this.props.personnelData?.proofOfAddressURL,
                  proofOfAddressDocId:
                    this.props.personnelData?.proofOfAddressDocId,
                  applicationStatus: values.submitStatus,
                  learnerType: values.whoareu,
                  profileCompletion: updatedPercentage,
                  isTourCompleted: 1,
                  isAddressSame: true,
                  learnerProfession: values.currentProfession,
                  workflowName:
                    this.state.processType === "1001" ? "EUIN" : "EUIN",
                  ifscCode: "Default0000",
                  isCertificate: values.isCertificate,
                  nismRegistrationNo:
                    this.state?.newLearnerDetails?.learnerEuinOption &&
                    ![null, undefined, "null", "undefined"].includes(
                      this.state?.newLearnerDetails?.learnerEuinOption,
                    ) &&
                    this.state?.newLearnerDetails?.learnerEuinOption !== "NISM"
                      ? values.certificateNumber
                      : null,
                  enrollmentNumber:
                    this.state?.newLearnerDetails?.learnerEuinOption &&
                    ![null, undefined, "null", "undefined"].includes(
                      this.state?.newLearnerDetails?.learnerEuinOption,
                    ) &&
                    this.state?.newLearnerDetails?.learnerEuinOption !== "NISM"
                      ? values.enrollmentNumber
                      : null,
                  euinNumber:
                    this.state?.newLearnerDetails?.learnerEuinOption &&
                    ![null, undefined, "null", "undefined"].includes(
                      this.state?.newLearnerDetails?.learnerEuinOption,
                    ) &&
                    this.state?.newLearnerDetails?.learnerEuinOption !== "NISM"
                      ? values.euinNumber
                      : "",
                  certificateValidUpto:
                    this.state?.newLearnerDetails?.learnerEuinOption &&
                    ![null, undefined, "null", "undefined"].includes(
                      this.state?.newLearnerDetails?.learnerEuinOption,
                    ) &&
                    this.state?.newLearnerDetails?.learnerEuinOption !== "NISM"
                      ? NISMDATE
                      : null,
                  enrollmentDate:
                    this.state?.newLearnerDetails?.learnerEuinOption &&
                    ![null, undefined, "null", "undefined"].includes(
                      this.state?.newLearnerDetails?.learnerEuinOption,
                    ) &&
                    this.state?.newLearnerDetails?.learnerEuinOption !== "NISM"
                      ? ENROLLMENTDATE
                      : null,
                  euinValidUpto: EUINDATE,
                  companyName: values.companyId,
                  otherCompanyName: values.otherCompanyName,
                  maskAadharUploadDate: maskAadharUploadDate,
                  isSponsored: [1, "1"].includes(isSponsored)
                    ? "Y"
                    : [0, "0"].includes(isSponsored)
                      ? "N"
                      : "",
                  isProfile: true,
                  callCamsFlowFlag:
                    localStorage.getItem("isCamsAPICall") === "false"
                      ? false
                      : true,
                };
                console.log("vkd updateUserProfile:::: ", data);
                console.log("vkd values vvvv", values);
                if (
                  values.orgCompanyName === "HDFC Bank Limited" &&
                  values.submitStatus === "SUBMITTED"
                ) {
                  this.setState({ submitHDFCBtnDisabled: true });
                } else if (
                  values.orgCompanyName === "HDFC Bank Limited" &&
                  values.submitStatus === "DRAFTED"
                ) {
                  this.setState({ saveDraftHDFCBtnDisabled: true });
                }
                if (values.submitStatus === "SUBMITTED") {
                  this.setState({ submitBtnDisabled: true });
                } else if (values.submitStatus === "DRAFTED") {
                  this.setState({ saveDraftBtnDisabled: true });
                }

                this.setState({ loading: true });
                let mandateDetails = JSON.parse(
                  localStorage.getItem("mandateDetails"),
                );
                RegisterUserService.updateUserProfile(data, (res) => {
                  if (res.status === "success") {
                    this.setState({ loading: false });
                    this.setState({ loading1: "none" });

                    localStorage.setItem("reload", "true");
                    if (localStorage.getItem("roleId") == 5) {
                      if (data.applicationStatus === "SUBMITTED") {
                        if (
                          values.preferredMandateName === "NISM" ||
                          ["", null].includes(values.learnerEuinOption)
                        ) {
                          if (!["", null, undefined].includes(mandateDetails)) {
                            const { isSponsored, hasTraining } = mandateDetails;
                            const isIncluded = (val, arr) => arr.includes(val);

                            if (isIncluded(isSponsored, [1, "1"])) {
                              if (isIncluded(hasTraining, [1, "1"])) {
                                success1(
                                  <FirstMessage />,
                                  successNotification1,
                                );
                              } else if (isIncluded(hasTraining, [0, "0"])) {
                                success1(
                                  <SecondMessage />,
                                  successNotification1,
                                );
                              }
                            } else if (isIncluded(isSponsored, [0, "0"])) {
                              success1(<ThirdMessage />, successNotification1);
                            } else {
                              success(
                                "Your profile has been successfully submitted.",
                                successNotification,
                              );
                            }
                          } else {
                            success(
                              "Your profile has been successfully submitted.",
                              successNotification,
                            );
                          }
                        } else {
                          success(
                            "Your profile has been successfully submitted.",
                            successNotification,
                          );
                        }
                        if (
                          values.preferredMandateName === "NISM" ||
                          ["", null].includes(values.learnerEuinOption)
                        ) {
                          var data2 = localStorage.getItem("PersonnelData");
                          let data = [
                            {
                              action: "NISM VA SUBSCRIBE",
                              workflowId:
                                JSON.parse(data2).responseObject.learnerID,
                              additionalDetails: {
                                stateId: values.preferredExamLocation,
                                stateName: values.preferredExamLocationState,
                                center: values.preferredExamCenter,
                                centerName: values.preferredExamCenter,
                                requestedDate: "2000-1-1",
                                flag: false,
                                isconfirmbycilopps: false,
                              },
                            },
                          ];
                          ReattemptTestService.UpdateWorkflow(
                            data,
                            (res) => {},
                          );
                        }
                        setTimeout(() => {
                          this.props.history.push("/learnerDashboard");
                        }, 5000);
                      } else {
                        const {
                          preferredMandateName,
                          learnerEuinOption,
                          preferredExamLocation,
                          preferredExamCenter,
                        } = values;

                        if (
                          (preferredMandateName === "NISM" ||
                            ["", null].includes(learnerEuinOption)) &&
                          ![null, "", undefined].includes(
                            preferredExamLocation,
                          ) &&
                          ![null, "", undefined].includes(preferredExamCenter)
                        ) {
                          info(
                            "If you want to save the details of Preferred Exam Location & Center then you must click on Submit Button. On Click of Save Draft Button the details will not save.",
                            infoNotification,
                          );
                        }

                        setTimeout(() => {
                          success(
                            "Welcome to CIELs Regulatory Platform. Your profile is created and saved as draft. Fill in all mandatory details to submit your profile successfully.",
                            successNotification,
                          );
                        }, 2000);
                        if (
                          values.preferredMandateName === "NISM" ||
                          ["", null].includes(values.learnerEuinOption)
                        ) {
                          if (
                            !["", null, undefined].includes(
                              values.preferredExamLocation,
                            ) &&
                            !["", null, undefined].includes(
                              values.preferredExamCenter,
                            )
                          ) {
                            var data2 = localStorage.getItem("PersonnelData");
                            let data = [
                              {
                                action: "NISM VA SUBSCRIBE",
                                workflowId:
                                  JSON.parse(data2).responseObject.learnerID,
                                additionalDetails: {
                                  stateId: values.preferredExamLocation,
                                  stateName: values.preferredExamLocationState,
                                  center: values.preferredExamCenter,
                                  centerName: values.preferredExamCenter,
                                  requestedDate: "2000-1-1",
                                  flag: false,
                                  isconfirmbycilopps: false,
                                },
                              },
                            ];
                            ReattemptTestService.UpdateWorkflow(
                              data,
                              (res) => {},
                            );
                          }
                        }
                        setTimeout(() => {
                          window.location.reload();
                        }, 5000);
                      }
                    } else {
                      success(
                        "Your profile has been successfully submitted.",
                        successNotification,
                      );
                      setTimeout(() => {
                        window.location.reload();
                      }, 5000);
                    }
                  } else {
                    this.setState({
                      loading: false,
                      submitBtnDisabled: false,
                      saveDraftBtnDisabled: false,
                      submitHDFCBtnDisabled: false,
                      saveDraftHDFCBtnDisabled: false,
                    });
                    if (AADHAR_WARNING_MESSAGES.includes(res.reasonText)) {
                      warning(res.reasonText, {
                        ...warningNotification,
                      });
                    } else {
                      error(res.reasonText, {
                        ...errorNotification,
                      });
                    }
                  }
                });
              }
            }
          }
        }}
        render={({
          errors,
          touched,
          handleSubmit,
          handleChange,
          isValid,
          values,
          setFieldValue,
          formProps,
          validateField,
          handleBlur,
          form,
          ...formikProps
        }) => (
          <React.Fragment>
            <div
              className="modal fade"
              id="opt12"
              tabindex="-1"
              role="dialog"
              aria-labelledby="modalLabel"
              data-backdrop="static"
              data-keyboard="false"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-md">
                <div className="modal-content">
                  <div className="modal-header"></div>
                  <div className="modal-body">
                    <h4>
                      This process is currently done by submitting hard copies
                      of the application with required documents.
                    </h4>
                    <br />
                    <br />
                    <i className="fa fa-dot-circle-o"></i> Download the
                    application and fill in all details. <br />
                    <br />
                    <div>
                      <a href={fresh} download>
                        <i className="fa fa-download"></i> EUIN Fresh
                        Application
                      </a>{" "}
                      <br />
                      <a href={renewal} download>
                        <i className="fa fa-download"></i> EUIN renewal
                        Application
                      </a>{" "}
                      <br />
                      <a href={mapping} download>
                        <i className="fa fa-download"></i> EUIN Mapping
                        Application
                      </a>{" "}
                    </div>
                    <br />
                    <i className="fa fa-dot-circle-o"></i> Attach the documents
                    required mentioned in the application. <br />
                    <br />
                    <i className="fa fa-dot-circle-o"></i> Ensure to mention
                    your EMP id on the form at the top right-hand corner. <br />
                    <br />
                    <i className="fa fa-dot-circle-o"></i>Ensure to mention your
                    organization ARN no. correctly to avoid any confusion and
                    delay in processing. <br />
                    <br />
                    <i className="fa fa-dot-circle-o"></i> Application completed
                    in all respect with documents must be sent to CIEL at the
                    following address – <br />
                    <br />
                    <span style={{ color: "blue" }}>
                      Centre for Investment Education and Learning Unit no. 320,
                      Plot No. 105, Champaklal Industrial Estate, Next to Sion
                      Telephone Exchange (situated at Sion Koliwada Road), Sion
                      East, Mumbai 400022
                    </span>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn-5 mt-40"
                      name="btnNo"
                      onClick={(e) => {
                        window.location.href = "/learnerdashboard";
                      }}
                    >
                      Go Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal fade"
              id="roadmap1"
              tabindex="-1"
              role="dialog"
              aria-labelledby="modalLabel"
              data-keyboard="true"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-md" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <div className="scr-board">
                      <h2>Why Fill The Form? </h2>
                      <div className="bottom-line" />
                    </div>
                  </div>
                  <div className="modal-body">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                      <p>
                        <b>Welcome to the RCP Platform!</b>
                      </p>{" "}
                      <br />
                      <p>
                        The platform will take you through your journey of NISM
                        certification/Training and EUIN or as mandated by your
                        employer.
                      </p>
                      <p>
                        We will be collecting the following information from you
                        to create your NISM Profile and undertake your enrolment
                        for the NISM VA MF Certification Examination. Fill all
                        the “Compulsory Fields”, which have been marked with a
                        red asterisk (*). In case you are only coming for EUIN,
                        you will still need to fill the profile and put in your
                        certificate number and validity. This information will
                        be passed on to CAMS seamlessly for generating your
                        EUIN.
                      </p>
                      <ul>
                        <li>
                          <b>
                            The profile details are required by National
                            Institute of Securities Markets (NISM) for your
                            Profile Creation & NISM VA Exam Registration
                          </b>
                        </li>
                        <li>
                          <b>Please Keep the following documents ready </b>
                          <ul>
                            <li>
                              Scanned PAN{" "}
                              <span className="validation">
                                (File size less than 1 MB)
                              </span>
                            </li>
                            <li>
                              Scanned Proof of Address - Electricity Bill /
                              Ration Card / Passport / Voter ID
                              <span className="validation">
                                (File size less than 1 MB)
                              </span>
                            </li>
                            <li>
                              Profile Image{" "}
                              <span className="validation">
                                (only JPEG/JPG/PNG formats accepted)
                              </span>
                              <br />
                              <span className="validation">
                                Please note that the file you upload should NOT{" "}
                                have ANY special character in the name of the
                                attachment file.
                              </span>
                            </li>
                          </ul>
                        </li>
                        <li>
                          Click on “<b>Submit</b>” after filling all the
                          compulsory fields. Click on “<b>Save Draft</b>” if you{" "}
                          intend on updating your profile at a later date.
                          Kindly note that “<b>Submitting your Profile</b>” is a{" "}
                          <i>mandatory requirement</i> to continue with the RCP
                          Journey
                        </li>
                        <li>
                          <b>
                            Please note you will be able to submit the profile
                            details & move to next section ONLY after filing all
                            mandatory information (Marked as{" "}
                            <span className="validation">*</span>, including
                            upload of scanned documents)
                          </b>
                        </li>
                        <li>
                          <b>
                            The form may take 15 mins of your precious time.
                            Please be patient
                          </b>
                        </li>
                        <li>
                          NISM Certificate Details: Please fill this only if you
                          have a valid NISM certificate. Once you fill your
                          valid certificate details, and complete your profile,
                          the platform will take you for your EUIN completion.
                          These details are mandatory if you have come to
                          complete the EUIN journey on RCP.
                        </li>
                        <li>
                          EUIN Details: In case you are apply for a EUIN
                          renewal, you need to give us your EUIN details – EUIN
                          number and validity. Also you need to necessarily
                          update your NISM certificate details above with valid
                          certificate number
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn-5 mt-40"
                      name="btnNo"
                      onClick={(e) => {
                        window.$("#roadmap1").modal("hide");
                      }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {this.state.loading && (
              <PopUpPortal
                HidePopup={this.state.loading}
                IsVisible={this.state.loading}
              />
            )}
            <section className="dashboard-tab user-profile">
              <div className="container">
                <div className="row">
                  <div className="col-md-3 col-lg-3 col-sm-12 col-xs-12">
                    <div className="profile-left-sidebar">
                      <div className="profile-sidebar">
                        <div className="table-header">
                          <div className="container-fluid">
                            <div id="topheader">
                              <nav>
                                <ul className="tab">
                                  <div className="col-lg-12 col-md-12 col-sm-6 col-xs-12 hidden-xs hidden-sm pl pr">
                                    <div className="container-fluid">
                                      <div id="topheader">
                                        <nav>
                                          <ul className="tab">
                                            <div className="col-lg-12 col-md-12 col-sm-6 col-xs-12 hidden-xs hidden-sm pl pr">
                                              {/* <li className="active">
                                                <a
                                                  onClick={(e) => {
                                                    this.goto(
                                                      "distributor-profile"
                                                    );
                                                  }}
                                                >
                                                  Profile Instructions
                                                </a>
                                              </li>
                                              <li className="">
                                                <a
                                                  onClick={(e) => {
                                                    this.goto("create-user");
                                                  }}
                                                >
                                                  Personal Details{" "}
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  onClick={(e) => {
                                                    this.goto("create-address");
                                                  }}
                                                >
                                                  Address Details{" "}
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  onClick={(e) => {
                                                    this.goto("office-address");
                                                  }}
                                                >
                                                  Office Address Details{" "}
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  onClick={(e) => {
                                                    this.goto(
                                                      "educational-details"
                                                    );
                                                  }}
                                                >
                                                  Educational Details{" "}
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  onClick={(e) => {
                                                    this.goto(
                                                      "create-qualification"
                                                    );
                                                  }}
                                                >
                                                  Professional Details
                                                </a>
                                              </li>
                                              {this.state
                                                .assignedUserMandateName !==
                                                undefined &&
                                              this.state
                                                .assignedUserMandateName !==
                                                "NISM" ? (
                                                <li className="">
                                                  <a
                                                    onClick={(e) => {
                                                      this.goto(
                                                        "NISMCertificate"
                                                      );
                                                    }}
                                                  >
                                                    {" "}
                                                    NISM Certificate Details{" "}
                                                  </a>
                                                </li>
                                              ) : (
                                                ""
                                              )}
                                              {this.state
                                                .assignedUserMandateName !==
                                                undefined &&
                                              this.state
                                                .assignedUserMandateName !==
                                                "NISM" ? (
                                                <li>
                                                  <a
                                                    onClick={(e) => {
                                                      this.goto("EUINDetails");
                                                    }}
                                                  >
                                                    {" "}
                                                    EUIN Details
                                                  </a>
                                                </li>
                                              ) : (
                                                ""
                                              )}
                                              {(values.preferredMandateName ===
                                                "NISM" ||
                                                ["", null].includes(
                                                  values.learnerEuinOption
                                                )) && (
                                                <li>
                                                  <a
                                                    onClick={(e) => {
                                                      this.goto(
                                                        "Preferred-NISM-Exam-Location"
                                                      );
                                                    }}
                                                  >
                                                    {" "}
                                                    Preferred NISM Exam Location
                                                  </a>
                                                </li>
                                              )}
                                              <li>
                                                <a
                                                  onClick={(e) => {
                                                    this.goto("ARNDetails");
                                                  }}
                                                >
                                                  {" "}
                                                  ARN Details
                                                </a>
                                              </li>

                                              <li>
                                                <a
                                                  onClick={(e) => {
                                                    this.goto("create-profile");
                                                  }}
                                                >
                                                  Profile Details
                                                </a>
                                              </li> */}
                                              {menuItems.map(
                                                ({ label, route }) => (
                                                  <li
                                                    key={route}
                                                    className={
                                                      route ===
                                                      "distributor-profile"
                                                        ? "active"
                                                        : ""
                                                    }
                                                  >
                                                    <a
                                                      onClick={() =>
                                                        this.goto(route)
                                                      }
                                                    >
                                                      {label}
                                                    </a>
                                                  </li>
                                                ),
                                              )}
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                              <UserProfileComplitionBarCommon
                                                personnelProfileData={
                                                  this.props.personnelData
                                                }
                                                personnelAddressData={
                                                  this.props.addressData
                                                }
                                                learnerEuinOption={
                                                  this.props.learnerEuinOption
                                                }
                                              />
                                            </div>
                                            <li>
                                              <a onClick={this.WhyTheFillForm}>
                                                {" "}
                                                User Profile
                                                <i
                                                  className="fa fa-question-circle-o"
                                                  aria-hidden="true"
                                                  style={{
                                                    fontSize: "20px",
                                                    paddingLeft: "5px",
                                                    paddingright: "8px",
                                                  }}
                                                />
                                              </a>
                                            </li>
                                          </ul>
                                        </nav>
                                      </div>
                                    </div>
                                  </div>
                                </ul>
                              </nav>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9 col-lg-9 col-sm-12 col-xs-12">
                    <main className="content-pos-fixed">
                      <Form
                        onSubmit={handleSubmit}
                        onKeyDown={(onKeyDown) => {
                          if (
                            (onKeyDown.charCode || onKeyDown.keyCode) === 13 &&
                            onKeyDown.target.name != "corcountryId" &&
                            onKeyDown.target.name != "corstateId" &&
                            onKeyDown.target.name != "corcityId" &&
                            onKeyDown.target.name != "percountryId" &&
                            onKeyDown.target.name != "perstateId" &&
                            onKeyDown.target.name != "percityId" &&
                            onKeyDown.target.name !=
                              "learnerFatherEmployementType" &&
                            onKeyDown.target.name !=
                              "learnerMotherEmployementType" &&
                            onKeyDown.target.name != "submitForm" &&
                            onKeyDown.target.name != "gender" &&
                            onKeyDown.target.name != "maritalStatus"
                          ) {
                            onKeyDown.preventDefault();
                          }
                        }}
                        className="form-group"
                      >
                        <div className="bg-box">
                          <section
                            className="create-user page-section profile-box"
                            id="distributor-profile"
                          >
                            <div className="row">
                              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <h2 className="sub-header">
                                  Profile Instructions
                                </h2>

                                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                  <p>
                                    <b>Welcome to the RCP Platform!</b>
                                  </p>{" "}
                                  <br />
                                  <p>
                                    The platform will take you through your
                                    journey of NISM certification/Training and
                                    EUIN as mandated by your employer.
                                  </p>
                                  <p>
                                    We will be collecting the following
                                    information from you to create your NISM
                                    Profile and undertake your enrolment for the
                                    NISM VA MF Certification Examination.
                                  </p>
                                  <ul>
                                    <li>
                                      <b>
                                        Please Keep the following documents
                                        ready
                                        <span className="validation">
                                          ((File size less than 1 MB))
                                        </span>
                                      </b>
                                      <ul>
                                        <li>Scanned PAN</li>
                                        <li>Scanned Proof of Address</li>
                                        <span className="validation">
                                          Note: "We will only be accepting
                                          Masked Aadhaar copies as Proof of
                                          Address. Please use the link{" "}
                                          <span
                                            onClick={() =>
                                              window.open(
                                                "https://myaadhaar.uidai.gov.in/",
                                              )
                                            }
                                            style={{
                                              color: "blue",
                                              textDecoration: "underline",
                                              cursor: "pointer",
                                            }}
                                          >
                                            https://myaadhaar.uidai.gov.in/
                                          </span>{" "}
                                          to download it."
                                        </span>
                                        <li>Photo</li>
                                        <span className="validation">
                                          Only JPEG/JPG/PNG formats accepted.
                                          Please note that the file you upload
                                          should NOT have ANY special character
                                          in the name of the attachment file.
                                        </span>
                                      </ul>
                                    </li>
                                  </ul>
                                </div>
                                <div
                                  className="form-group"
                                  style={{
                                    display: "none",
                                  }}
                                >
                                  <div className="row">
                                    <div
                                      className="col-md-12 col-sm-12 col-xs-12"
                                      style={{ display: "none" }}
                                    >
                                      <label>Process Type </label>
                                      <div className="displayFlex">
                                        <div>
                                          <Field
                                            className="form-check-input"
                                            type="checkbox"
                                            name="ARN"
                                            checked={
                                              this.state.processType === "1001"
                                                ? true
                                                : false
                                            }
                                            disabled={true}
                                            style={{ marginRight: "10px" }}
                                          />
                                          <label
                                            className="form-check-label"
                                            for="gridCheck"
                                            style={{ marginRight: "15px" }}
                                          >
                                            ARN
                                          </label>
                                        </div>
                                        <div>
                                          <Field
                                            className="form-check-input"
                                            type="checkbox"
                                            name="CPE"
                                            checked={
                                              this.state.processType === "1003"
                                                ? true
                                                : false
                                            }
                                            disabled={true}
                                            style={{ marginRight: "10px" }}
                                          />
                                          <label
                                            className="form-check-label"
                                            for="gridCheck"
                                            style={{ marginRight: "15px" }}
                                          >
                                            NISM Certification Details
                                          </label>
                                        </div>
                                        <div>
                                          <Field
                                            className="form-check-input"
                                            type="checkbox"
                                            name="EUIN"
                                            checked={
                                              this.state.processType === "1002"
                                                ? true
                                                : false
                                            }
                                            disabled={true}
                                            style={{ marginRight: "10px" }}
                                          />
                                          <label
                                            className="form-check-label"
                                            for="gridCheck"
                                            style={{ marginRight: "15px" }}
                                          >
                                            EUIN
                                          </label>
                                        </div>
                                        <div>
                                          <Field
                                            className="form-check-input"
                                            type="checkbox"
                                            name="nismCertificate"
                                            checked={
                                              this.state.processType === "1004"
                                                ? true
                                                : false
                                            }
                                            disabled={true}
                                            style={{ marginRight: "10px" }}
                                          />
                                          <label
                                            className="form-check-label"
                                            for="gridCheck"
                                            style={{ marginRight: "15px" }}
                                          >
                                            NISM Certification
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="col-md-4 col-sm-4 col-xs-12"
                                      style={{ display: "none" }}
                                    >
                                      <label>
                                        Who Are You?
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        as="select"
                                        name="whoareu"
                                        id="whoareu"
                                        disabled={values.disabledForCielops}
                                        onChange={(event) => {
                                          setFieldValue(
                                            (values.whoareu =
                                              event.target.value),
                                          );
                                          if (event.target.value == "1011") {
                                            setFieldValue(
                                              (values.PanValidation = false),
                                            );
                                          } else {
                                            setFieldValue(
                                              (values.PanValidation = true),
                                            );
                                          }
                                          if (event.target.value == "1015") {
                                            setFieldValue(
                                              (values.nameOfCurrProf =
                                                "Last Profession"),
                                            );
                                          }
                                          if (
                                            event.target.value == "1011" ||
                                            event.target.value == "1012"
                                          ) {
                                            setFieldValue(
                                              (values.currProfessionList = []),
                                            );
                                            setFieldValue(
                                              (values.disablecurreProf = true),
                                            );
                                          } else if (
                                            event.target.value == "1013" ||
                                            event.target.value == "1015"
                                          ) {
                                            setFieldValue(
                                              (values.disablecurreProf = false),
                                            );
                                            setFieldValue(
                                              (values.currProfessionList =
                                                currProf),
                                            );
                                          } else {
                                            setFieldValue(
                                              (values.currProfessionList = []),
                                            );
                                            setFieldValue(
                                              (values.disablecurreProf = true),
                                            );
                                          }
                                        }}
                                        onBlur={(event) => {
                                          this.updateCommonWeightage(
                                            event.target.name,
                                            event.target.value,
                                            values,
                                          );
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.whoareu && touched.whoareu
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="1011">Student</option>
                                        <option value="1012">
                                          Entrepreneur
                                        </option>
                                        <option value="1013">
                                          Professional
                                        </option>
                                        <option value="1014">Home Maker</option>
                                        <option value="1015">Retired</option>
                                      </Field>
                                      {errors.whoareu && (
                                        <div className="validation">
                                          {errors.whoareu}
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>{values.nameOfCurrProf} </label>

                                      <div>
                                        <Field
                                          as="select"
                                          name="currentProfession"
                                          id="currentProfession"
                                          onChange={handleChange}
                                          disabled={
                                            values.disabledForCielops ||
                                            values.disablecurreProf
                                          }
                                          onBlur={(event) => {
                                            this.updateCommonWeightage(
                                              event.target.name,
                                              event.target.value,
                                              values,
                                            );
                                          }}
                                          className={
                                            "form-control" +
                                            (errors.lookingFor &&
                                            touched.lookingFor
                                              ? " is-invalid"
                                              : "")
                                          }
                                        >
                                          <option value="">--Select--</option>
                                          {(
                                            values.currProfessionList || []
                                          ).map((team) => (
                                            <option
                                              key={team.codeValueId}
                                              value={team.codeValueId}
                                            >
                                              {team.codeValue}
                                            </option>
                                          ))}
                                        </Field>
                                        {errors.currentProfession && (
                                          <div className="validation">
                                            {errors.currentProfession}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>ARN/EUIN Number</label>
                                      <Field
                                        type="text"
                                        placeholder="ARN/EUIN Number"
                                        className="form-control"
                                        disabled={values.disabledForCielops}
                                        onBlur={(event) => {
                                          this.updateCommonWeightage(
                                            event.target.name,
                                            event.target.value,
                                            values,
                                          );
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="row" />
                                </div>
                              </div>
                            </div>
                          </section>
                          <section
                            className="create-user page-section profile-box"
                            id="create-user"
                          >
                            <div className="row">
                              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <h2 className="sub-header">Personal Details</h2>
                                <div className="form-group">
                                  <div className="row">
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Employee ID{" "}
                                        <span className="validation">
                                          {" "}
                                          *
                                        </span>{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        name="empNo"
                                        value={values.empNo || ""} // always bind to Formik value
                                        onChange={handleChange}
                                        onBlur={this.handleNormalizeOnBlur(
                                          "empNo",
                                          setFieldValue,
                                          values,
                                        )}
                                        id="empNo"
                                        className="form-control"
                                        placeholder="Employee ID"
                                      />
                                      <div className="col-md-12 col-sm-12">
                                        <span className="file-size-limit">
                                          If from Institution/Bank mentioned
                                          your Employee ID
                                        </span>
                                      </div>
                                      {errors.empNo && (
                                        <div className="validation">
                                          {errors.empNo}
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Mobile No{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="mobileNo"
                                        id="mobileNo"
                                        onChange={(e) => {
                                          if (this.state.isEditable) {
                                            handleChange(e);
                                          }
                                        }}
                                        disabled
                                        autoComplete="mobileNo"
                                        className={
                                          "form-control" +
                                          (errors.mobileNo && touched.mobileNo
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Mobile Number"
                                      />
                                      {errors.mobileNo && (
                                        <div className="validation">
                                          {errors.mobileNo}
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Personal Email Id
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="emailID"
                                        id="emailID"
                                        onChange={(e) => {
                                          if (this.state.isEditable) {
                                            handleChange(e);
                                          }
                                        }}
                                        disabled
                                        autoComplete="emailID"
                                        className={
                                          "form-control" +
                                          (errors.emailID && touched.emailID
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Email ID"
                                      />
                                      {errors.emailID && (
                                        <div className="validation">
                                          {errors.emailID}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-12 col-sm-12 col-xs-12" />
                                  <div className="row">
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Gender
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        as="select"
                                        name="gender"
                                        id="gender"
                                        disabled={values.disabledForCielops}
                                        value={values.gender || ""} // always bind to Formik value
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          handleChange(e);
                                          setFieldValue("gender", value);
                                          this.setState({
                                            gender: value,
                                          });
                                        }}
                                        onBlur={this.handleNormalizeOnBlur(
                                          "gender",
                                          setFieldValue,
                                          values,
                                        )}
                                        className={
                                          "form-control" +
                                          (errors.gender && touched.gender
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="">Select Gender</option>
                                        <option value="1">Male</option>
                                        <option value="2">Female</option>
                                        <option value="3">Transgender</option>
                                      </Field>
                                      {errors.gender && (
                                        <div className="validation">
                                          {errors.gender}
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>Select Salutation</label>
                                      <Field
                                        as="select"
                                        name="salutation"
                                        id="salutation"
                                        disabled={values.disabledForCielops}
                                        value={values.salutation || ""} // always bind to Formik value
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          handleChange(e);
                                          setFieldValue("salutation", value);
                                          this.setState({
                                            salutation: value,
                                          });
                                        }}
                                        onBlur={this.handleNormalizeOnBlur(
                                          "salutation",
                                          setFieldValue,
                                          values,
                                        )}
                                        className={
                                          "form-control" +
                                          (errors.salutation &&
                                          touched.salutation
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="">
                                          Select Salutation
                                        </option>
                                        <option value="1">Mr.</option>
                                        <option value="2">Mrs.</option>
                                        <option value="3">Miss.</option>
                                      </Field>
                                      {errors.salutation && (
                                        <div className="validation">
                                          {errors.salutation}
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        First Name{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="firstName"
                                        id="firstName"
                                        disabled={values.disabledForCielops}
                                        value={values.firstName || ""} // bind to Formik
                                        maxLength={70}
                                        autoComplete="firstName"
                                        onChange={handleChange}
                                        onBlur={this.handleNormalizeOnBlur(
                                          "firstName",
                                          setFieldValue,
                                          values,
                                        )}
                                        className={
                                          "form-control" +
                                          (errors.firstName && touched.firstName
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="First Name"
                                      />
                                      {errors.firstName && (
                                        <div className="validation">
                                          {errors.firstName}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-12 col-sm-12 col-xs-12" />
                                  <div className="row">
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>Middle Name</label>
                                      <Field
                                        type="text"
                                        name="middleName"
                                        id="middleName"
                                        disabled={values.disabledForCielops}
                                        value={values.middleName || ""} // always bind to Formik value
                                        onChange={handleChange}
                                        onBlur={this.handleNormalizeOnBlur(
                                          "middleName",
                                          setFieldValue,
                                          values,
                                        )}
                                        autoComplete="middleName"
                                        className="form-control"
                                        placeholder="Middle Name"
                                      />
                                      {errors.middleName && (
                                        <div className="validation">
                                          {errors.middleName}
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Last Name
                                        <span className="validation">
                                          {" "}
                                          *
                                        </span>{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        name="lastName"
                                        id="lastName"
                                        disabled={values.disabledForCielops}
                                        value={values.lastName || ""} // always bind to Formik value
                                        onChange={handleChange}
                                        onBlur={this.handleNormalizeOnBlur(
                                          "lastName",
                                          setFieldValue,
                                          values,
                                        )}
                                        autoComplete="lastName"
                                        className={
                                          "form-control" +
                                          (errors.lastName && touched.lastName
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Last Name"
                                      />
                                      {errors.lastName && (
                                        <div className="validation">
                                          {errors.lastName}
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Father's Name
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="fatherName"
                                        id="fatherName"
                                        disabled={values.disabledForCielops}
                                        value={values.fatherName || ""} // always bind to Formik value
                                        onChange={handleChange}
                                        onBlur={this.handleNormalizeOnBlur(
                                          "fatherName",
                                          setFieldValue,
                                          values,
                                        )}
                                        autoComplete="fatherName"
                                        className="form-control"
                                        placeholder="Father Name"
                                      />
                                      {errors.fatherName && (
                                        <div className="validation">
                                          {errors.fatherName}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-12 col-sm-12 col-xs-12" />
                                  <div className="row">
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Marital Status
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        as="select"
                                        name="maritalStatus"
                                        id="maritalStatus"
                                        disabled={values.disabledForCielops}
                                        value={values.maritalStatus || ""} // always bind to Formik value
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          handleChange(e);
                                          setFieldValue("maritalStatus", value);
                                          this.setState({
                                            maritalStatus: value,
                                          });
                                        }}
                                        onBlur={this.handleNormalizeOnBlur(
                                          "maritalStatus",
                                          setFieldValue,
                                          values,
                                        )}
                                        className={
                                          "form-control" +
                                          (errors.maritalStatus &&
                                          touched.maritalStatus
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="">
                                          Select Marital Status
                                        </option>
                                        <option value="11020">Married</option>
                                        <option value="11021">Unmarried</option>
                                      </Field>
                                      {errors.maritalStatus && (
                                        <div className="validation">
                                          {errors.maritalStatus}
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>Official Email ID</label>
                                      <span className="validation"> *</span>
                                      <Field
                                        type="text"
                                        name="secondaryEmailID"
                                        id="secondaryEmailID"
                                        value={values.secondaryEmailID || ""} // always bind to Formik value
                                        autoComplete="secondaryEmailID"
                                        disabled={values.disabledForCielops}
                                        onChange={handleChange}
                                        onBlur={this.handleNormalizeOnBlur(
                                          "secondaryEmailID",
                                          setFieldValue,
                                          values,
                                        )}
                                        className={
                                          "form-control" +
                                          (errors.secondaryEmailID &&
                                          touched.secondaryEmailID
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Email ID"
                                      />
                                      {errors.secondaryEmailID && (
                                        <div className="validation">
                                          {errors.secondaryEmailID}
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Birth Date
                                        <span className="validation"> *</span>
                                      </label>
                                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                        <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pl pr">
                                          <Field
                                            as="select"
                                            name="day"
                                            id="day"
                                            disabled={values.disabledForCielops}
                                            value={values.day || ""} // always bind to Formik value
                                            onChange={(e) => {
                                              var listOfMonth = [];
                                              const value = e.target.value;
                                              setFieldValue(
                                                (values.day = value),
                                              );
                                              this.setState({ day: value });
                                              handleChange(e);
                                              if (e.target.value == 31) {
                                                listOfMonth = [
                                                  { key: 1, value: "Jan" },

                                                  { key: 3, value: "Mar" },

                                                  { key: 5, value: "May" },

                                                  { key: 7, value: "Jul" },
                                                  { key: 8, value: "Aug" },

                                                  { key: 10, value: "Oct" },

                                                  { key: 12, value: "Dec" },
                                                ];
                                              } else if (e.target.value == 30) {
                                                listOfMonth = [
                                                  { key: 1, value: "Jan" },

                                                  { key: 3, value: "Mar" },
                                                  { key: 4, value: "Apr" },
                                                  { key: 5, value: "May" },
                                                  { key: 6, value: "Jun" },
                                                  { key: 7, value: "Jul" },
                                                  { key: 8, value: "Aug" },
                                                  { key: 9, value: "Sep" },
                                                  { key: 10, value: "Oct" },
                                                  { key: 11, value: "Nov" },
                                                  { key: 12, value: "Dec" },
                                                ];
                                              } else if (
                                                e.target.value == 28 ||
                                                e.target.value == 29
                                              ) {
                                                listOfMonth = [
                                                  { key: 1, value: "Jan" },
                                                  { key: 2, value: "Feb" },
                                                  { key: 3, value: "Mar" },
                                                  { key: 4, value: "Apr" },
                                                  { key: 5, value: "May" },
                                                  { key: 6, value: "Jun" },
                                                  { key: 7, value: "Jul" },
                                                  { key: 8, value: "Aug" },
                                                  { key: 9, value: "Sep" },
                                                  { key: 10, value: "Oct" },
                                                  { key: 11, value: "Nov" },
                                                  { key: 12, value: "Dec" },
                                                ];
                                              } else {
                                                listOfMonth = [
                                                  { key: 1, value: "Jan" },
                                                  { key: 2, value: "Feb" },
                                                  { key: 3, value: "Mar" },
                                                  { key: 4, value: "Apr" },
                                                  { key: 5, value: "May" },
                                                  { key: 6, value: "Jun" },
                                                  { key: 7, value: "Jul" },
                                                  { key: 8, value: "Aug" },
                                                  { key: 9, value: "Sep" },
                                                  { key: 10, value: "Oct" },
                                                  { key: 11, value: "Nov" },
                                                  { key: 12, value: "Dec" },
                                                ];
                                              }
                                              setFieldValue(
                                                (values.listOfMonth =
                                                  listOfMonth),
                                              );
                                              this.setState({
                                                listOfMonth: listOfMonth,
                                              });
                                            }}
                                            onBlur={this.handleNormalizeOnBlur(
                                              "day",
                                              setFieldValue,
                                              values,
                                            )}
                                            className={
                                              "form-control" +
                                              (errors.day && touched.day
                                                ? " is-invalid"
                                                : "")
                                            }
                                          >
                                            <option value="">DD</option>
                                            {(values.listOfDay || []).map(
                                              (d) => (
                                                <option value={d}>{d}</option>
                                              ),
                                            )}
                                          </Field>
                                          {errors.day && (
                                            <div className="validation">
                                              {errors.day}
                                            </div>
                                          )}
                                        </div>
                                        <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                          <Field
                                            as="select"
                                            name="month"
                                            id="month"
                                            value={values.month || ""} // always bind to Formik value
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              setFieldValue(
                                                (values.month = value),
                                              );
                                              this.setState({ month: value });
                                              handleChange(e);
                                              if (e.target.value == 2) {
                                                var listOfDay = [];
                                                for (var i = 1; i <= 29; i++) {
                                                  listOfDay.push(i);
                                                }
                                              } else if (
                                                e.target.value == 1 ||
                                                e.target.value == 3 ||
                                                e.target.value == 5 ||
                                                e.target.value == 7 ||
                                                e.target.value == 8 ||
                                                e.target.value == 10 ||
                                                e.target.value == 12
                                              ) {
                                                var listOfDay = [];
                                                for (var i = 1; i <= 31; i++) {
                                                  listOfDay.push(i);
                                                }
                                              } else {
                                                var listOfDay = [];
                                                for (var i = 1; i <= 30; i++) {
                                                  listOfDay.push(i);
                                                }
                                              }
                                              setFieldValue(
                                                (values.listOfDay = listOfDay),
                                              );
                                              this.setState({
                                                listOfDay: listOfDay,
                                              });
                                            }}
                                            onBlur={this.handleNormalizeOnBlur(
                                              "month",
                                              setFieldValue,
                                              values,
                                            )}
                                            className={
                                              "form-control" +
                                              (errors.month && touched.month
                                                ? " is-invalid"
                                                : "")
                                            }
                                            disabled={values.disabledForCielops}
                                          >
                                            <option value="">MM</option>
                                            {(values.listOfMonth || []).map(
                                              (m) => (
                                                <option value={m.key}>
                                                  {m.value}
                                                </option>
                                              ),
                                            )}
                                          </Field>
                                          {errors.month && (
                                            <div className="validation">
                                              {errors.month}
                                            </div>
                                          )}
                                        </div>
                                        <div className="col-md-5 col-lg-5 col-sm-5 col-xs-5 pl pr">
                                          <Field
                                            as="select"
                                            name="year"
                                            id="year"
                                            value={values.year || ""} // always bind to Formik value
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              handleChange(e);
                                              setFieldValue("year", value);
                                              this.setState({
                                                year: value,
                                              });
                                            }}
                                            onBlur={this.handleNormalizeOnBlur(
                                              "year",
                                              setFieldValue,
                                              values,
                                            )}
                                            className={
                                              "form-control" +
                                              (errors.year && touched.year
                                                ? " is-invalid"
                                                : "")
                                            }
                                            disabled={values.disabledForCielops}
                                          >
                                            <option value="">YYYY</option>
                                            {(this.state.listOfYear1 || []).map(
                                              (year) => (
                                                <option value={year}>
                                                  {year}
                                                </option>
                                              ),
                                            )}
                                          </Field>
                                          {errors.year && (
                                            <div className="validation">
                                              {errors.year}
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                      {errors.dob && (
                                        <div className="validation">
                                          {errors.dob}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-12 col-sm-12 col-xs-12" />
                                  <div className="row">
                                    <div
                                      className="col-md-4 col-sm-4 col-xs-12"
                                      id="pan"
                                    >
                                      <label>
                                        PAN NO
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="panNumber"
                                        id="panNumber"
                                        maxlength="10"
                                        disabled
                                        onChange={(event) => {
                                          handleChange(event);
                                          let pan = event.target.value;
                                          pan = pan.toUpperCase();
                                          setFieldValue(
                                            (values.panNumber = pan),
                                          );
                                        }}
                                        onBlur={(event) => {
                                          this.updateCommonWeightage(
                                            event.target.name,
                                            event.target.value,
                                            values,
                                          );
                                        }}
                                        className="form-control"
                                        placeholder="PAN NO"
                                      />

                                      <div className="col-md-12 col-sm-12">
                                        <span className="file-size-limit">
                                          PAN is compulsory for NISM
                                          Registration
                                        </span>
                                      </div>
                                      {errors.panNumber && (
                                        <div className="validation">
                                          {errors.panNumber}
                                        </div>
                                      )}
                                    </div>
                                    <div
                                      className="col-md-4 col-sm-4 col-xs-12"
                                      style={{ display: "none" }}
                                    >
                                      <label>
                                        Aadhaar No{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="aadharNumber"
                                        id="aadharNumber"
                                        maxlength="12"
                                        disabled
                                        onChange={handleChange}
                                        onBlur={(event) => {
                                          this.updateCommonWeightage(
                                            event.target.name,
                                            event.target.value,
                                            values,
                                          );
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.aadharNumber &&
                                          touched.aadharNumber
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Aadhaar NO"
                                      />
                                      {errors.aadharNumber && (
                                        <div className="validation">
                                          {errors.aadharNumber}
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-md-12 col-sm-12 col-xs-12" />
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Upload PAN
                                        <span className="validation"> *</span>
                                      </label>
                                      <div className="profile-detail">
                                        <div className="circle">
                                          {values.panCardURL && (
                                            <>
                                              <img
                                                className="profile-pic"
                                                src={values.panCardURL}
                                              />
                                              <div className="profile">
                                                <i
                                                  className="fa fa-user"
                                                  aria-hidden="true"
                                                />
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                      <div className="profile-add">
                                        <a>
                                          <span className="icon btn-file text-center">
                                            <i
                                              className="fa fa-plus-circle"
                                              aria-hidden="true"
                                            />
                                            <FileBase64
                                              multiple={true}
                                              name="panCardURL"
                                              key={this.state.panCardFileKey} // 👈 add key
                                              id="panCardURL"
                                              onChange={handleChange}
                                              // onDone={(event) => {
                                              //   const checkType =
                                              //     event[0].name.split(
                                              //       /\.(?=[^\.]+$)/
                                              //     );
                                              //   if (
                                              //     [
                                              //       "jpg",
                                              //       "JPG",
                                              //       "jpeg",
                                              //       "JPEG",
                                              //       "png",
                                              //       "PNG",
                                              //     ].indexOf(checkType[1]) < 0
                                              //   ) {
                                              //     setFieldValue(
                                              //       (values.documentTypeCheckForPANImage = true)
                                              //     );
                                              //   } else if (
                                              //     event[0].file.size <= 1048576
                                              //   ) {
                                              //     if (
                                              //       this.checkName(
                                              //         event[0].name
                                              //       )
                                              //     ) {
                                              //       values.document.push({
                                              //         documentHash:
                                              //           event[0].base64,
                                              //         documentType: "PanCard",
                                              //         documentName:
                                              //           event[0].name,
                                              //       });
                                              //       this.updateCommonWeightage(
                                              //         "panCardURL",
                                              //         event[0].name,
                                              //         values
                                              //       );
                                              //       setFieldValue(
                                              //         (values.documentTypeCheckForPANImage = false)
                                              //       );
                                              //       setFieldValue(
                                              //         (values.panCardName =
                                              //           event[0].name)
                                              //       );
                                              //       setFieldValue(
                                              //         (values.documentSizeCheckForPanCard = false)
                                              //       );
                                              //       setFieldValue(
                                              //         (values.documentNameValidation = false)
                                              //       );
                                              //       setFieldValue(
                                              //         (values.panCardURL =
                                              //           event[0].base64)
                                              //       );
                                              //     } else {
                                              //       setFieldValue(
                                              //         (values.documentNameValidation = true)
                                              //       );
                                              //     }
                                              //   } else {
                                              //     setFieldValue(
                                              //       (values.documentNameValidation = false)
                                              //     );
                                              //     setFieldValue(
                                              //       (values.documentSizeCheckForPanCard = true)
                                              //     );
                                              //   }
                                              // }}
                                              onDone={(event) => {
                                                const file = event[0]; // FileBase64 gives an array
                                                if (!file) return;
                                                if (file) {
                                                  const fileName = file.name;
                                                  const fileSize =
                                                    file.file.size;
                                                  const base64 = file.base64;
                                                  const validExtensions = [
                                                    "jpg",
                                                    "jpeg",
                                                    "png",
                                                  ];
                                                  const ext = fileName
                                                    .split(".")
                                                    .pop()
                                                    .toLowerCase();
                                                  const maxSize = 1048576; // 1MB
                                                  // ❌ Invalid extension
                                                  if (
                                                    !validExtensions.includes(
                                                      ext,
                                                    )
                                                  ) {
                                                    warning(
                                                      `Invalid Image Format - Pan Card`,
                                                      warningNotification,
                                                    );
                                                    this.setState({
                                                      panCardFileKey:
                                                        Date.now(), // 🔑 force re-render FileBase64
                                                    });
                                                    return;
                                                  }
                                                  // ❌ Invalid size
                                                  if (fileSize > maxSize) {
                                                    warning(
                                                      `File size exceeds 1MB - Pan Card`,
                                                      warningNotification,
                                                    );
                                                    this.setState({
                                                      panCardFileKey:
                                                        Date.now(), // 🔑 reset
                                                    });
                                                    return;
                                                  }
                                                  // ❌ Double extensions (abc.jpg.png)
                                                  const regex = new RegExp(
                                                    `^[^.]+\\.(${validExtensions.join(
                                                      "|",
                                                    )})$`,
                                                    "i",
                                                  );
                                                  if (!regex.test(fileName)) {
                                                    warning(
                                                      `Only single extension is allowed - Pan Card`,
                                                      warningNotification,
                                                    );
                                                    this.setState({
                                                      panCardFileKey:
                                                        Date.now(), // 🔑 reset
                                                    });
                                                    return;
                                                  }
                                                  if (
                                                    !this.checkName(fileName)
                                                  ) {
                                                    warning(
                                                      `File/Document name can only contain
                                                      number, letter, hyphens, space. - Pan Card`,
                                                      warningNotification,
                                                    );
                                                    this.setState({
                                                      panCardFileKey:
                                                        Date.now(), // 🔑 reset
                                                    });
                                                    return;
                                                  }
                                                  // ❌ Invalid name
                                                  if (
                                                    !this.checkName(fileName)
                                                  ) {
                                                    this.setState({
                                                      documentNameValidation: true,
                                                      documentTypeCheckForPANImage: false,
                                                      documentSizeCheckForPanCard: false,
                                                      panCardFileKey:
                                                        Date.now(), // 🔑 reset
                                                    });
                                                    return;
                                                  }
                                                  // ✅ Passed all checks → Save file
                                                  const newDoc = {
                                                    documentHash: base64,
                                                    documentType: "PanCard",
                                                    documentName: fileName,
                                                  };
                                                  this.setState(
                                                    (prevState) => ({
                                                      document: [
                                                        ...prevState.document,
                                                        newDoc,
                                                      ],
                                                      panCardName: fileName,
                                                      panCardURL: base64,
                                                      documentTypeCheckForPANImage: false,
                                                      documentSizeCheckForPanCard: false,
                                                      documentNameValidation: false,
                                                      panCardFileKey:
                                                        Date.now(), // 🔑 reset so same file can still trigger
                                                    }),
                                                    () => {
                                                      this.updateCommonWeightage(
                                                        "panCardURL",
                                                        fileName,
                                                        this.state,
                                                      );
                                                    },
                                                  );
                                                }
                                              }}
                                            />
                                            <h4>Add PAN</h4>
                                          </span>
                                        </a>
                                        <h4 style={{ wordBreak: "break-all" }}>
                                          {values.panCardName
                                            ? ""
                                            : values.panpdfName
                                              ? values.panpdfName.split(
                                                  ".",
                                                )[1] == "pdf"
                                                ? values.panpdfName
                                                : ""
                                              : ""}
                                          {values.panCardName &&
                                          values.panCardName.split(".")[1] ==
                                            "pdf"
                                            ? "(" + values.panCardName + ")"
                                            : ""}
                                        </h4>
                                        <div className="col-md-12 col-sm-12">
                                          <span className="file-size-limit">
                                            The file should be in PNG/JPG
                                            format, with file-size less than
                                            1MB, with no special characters in
                                            the file-name
                                          </span>
                                        </div>
                                        {values.documentSizeCheckForPanCard ? (
                                          <p style={{ color: "red" }}>
                                            File Size is too large(Maximum File
                                            Size:1MB).
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                        {values.documentTypeCheckForPANImage ? (
                                          <p style={{ color: "red" }}>
                                            Invalid image format
                                          </p>
                                        ) : (
                                          ""
                                        )}

                                        {values.documentNameValidation ? (
                                          <p style={{ color: "red" }}>
                                            File/Document name can only contain
                                            number, letter, hyphens, space.
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>

                                    <div
                                      className="col-md-4 col-sm-4 col-xs-12"
                                      style={{ display: "none" }}
                                    >
                                      <label>
                                        Upload Aadhaar
                                        <span className="validation"> </span>
                                      </label>
                                      <div className="profile-detail">
                                        <div className="circle">
                                          <img
                                            className="profile-pic"
                                            src={values.aadharCardURL}
                                          />
                                          <div className="profile">
                                            <i
                                              className="fa fa-user"
                                              aria-hidden="true"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="profile-add">
                                        <a
                                          style={{
                                            pointerEvents: "none",
                                            cursor: "default",
                                          }}
                                        >
                                          <span className="icon btn-file text-center">
                                            <i
                                              className="fa fa-plus-circle"
                                              aria-hidden="true"
                                            />
                                            <FileBase64
                                              multiple={true}
                                              name="aadharCardURL"
                                              onChange={handleChange}
                                              onDone={(event) => {
                                                const checkType =
                                                  event[0].name.split(
                                                    /\.(?=[^\.]+$)/,
                                                  );

                                                if (
                                                  [
                                                    "jpg",
                                                    "JPG",
                                                    "jpeg",
                                                    "JPEG",
                                                    "png",
                                                    "PNG",
                                                    "pdf",
                                                  ].indexOf(checkType[1]) < 0
                                                ) {
                                                  setFieldValue(
                                                    (values.documentTypeCheckForAadharImage = true),
                                                  );
                                                } else if (
                                                  event[0].file.size <= 1000000
                                                ) {
                                                  if (
                                                    this.checkName(
                                                      event[0].name,
                                                    )
                                                  ) {
                                                    values.document.push({
                                                      documentHash:
                                                        event[0].base64,
                                                      documentType:
                                                        "AadharCard",
                                                      documentName:
                                                        event[0].name,
                                                    });
                                                    this.updateCommonWeightage(
                                                      "aadharCardURL",
                                                      event[0].name,
                                                      values,
                                                    );
                                                    setFieldValue(
                                                      (values.documentTypeCheckForAadharImage = false),
                                                    );
                                                    setFieldValue(
                                                      (values.documentSizeCheckForAadharCard = false),
                                                    );
                                                    setFieldValue(
                                                      (values.adharDocumentNameValidation = false),
                                                    );
                                                    setFieldValue(
                                                      (values.aadharCardDocumentName =
                                                        event[0].name),
                                                    );
                                                    setFieldValue(
                                                      (values.aadharCardURL =
                                                        event[0].base64),
                                                    );
                                                  } else {
                                                    setFieldValue(
                                                      (values.adharDocumentNameValidation = true),
                                                    );
                                                  }
                                                } else {
                                                  setFieldValue(
                                                    (values.adharDocumentNameValidation = false),
                                                  );
                                                  setFieldValue(
                                                    (values.documentSizeCheckForAadharCard = true),
                                                  );
                                                }
                                              }}
                                            />
                                            <h4 style={{ color: "black" }}>
                                              Add Aadhaar Front Part
                                            </h4>
                                          </span>
                                        </a>

                                        <h4 style={{ wordBreak: "break-all" }}>
                                          {values.aadharCardDocumentName
                                            ? ""
                                            : values.aadharpdfName
                                              ? values.aadharpdfName.split(
                                                  ".",
                                                )[1] == "pdf"
                                                ? values.aadharpdfName
                                                : ""
                                              : ""}
                                          {values.aadharCardDocumentName &&
                                          values.aadharCardDocumentName.split(
                                            ".",
                                          )[1] == "pdf"
                                            ? "(" +
                                              values.aadharCardDocumentName +
                                              ")"
                                            : ""}
                                        </h4>

                                        <div className="col-md-12 col-sm-12">
                                          <span className="file-size-limit">
                                            The file should be in PNG/JPG/PDF
                                            format, with file-size less than
                                            1MB, with no special characters in
                                            the file-name
                                          </span>
                                        </div>
                                        {values.documentSizeCheckForAadharCard ? (
                                          <p style={{ color: "red" }}>
                                            File Size is too large(Maximum File
                                            Size:1MB).
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                        {values.documentTypeCheckForAadharImage ? (
                                          <p style={{ color: "red" }}>
                                            Invalid image format
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                        {values.adharDocumentNameValidation ? (
                                          <p style={{ color: "red" }}>
                                            File/Document name can only contain
                                            number, letter, hyphens, space.
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>

                                    <div
                                      className="col-md-4 col-sm-4 col-xs-12"
                                      style={{ display: "none" }}
                                    >
                                      <label>
                                        Upload Aadhaar
                                        <span className="validation"> </span>
                                      </label>
                                      <div className="profile-detail">
                                        <div className="circle">
                                          <img
                                            className="profile-pic"
                                            src={values.BackaadharCardBackURL}
                                          />
                                          <div className="profile">
                                            <i
                                              className="fa fa-user"
                                              aria-hidden="true"
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div className="profile-add">
                                        <a
                                          style={{
                                            pointerEvents: "none",
                                            cursor: "default",
                                          }}
                                        >
                                          <span className="icon btn-file text-center">
                                            <i
                                              className="fa fa-plus-circle"
                                              aria-hidden="true"
                                            />
                                            <FileBase64
                                              multiple={true}
                                              name="AadharCardBackSide"
                                              onChange={handleChange}
                                              onDone={(event) => {
                                                const checkType =
                                                  event[0].name.split(
                                                    /\.(?=[^\.]+$)/,
                                                  );

                                                if (
                                                  [
                                                    "jpg",
                                                    "JPG",
                                                    "jpeg",
                                                    "JPEG",
                                                    "png",
                                                    "PNG",
                                                    "pdf",
                                                  ].indexOf(checkType[1]) < 0
                                                ) {
                                                  setFieldValue(
                                                    (values.documentTypeCheckForBackAadharImage = true),
                                                  );
                                                } else if (
                                                  event[0].file.size <= 1000000
                                                ) {
                                                  if (
                                                    this.checkName(
                                                      event[0].name,
                                                    )
                                                  ) {
                                                    values.document.push({
                                                      documentHash:
                                                        event[0].base64,
                                                      documentType:
                                                        "AadharCardBackSide",
                                                      documentName:
                                                        event[0].name,
                                                    });
                                                    this.updateCommonWeightage(
                                                      "BackaadharCardBackURL",
                                                      event[0].name,
                                                      values,
                                                    );
                                                    setFieldValue(
                                                      (values.documentTypeCheckForBackAadharImage = false),
                                                    );
                                                    setFieldValue(
                                                      (values.documentSizeCheckForBackAadharCard = false),
                                                    );
                                                    setFieldValue(
                                                      (values.BackadharDocumentNameValidation = false),
                                                    );
                                                    setFieldValue(
                                                      (values.BackaadharCardDocumentName =
                                                        event[0].name),
                                                    );
                                                    setFieldValue(
                                                      (values.BackaadharCardBackURL =
                                                        event[0].base64),
                                                    );
                                                  } else {
                                                    setFieldValue(
                                                      (values.BackadharDocumentNameValidation = true),
                                                    );
                                                  }
                                                } else {
                                                  setFieldValue(
                                                    (values.BackadharDocumentNameValidation = false),
                                                  );
                                                  setFieldValue(
                                                    (values.BackdocumentSizeCheckForAadharCard = true),
                                                  );
                                                }
                                              }}
                                            />
                                            <h4 style={{ color: "black" }}>
                                              Add Aadhaar Back Part
                                            </h4>
                                          </span>
                                        </a>
                                        <h4 style={{ wordBreak: "break-all" }}>
                                          {values.BackaadharCardDocumentName
                                            ? ""
                                            : values.backaadharpdfName
                                              ? values.backaadharpdfName.split(
                                                  ".",
                                                )[1] == "pdf"
                                                ? values.backaadharpdfName
                                                : ""
                                              : ""}
                                          {values.BackaadharCardDocumentName &&
                                          values.BackaadharCardDocumentName.split(
                                            ".",
                                          )[1] == "pdf"
                                            ? "(" +
                                              values.BackaadharCardDocumentName +
                                              ")"
                                            : ""}
                                        </h4>

                                        <div className="col-md-12 col-sm-12">
                                          <span className="file-size-limit">
                                            The file should be in PNG/JPG/PDF
                                            format, with file-size less than
                                            1MB, with no special characters in
                                            the file-name
                                          </span>
                                        </div>
                                        {values.documentSizeCheckForBackAadharCard ? (
                                          <p style={{ color: "red" }}>
                                            File Size is too large(Maximum File
                                            Size:1MB).
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                        {values.documentTypeCheckForBackAadharImage ? (
                                          <p style={{ color: "red" }}>
                                            Invalid image format
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                        {values.BackadharDocumentNameValidation ? (
                                          <p style={{ color: "red" }}>
                                            File/Document name can only contain
                                            number, letter, hyphens, space.
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>

                          {/* <UserAddressDetails /> */}
                          <section
                            className="create-address page-section profile-box"
                            style={{ display: "block" }}
                            id="create-address"
                          >
                            <h2 className="sub-header">Address Details</h2>
                            <div
                              className="address-border"
                              style={{ display: "block" }}
                            >
                              <div className="form-group">
                                <div className="row">
                                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                    <div className="row row-no-margin">
                                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                        <Field
                                          className="form-check-input"
                                          type="checkbox"
                                          name="addressTypeMark"
                                          style={{ marginRight: "10px" }}
                                          checked={values.addressTypeMark}
                                          onClick={(event) => {
                                            if (event.target.checked) {
                                              setFieldValue(
                                                "addressTypeMark",
                                                true,
                                              );
                                              this.setState({
                                                addressTypeMark: true,
                                              });
                                            } else {
                                              setFieldValue(
                                                "addressTypeMark",
                                                false,
                                              );
                                              this.setState({
                                                addressTypeMark: false,
                                              });
                                            }
                                          }}
                                        />
                                        <label
                                          className="form-check-label"
                                          for="gridCheck"
                                        >
                                          Mark, if this is your permanent
                                          address
                                        </label>
                                      </div>
                                    </div>{" "}
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                    <label>
                                      Current House Number{" "}
                                      <span className="validation"> *</span>
                                    </label>
                                    <Field
                                      type="text"
                                      name="perStreet"
                                      id="perStreet"
                                      maxLength="40"
                                      autoComplete="perStreet"
                                      disabled={values.disabledForCielops}
                                      value={values.perStreet || ""} // always bind to Formik value
                                      onChange={handleChange}
                                      onBlur={this.handleNormalizeOnBlur(
                                        "perStreet",
                                        setFieldValue,
                                        values,
                                      )}
                                      className={
                                        "form-control" +
                                        (errors.perStreet && touched.perStreet
                                          ? " is-invalid"
                                          : "")
                                      }
                                      placeholder="Current House Number"
                                    />
                                    {errors.perStreet && (
                                      <div className="validation">
                                        {errors.perStreet}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                    <label>Current Street</label>
                                    <Field
                                      type="text"
                                      name="perStreet2"
                                      id="perStreet2"
                                      maxLength="40"
                                      value={values.perStreet2 || ""} // always bind to Formik value
                                      disabled={values.disabledForCielops}
                                      onChange={handleChange}
                                      onBlur={this.handleNormalizeOnBlur(
                                        "perStreet2",
                                        setFieldValue,
                                        values,
                                      )}
                                      autoComplete="perStreet2"
                                      className={
                                        "form-control" +
                                        (errors.perStreet2 && touched.perStreet2
                                          ? " is-invalid"
                                          : "")
                                      }
                                      placeholder="Current Street"
                                    />
                                    {errors.perStreet2 && (
                                      <div className="validation">
                                        {errors.perStreet2}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                    <label>Current Town</label>
                                    <Field
                                      type="text"
                                      name="perStreet3"
                                      maxLength="40"
                                      id="perStreet3"
                                      value={values.perStreet3 || ""} // always bind to Formik value
                                      disabled={values.disabledForCielops}
                                      onChange={handleChange}
                                      onBlur={this.handleNormalizeOnBlur(
                                        "perStreet3",
                                        setFieldValue,
                                        values,
                                      )}
                                      autoComplete="perStreet3"
                                      className={
                                        "form-control" +
                                        (errors.perStreet3 && touched.perStreet3
                                          ? " is-invalid"
                                          : "")
                                      }
                                      placeholder="Current Town"
                                    />
                                    {errors.perStreet3 && (
                                      <div className="validation">
                                        {errors.perStreet3}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12" />
                                <div className="row">
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                    <label>
                                      Country
                                      <span className="validation"> *</span>
                                    </label>
                                    <Field
                                      as="select"
                                      name="percountryId"
                                      id="percountryId"
                                      disabled={values.disabledForCielops}
                                      value={values.percountryId || ""} // keep controlled by Formik
                                      onChange={(event) => {
                                        const countryId = event.target.value;

                                        if (countryId && countryId !== "") {
                                          // ✅ Country selected → reset state & city
                                          setFieldValue(
                                            "percountryId",
                                            countryId,
                                          );
                                          setFieldValue("perstateId", "");
                                          setFieldValue("percityId", "");
                                          setFieldValue("stateListForPer", []);
                                          setFieldValue("cityListForPer", []);

                                          this.setState({
                                            percountryId: countryId,
                                            perstateId: "",
                                            percityId: "",
                                            stateListForPer: [],
                                            cityListForPer: [],
                                          });

                                          // Fetch states for this country
                                          RegionManagementService.getState(
                                            "countryId=" + countryId,
                                            (res) => {
                                              const stateList =
                                                res?.responseListObject || [];
                                              setFieldValue(
                                                "stateListForPer",
                                                stateList,
                                              );
                                              this.setState({
                                                stateListForPer: stateList,
                                              });
                                            },
                                          );
                                        } else {
                                          // ❌ No country → reset all
                                          setFieldValue("percountryId", "");
                                          setFieldValue("perstateId", "");
                                          setFieldValue("percityId", "");
                                          setFieldValue("stateListForPer", []);
                                          setFieldValue("cityListForPer", []);

                                          this.setState({
                                            percountryId: "",
                                            perstateId: "",
                                            percityId: "",
                                            stateListForPer: [],
                                            cityListForPer: [],
                                          });
                                        }
                                      }}
                                      onBlur={this.handleNormalizeOnBlur(
                                        "percountryId",
                                        setFieldValue,
                                        values,
                                      )}
                                      className={
                                        "form-control" +
                                        (errors.percountryId &&
                                        touched.percountryId
                                          ? " is-invalid"
                                          : "")
                                      }
                                    >
                                      <option value="">---Select----</option>
                                      {(values.countryList || []).map((team) =>
                                        team.isActive ? (
                                          <option
                                            key={team.countryId}
                                            value={team.countryId}
                                          >
                                            {this.titleCase(team.countryName)}
                                          </option>
                                        ) : null,
                                      )}
                                    </Field>
                                    {errors.percountryId && (
                                      <div className="validation">
                                        {errors.percountryId}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                    <label>
                                      State{" "}
                                      <span className="validation"> *</span>
                                    </label>
                                    <Field
                                      as="select"
                                      name="perstateId"
                                      id="perstateId"
                                      disabled={values.disabledForCielops}
                                      value={values.perstateId || ""}
                                      onChange={(event) => {
                                        const selectedStateId =
                                          event.target.value;

                                        if (!selectedStateId) {
                                          // 🔹 If state removed → clear state + city
                                          setFieldValue("perstateId", "");
                                          setFieldValue("percityId", "");
                                          setFieldValue("cityListForPer", []);
                                          this.setState({
                                            perstateId: "",
                                            percityId: "",
                                            cityListForPer: [],
                                          });
                                          return;
                                        }

                                        // 🔹 If state changed → reset city
                                        if (
                                          selectedStateId !== values.perstateId
                                        ) {
                                          setFieldValue("percityId", "");
                                          this.setState({ percityId: "" });
                                        }

                                        // 🔹 Set new stateId in both
                                        setFieldValue(
                                          "perstateId",
                                          selectedStateId,
                                        );
                                        this.setState({
                                          perstateId: selectedStateId,
                                        });
                                        this.setState({ loading: true });
                                        // 🔹 Fetch cities for this state
                                        RegionManagementService.getCity(
                                          "stateId=" + selectedStateId,
                                          (res) => {
                                            if (res.status === "success") {
                                              setTimeout(() => {
                                                this.setState({
                                                  loading: false,
                                                });
                                              }, 650);
                                              const cities =
                                                res.responseListObject || [];
                                              setFieldValue(
                                                "cityListForPer",
                                                cities,
                                              );
                                              this.setState({
                                                cityListForPer: cities,
                                              });
                                            } else {
                                              setTimeout(() => {
                                                this.setState({
                                                  loading: false,
                                                });
                                              }, 650);
                                              warning(
                                                res.reasonText,
                                                warningNotification,
                                              );
                                              setFieldValue(
                                                "cityListForPer",
                                                [],
                                              );
                                              this.setState({
                                                cityListForPer: [],
                                              });
                                            }
                                          },
                                        );
                                      }}
                                      onBlur={this.handleNormalizeOnBlur(
                                        "perstateId",
                                        setFieldValue,
                                        values,
                                      )}
                                      className={
                                        "form-control" +
                                        (errors.perstateId && touched.perstateId
                                          ? " is-invalid"
                                          : "")
                                      }
                                    >
                                      <option value="">---Select----</option>
                                      {(values.stateListForPer || []).map(
                                        (team) => (
                                          <option
                                            key={team.stateId}
                                            value={team.stateId}
                                          >
                                            {this.titleCase(team.stateName)}
                                          </option>
                                        ),
                                      )}
                                    </Field>
                                    {errors.perstateId && (
                                      <div className="validation">
                                        {errors.perstateId}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                    <label>
                                      City
                                      <span className="validation"> *</span>
                                    </label>
                                    <Field
                                      as="select"
                                      name="percityId"
                                      id="percityId"
                                      disabled={values.disabledForCielops}
                                      value={values.percityId || ""}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        handleChange(e);
                                        setFieldValue("percityId", value);
                                        this.setState({
                                          percityId: value,
                                        });
                                      }}
                                      onBlur={this.handleNormalizeOnBlur(
                                        "percityId",
                                        setFieldValue,
                                        values,
                                      )}
                                      className={
                                        "form-control" +
                                        (errors.percityId && touched.percityId
                                          ? " is-invalid"
                                          : "")
                                      }
                                    >
                                      <option value="">---Select----</option>
                                      {(values.cityListForPer || []).map(
                                        (team) => (
                                          <option
                                            key={team.cityId}
                                            value={team.cityId}
                                          >
                                            {this.titleCase(team.cityName)}
                                          </option>
                                        ),
                                      )}
                                    </Field>
                                    {errors.percityId && (
                                      <div className="validation">
                                        {errors.percityId}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12" />
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                    <label>
                                      pin Code
                                      <span className="validation"> *</span>
                                    </label>
                                    <Field
                                      type="text"
                                      name="perPostalCode"
                                      id="perPostalCode"
                                      disabled={values.disabledForCielops}
                                      maxlength="6"
                                      value={values.perPostalCode || ""} // always bind to Formik value
                                      onChange={(event) => {
                                        handleChange(event);
                                        fetch(
                                          "https://api.postalpincode.in/pincode/" +
                                            event.target.value,
                                        )
                                          .then((response) => response.json())
                                          .then((records) => {
                                            if (
                                              records[0].Status === "Success"
                                            ) {
                                              setFieldValue(
                                                (values.perPostalCode =
                                                  event.target.value),
                                              );
                                              const value = event.target.value;
                                              this.setState({
                                                perPostalCode: value || "",
                                              }); // set "" when empty
                                              this.updateCommonWeightage(
                                                event.target.name,
                                                event.target.value,
                                                values,
                                              );
                                            } else {
                                              if (event.target.value === "") {
                                                setFieldValue(
                                                  (values.perPostalCode = ""),
                                                );
                                                const value =
                                                  event.target.value;
                                                this.setState({
                                                  perPostalCode: value || "",
                                                }); // set "" when empty
                                                this.updateCommonWeightage(
                                                  "perPostalCode",
                                                  "",
                                                  values,
                                                );
                                              } else {
                                                const value =
                                                  event.target.value;
                                                this.setState({
                                                  perPostalCode: value || "",
                                                }); // set "" when empty
                                              }
                                            }
                                          })
                                          .catch((error) => {});
                                      }}
                                      onBlur={this.handleNormalizeOnBlur(
                                        "perPostalCode",
                                        setFieldValue,
                                        values,
                                      )}
                                      autoComplete="perPostalCode"
                                      className={
                                        "form-control" +
                                        (errors.perPostalCode &&
                                        touched.perPostalCode
                                          ? " is-invalid"
                                          : "")
                                      }
                                      placeholder="PIN"
                                    />
                                    {errors.perPostalCode && (
                                      <div className="validation">
                                        {errors.perPostalCode}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                    {" "}
                                    <label>
                                      Proof Of Address
                                      <span className="validation"> *</span>
                                    </label>
                                    <Field
                                      as="select"
                                      name="peraddressproof1"
                                      id="peraddressproof1"
                                      value={values.peraddressproof1 || ""} // always bind to Formik value
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        handleChange(e);
                                        setFieldValue(
                                          "peraddressproof1",
                                          value,
                                        );
                                        this.setState({
                                          peraddressproof1: value,
                                        });
                                      }}
                                      onBlur={this.handleNormalizeOnBlur(
                                        "peraddressproof1",
                                        setFieldValue,
                                        values,
                                      )}
                                      className={
                                        "form-control" +
                                        (errors.peraddressproof1 &&
                                        touched.peraddressproof1
                                          ? " is-invalid"
                                          : "")
                                      }
                                    >
                                      <option value="">---Select----</option>
                                      {(this.state.AddressProof || []).map(
                                        (team) => {
                                          if (
                                            team.codeValue !==
                                            "Aadhar Front Side"
                                          ) {
                                            let date = "15.10.2024";
                                            let thresholdDate = moment(
                                              date,
                                              "DD.MM.YYYY",
                                            ); // Use correct date format (slashes)
                                            let createdDate = this.props
                                              .personnelData.createdDate
                                              ? moment(
                                                  this.props.personnelData
                                                    .createdDate,
                                                  "DD.MM.YYYY",
                                                )
                                              : null;

                                            // Condition to display 11022 only if createdDate is earlier than 15.10.2024
                                            let showOptionFor11022 =
                                              [11022, "11022"].includes(
                                                team.codeValueId,
                                              ) &&
                                              createdDate &&
                                              createdDate.diff(
                                                thresholdDate,
                                                "days",
                                              ) < 0; // Display if createdDate is earlier than thresholdDate

                                            // Return all other values normally, and conditionally show 11022
                                            return (
                                              (([11022, "11022"].includes(
                                                team.codeValueId,
                                              ) &&
                                                showOptionFor11022) ||
                                                ![11022, "11022"].includes(
                                                  team.codeValueId,
                                                )) && (
                                                <option
                                                  key={team.codeValueId}
                                                  value={team.codeValueId}
                                                >
                                                  {team.codeValue}
                                                </option>
                                              )
                                            );
                                          }
                                        },
                                      )}
                                    </Field>
                                    {errors.peraddressproof1 && (
                                      <div className="validation">
                                        {errors.peraddressproof1}
                                      </div>
                                    )}
                                    <span className="file-size-limit">
                                      {" "}
                                      Please choose one of the documents from
                                      the dropdown and attach a scanned image of
                                      the same{" "}
                                    </span>
                                    {[11024, "11024"].includes(
                                      values.peraddressproof1,
                                    ) && (
                                      <>
                                        <span className="file-size-limit">
                                          {" "}
                                          We will only be accepting Masked
                                          aadhar copies as Proof of Address.
                                          Please use the link{" "}
                                          <span
                                            onClick={() =>
                                              window.open(
                                                "https://myaadhaar.uidai.gov.in/",
                                              )
                                            }
                                            style={{
                                              color: "blue",
                                              textDecoration: "underline",
                                              cursor: "pointer",
                                            }}
                                          >
                                            https://myaadhaar.uidai.gov.in/
                                          </span>{" "}
                                          to download.{" "}
                                        </span>
                                        <span className="file-size-limit">
                                          <Field
                                            className="form-check-input"
                                            type="checkbox"
                                            name="maskedAadhaar"
                                            checked={values.maskedAadhaar}
                                            onClick={(event) => {
                                              if (event.target.checked) {
                                                setFieldValue(
                                                  "maskedAadhaar",
                                                  true,
                                                );
                                                this.setState({
                                                  maskedAadhaar: true,
                                                });
                                              } else {
                                                setFieldValue(
                                                  "maskedAadhaar",
                                                  false,
                                                );
                                                this.setState({
                                                  maskedAadhaar: false,
                                                });
                                              }
                                            }}
                                          />
                                          <span className="validation"> *</span>{" "}
                                          I understand and agree that the
                                          details of my Aadhaar are being used
                                          solely for NISM profile creation by
                                          CIEL, and I voluntarily provide the
                                          same to them. The document will be
                                          destroyed after the profile has been
                                          created.
                                        </span>
                                      </>
                                    )}
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                    <label>
                                      Upload Address Proof
                                      <span className="validation"> *</span>
                                    </label>
                                    <div className="profile-detail">
                                      <div className="circle">
                                        {values.addressProofCardURL && (
                                          <>
                                            <img
                                              className="profile-pic"
                                              src={values.addressProofCardURL}
                                            />
                                            <div className="profile">
                                              <i
                                                className="fa fa-user"
                                                aria-hidden="true"
                                              />
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                    <div className="profile-add">
                                      <a>
                                        <span className="icon btn-file text-center">
                                          <i
                                            className="fa fa-plus-circle"
                                            aria-hidden="true"
                                          />
                                          <FileBase64
                                            multiple={true}
                                            id={this.state.addressProofFileKey} // 👈 add key
                                            name="addressProofCardURL"
                                            onChange={handleChange}
                                            key={values.addressProofCardURL}
                                            // onDone={(event) => {
                                            //   const checkType =
                                            //     event[0].name.split(
                                            //       /\.(?=[^\.]+$)/
                                            //     );

                                            //   if (
                                            //     [
                                            //       "jpg",
                                            //       "JPG",
                                            //       "jpeg",
                                            //       "JPEG",
                                            //       "png",
                                            //       "PNG",
                                            //     ].indexOf(checkType[1]) < 0
                                            //   ) {
                                            //     setFieldValue(
                                            //       (values.documentTypeCheckForaddressProofCardURLImage = true)
                                            //     );
                                            //   } else if (
                                            //     event[0].file.size <= 1048576
                                            //   ) {
                                            //     if (
                                            //       this.checkName(event[0].name)
                                            //     ) {
                                            //       values.document.push({
                                            //         documentHash:
                                            //           event[0].base64,
                                            //         documentType:
                                            //           "AddressProof",
                                            //         documentName: event[0].name,
                                            //       });
                                            //       this.updateCommonWeightage(
                                            //         "addressProofCardURL",
                                            //         event[0].name,
                                            //         values
                                            //       );
                                            //       setFieldValue(
                                            //         (values.documentTypeCheckForaddressProofCardURLImage = false)
                                            //       );
                                            //       setFieldValue(
                                            //         (values.documentSizeCheckForaddressProofCardURLCard = false)
                                            //       );
                                            //       setFieldValue(
                                            //         (values.AressProofDocumentNameValidation = false)
                                            //       );

                                            //       setFieldValue(
                                            //         (values.addressProofCardURL =
                                            //           event[0].base64)
                                            //       );
                                            //       setFieldValue(
                                            //         (values.addressProofName =
                                            //           event[0].name)
                                            //       );
                                            //     } else {
                                            //       setFieldValue(
                                            //         (values.AressProofDocumentNameValidation = true)
                                            //       );
                                            //     }
                                            //   } else {
                                            //     setFieldValue(
                                            //       (values.AressProofDocumentNameValidation = false)
                                            //     );

                                            //     setFieldValue(
                                            //       (values.documentSizeCheckForaddressProofCardURL = true)
                                            //     );
                                            //   }
                                            // }}
                                            onDone={(event) => {
                                              const file = event[0]; // FileBase64 gives an array
                                              if (!file) return;
                                              if (file) {
                                                const fileName = file.name;
                                                const fileSize = file.file.size;
                                                const base64 = file.base64;
                                                const validExtensions = [
                                                  "jpg",
                                                  "jpeg",
                                                  "png",
                                                ];
                                                const ext = fileName
                                                  .split(".")
                                                  .pop()
                                                  .toLowerCase();
                                                const maxSize = 1048576; // 1MB
                                                // ❌ Invalid extension
                                                if (
                                                  !validExtensions.includes(ext)
                                                ) {
                                                  warning(
                                                    `Invalid Image Format - Address Proof`,
                                                    warningNotification,
                                                  );
                                                  this.setState({
                                                    addressProofFileKey:
                                                      Date.now(), // 🔑 force re-render FileBase64
                                                  });
                                                  return;
                                                }
                                                // ❌ Invalid size
                                                if (fileSize > maxSize) {
                                                  warning(
                                                    `File size exceeds 1MB - Address Proof`,
                                                    warningNotification,
                                                  );
                                                  this.setState({
                                                    addressProofFileKey:
                                                      Date.now(), // 🔑 reset
                                                  });
                                                  return;
                                                }
                                                // ❌ Double extensions (abc.jpg.png)
                                                const regex = new RegExp(
                                                  `^[^.]+\\.(${validExtensions.join(
                                                    "|",
                                                  )})$`,
                                                  "i",
                                                );
                                                if (!regex.test(fileName)) {
                                                  warning(
                                                    `Only single extension is allowed - Address Proof`,
                                                    warningNotification,
                                                  );
                                                  this.setState({
                                                    addressProofFileKey:
                                                      Date.now(), // 🔑 reset
                                                  });
                                                  return;
                                                }
                                                if (!this.checkName(fileName)) {
                                                  warning(
                                                    `File/Document name can only contain
                                                    number, letter, hyphens, space. - Address Proof`,
                                                    warningNotification,
                                                  );
                                                  this.setState({
                                                    addressProofFileKey:
                                                      Date.now(), // 🔑 reset
                                                  });
                                                  return;
                                                }
                                                // ❌ Invalid name
                                                if (!this.checkName(fileName)) {
                                                  this.setState({
                                                    AressProofDocumentNameValidation: true,
                                                    documentTypeCheckForaddressProofCardURLImage: false,
                                                    documentSizeCheckForaddressProofCardURL: false,
                                                    addressProofFileKey:
                                                      Date.now(), // 🔑 reset
                                                  });
                                                  return;
                                                }
                                                // ✅ Passed all checks → Save file
                                                const newDoc = {
                                                  documentHash: base64,
                                                  documentType: "AddressProof",
                                                  documentName: fileName,
                                                };
                                                this.setState(
                                                  (prevState) => ({
                                                    document: [
                                                      ...prevState.document,
                                                      newDoc,
                                                    ],
                                                    addressProofName: fileName,
                                                    addressProofCardURL: base64,
                                                    documentTypeCheckForaddressProofCardURLImage: false,
                                                    documentSizeCheckForaddressProofCardURL: false,
                                                    AressProofDocumentNameValidation: false,
                                                    addressProofFileKey:
                                                      Date.now(), // 🔑 reset so same file can still trigger
                                                  }),
                                                  () => {
                                                    this.updateCommonWeightage(
                                                      "addressProofCardURL",
                                                      fileName,
                                                      this.state,
                                                    );
                                                  },
                                                );
                                              }
                                            }}
                                          />
                                          <h4>Add Address Proof</h4>
                                          <h4
                                            style={{ wordBreak: "break-all" }}
                                          >
                                            {values.addressProofName
                                              ? ""
                                              : values.addressProofName1
                                                ? values.addressProofName1.split(
                                                    ".",
                                                  )[1] == "pdf"
                                                  ? values.addressProofName1
                                                  : ""
                                                : ""}
                                            {values.addressProofName &&
                                            values.addressProofName.split(
                                              ".",
                                            )[1] == "pdf"
                                              ? "(" +
                                                values.addressProofName +
                                                ")"
                                              : ""}
                                          </h4>
                                        </span>
                                      </a>
                                      <div className="col-md-12 col-sm-12">
                                        <span className="file-size-limit">
                                          The file should be in PNG/JPG format,
                                          with file-size less than 1MB, with no
                                          special characters in the file-name
                                        </span>
                                      </div>
                                      {values.documentSizeCheckForaddressProofCardURL ? (
                                        <p style={{ color: "red" }}>
                                          File Size is too large(Maximum File
                                          Size:1MB).
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                      {values.documentTypeCheckForaddressProofCardURLImage ? (
                                        <p style={{ color: "red" }}>
                                          Invalid image format
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                      {values.AressProofDocumentNameValidation ? (
                                        <p style={{ color: "red" }}>
                                          File/Document name can only contain
                                          number, letter, hyphens, space.
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                          {/* <OfficeAddressDetails /> */}
                          <section
                            className="create-address page-section profile-box"
                            id="office-address"
                            style={{ display: "block" }}
                          >
                            <h2 className="sub-header">
                              Office Address Details
                            </h2>
                            <div className="address-border">
                              <div className="form-group">
                                <div className="row">
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                    <label>
                                      Address 1{" "}
                                      <span className="validation"> *</span>
                                    </label>
                                    <Field
                                      type="text"
                                      name="officeStreet"
                                      id="officeStreet"
                                      disabled={values.disabledForCielops}
                                      maxLength={40}
                                      autoComplete="officeStreet"
                                      value={values.officeStreet || ""} // always bind to Formik value
                                      onChange={handleChange}
                                      onBlur={this.handleNormalizeOnBlur(
                                        "officeStreet",
                                        setFieldValue,
                                        values,
                                      )}
                                      className={
                                        "form-control" +
                                        (errors.officeStreet &&
                                        touched.officeStreet
                                          ? " is-invalid"
                                          : "")
                                      }
                                      placeholder="Address 1"
                                    />
                                    {errors.officeStreet && (
                                      <div className="validation">
                                        {errors.officeStreet}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                    <label>
                                      Address 2{" "}
                                      <span className="validation"> *</span>
                                    </label>
                                    <Field
                                      type="text"
                                      name="officeStreet2"
                                      id="officeStreet2"
                                      disabled={values.disabledForCielops}
                                      maxLength={40}
                                      value={values.officeStreet2 || ""} // always bind to Formik value
                                      onChange={handleChange}
                                      onBlur={this.handleNormalizeOnBlur(
                                        "officeStreet2",
                                        setFieldValue,
                                        values,
                                      )}
                                      autoComplete="officeStreet2"
                                      className={
                                        "form-control" +
                                        (errors.officeStreet2 &&
                                        touched.officeStreet2
                                          ? " is-invalid"
                                          : "")
                                      }
                                      placeholder="Address 2"
                                    />
                                    {errors.officeStreet2 && (
                                      <div className="validation">
                                        {errors.officeStreet2}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                    <label>
                                      Address 3{" "}
                                      <span className="validation"> *</span>
                                    </label>
                                    <Field
                                      type="text"
                                      name="officeStreet3"
                                      maxLength={40}
                                      id="officeStreet3"
                                      disabled={values.disabledForCielops}
                                      value={values.officeStreet3 || ""} // always bind to Formik value
                                      onChange={handleChange}
                                      onBlur={this.handleNormalizeOnBlur(
                                        "officeStreet3",
                                        setFieldValue,
                                        values,
                                      )}
                                      autoComplete="officeStreet3"
                                      className={
                                        "form-control" +
                                        (errors.officeStreet3 &&
                                        touched.officeStreet3
                                          ? " is-invalid"
                                          : "")
                                      }
                                      placeholder="Address 3"
                                    />
                                    {errors.officeStreet3 && (
                                      <div className="validation">
                                        {errors.officeStreet3}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12" />
                                <div className="row">
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                    <label>
                                      Country{" "}
                                      <span className="validation"> *</span>
                                    </label>
                                    <Field
                                      as="select"
                                      name="officecountryId"
                                      id="officecountryId"
                                      disabled={values.disabledForCielops}
                                      value={values.officecountryId || ""} // keep controlled with Formik
                                      onChange={(event) => {
                                        const countryId = event.target.value;

                                        if (countryId && countryId !== "") {
                                          // ✅ Country selected → reset state & city
                                          setFieldValue(
                                            "officecountryId",
                                            countryId,
                                          );
                                          setFieldValue("officestateId", "");
                                          setFieldValue("officecityId", "");
                                          setFieldValue(
                                            "stateListForOffice",
                                            [],
                                          );
                                          setFieldValue(
                                            "cityListForOffice",
                                            [],
                                          );

                                          this.setState({
                                            officecountryId: countryId,
                                            officestateId: "",
                                            officecityId: "",
                                            stateListForOffice: [],
                                            cityListForOffice: [],
                                          });

                                          // Fetch states for selected country
                                          RegionManagementService.getState(
                                            "countryId=" + countryId,
                                            (res) => {
                                              const stateList =
                                                res?.responseListObject || [];
                                              setFieldValue(
                                                "stateListForOffice",
                                                stateList,
                                              );
                                              this.setState({
                                                stateListForOffice: stateList,
                                              });
                                            },
                                          );
                                        } else {
                                          // ❌ No country → reset all
                                          setFieldValue("officecountryId", "");
                                          setFieldValue("officestateId", "");
                                          setFieldValue("officecityId", "");
                                          setFieldValue(
                                            "stateListForOffice",
                                            [],
                                          );
                                          setFieldValue(
                                            "cityListForOffice",
                                            [],
                                          );

                                          this.setState({
                                            officecountryId: "",
                                            officestateId: "",
                                            officecityId: "",
                                            stateListForOffice: [],
                                            cityListForOffice: [],
                                          });
                                        }
                                      }}
                                      onBlur={this.handleNormalizeOnBlur(
                                        "officecountryId",
                                        setFieldValue,
                                        values,
                                      )}
                                      className={
                                        "form-control" +
                                        (errors.officecountryId &&
                                        touched.officecountryId
                                          ? " is-invalid"
                                          : "")
                                      }
                                    >
                                      <option value="">---Select----</option>
                                      {values.countryList.map((team) =>
                                        team.isActive ? (
                                          <option
                                            key={team.countryId}
                                            value={team.countryId}
                                          >
                                            {this.titleCase(team.countryName)}
                                          </option>
                                        ) : null,
                                      )}
                                    </Field>
                                    {errors.officecountryId && (
                                      <div className="validation">
                                        {errors.officecountryId}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                    <label>
                                      State{" "}
                                      <span className="validation"> *</span>
                                    </label>
                                    <Field
                                      as="select"
                                      name="officestateId"
                                      id="officestateId"
                                      disabled={values.disabledForCielops}
                                      value={values.officestateId || ""}
                                      onChange={(event) => {
                                        const selectedStateId =
                                          event.target.value;

                                        if (!selectedStateId) {
                                          // 🔹 If state removed → clear everything
                                          setFieldValue("officestateId", "");
                                          setFieldValue("officecityId", "");
                                          setFieldValue(
                                            "cityListForOffice",
                                            [],
                                          );
                                          this.setState({
                                            officestateId: "",
                                            officecityId: "",
                                            cityListForOffice: [],
                                          });
                                          return;
                                        }

                                        // 🔹 If state changed → reset city
                                        if (
                                          selectedStateId !==
                                          values.officestateId
                                        ) {
                                          setFieldValue("officecityId", "");
                                          this.setState({ officecityId: "" });
                                        }

                                        // 🔹 Set state in Formik + local state
                                        setFieldValue(
                                          "officestateId",
                                          selectedStateId,
                                        );
                                        this.setState({
                                          officestateId: selectedStateId,
                                        });
                                        this.setState({ loading: true });
                                        // 🔹 Fetch cities
                                        RegionManagementService.getCity(
                                          "stateId=" + selectedStateId,
                                          (res) => {
                                            if (res.status === "success") {
                                              setTimeout(() => {
                                                this.setState({
                                                  loading: false,
                                                });
                                              }, 650);
                                              const cities =
                                                res.responseListObject || [];
                                              setFieldValue(
                                                "cityListForOffice",
                                                cities,
                                              );
                                              this.setState({
                                                cityListForOffice: cities,
                                              });
                                            } else {
                                              setTimeout(() => {
                                                this.setState({
                                                  loading: false,
                                                });
                                              }, 650);
                                              warning(
                                                res.reasonText,
                                                warningNotification,
                                              );
                                              setFieldValue(
                                                "cityListForOffice",
                                                [],
                                              );
                                              this.setState({
                                                cityListForOffice: [],
                                              });
                                            }
                                          },
                                        );
                                      }}
                                      onBlur={this.handleNormalizeOnBlur(
                                        "officestateId",
                                        setFieldValue,
                                        values,
                                      )}
                                      className={
                                        "form-control" +
                                        (errors.officestateId &&
                                        touched.officestateId
                                          ? " is-invalid"
                                          : "")
                                      }
                                    >
                                      <option value="">---Select----</option>
                                      {(values.stateListForOffice || []).map(
                                        (team) => (
                                          <option
                                            key={team.stateId}
                                            value={team.stateId}
                                          >
                                            {this.titleCase(team.stateName)}
                                          </option>
                                        ),
                                      )}
                                    </Field>
                                    {errors.officestateId && (
                                      <div className="validation">
                                        {errors.officestateId}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                    <label>
                                      City{" "}
                                      <span className="validation"> *</span>
                                    </label>
                                    <Field
                                      as="select"
                                      name="officecityId"
                                      id="officecityId"
                                      disabled={values.disabledForCielops}
                                      value={values.officecityId || ""}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        handleChange(e);
                                        setFieldValue("officecityId", value);
                                        this.setState({
                                          officecityId: value,
                                        });
                                      }}
                                      onBlur={this.handleNormalizeOnBlur(
                                        "officecityId",
                                        setFieldValue,
                                        values,
                                      )}
                                      className={
                                        "form-control" +
                                        (errors.officecityId &&
                                        touched.officecityId
                                          ? " is-invalid"
                                          : "")
                                      }
                                    >
                                      <option value="">---Select----</option>
                                      {(values.cityListForOffice || []).map(
                                        (team) => (
                                          <option
                                            key={team.cityId}
                                            value={team.cityId}
                                          >
                                            {this.titleCase(team.cityName)}
                                          </option>
                                        ),
                                      )}
                                    </Field>
                                    {errors.officecityId && (
                                      <div className="validation">
                                        {errors.officecityId}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12" />
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                    <label>
                                      Pin Code{" "}
                                      <span className="validation"> *</span>
                                    </label>
                                    <Field
                                      type="text"
                                      name="officePostalCode"
                                      id="officePostalCode"
                                      disabled={values.disabledForCielops}
                                      maxlength={6}
                                      value={values.officePostalCode || ""} // always bind to Formik value
                                      onChange={(event) => {
                                        handleChange(event);
                                        fetch(
                                          "https://api.postalpincode.in/pincode/" +
                                            event.target.value,
                                        )
                                          .then((response) => response.json())
                                          .then((records) => {
                                            if (
                                              records[0].Status === "Success"
                                            ) {
                                              setFieldValue(
                                                (values.officePostalCode =
                                                  event.target.value),
                                              );
                                              const value = event.target.value;
                                              this.setState({
                                                officePostalCode: value || "",
                                              }); // set "" when empty
                                              this.updateCommonWeightage(
                                                "officePostalCode",
                                                event.target.value,
                                                values,
                                              );
                                            } else {
                                              if (event.target.value === "") {
                                                setFieldValue(
                                                  (values.officePostalCode =
                                                    ""),
                                                );
                                                const value =
                                                  event.target.value;
                                                this.setState({
                                                  officePostalCode: value || "",
                                                }); // set "" when empty
                                                this.updateCommonWeightage(
                                                  "officePostalCode",
                                                  "",
                                                  values,
                                                );
                                              } else {
                                                const value =
                                                  event.target.value;
                                                this.setState({
                                                  officePostalCode: value || "",
                                                }); // set "" when empty
                                              }
                                            }
                                          })
                                          .catch((error) => {});
                                      }}
                                      onBlur={this.handleNormalizeOnBlur(
                                        "officePostalCode",
                                        setFieldValue,
                                        values,
                                      )}
                                      autoComplete="officePostalCode"
                                      className={
                                        "form-control" +
                                        (errors.officePostalCode &&
                                        touched.officePostalCode
                                          ? " is-invalid"
                                          : "")
                                      }
                                      placeholder="PIN Code"
                                    />
                                    {errors.officePostalCode && (
                                      <div className="validation">
                                        {errors.officePostalCode}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                          <section
                            className="create-qualification page-section profile-box"
                            id="educational-details"
                          >
                            <div className="row">
                              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <h2 className="sub-header">
                                  Educational Qualification Details
                                  <span className="validation">*</span> <br />
                                  <span
                                    className="file-size-limit"
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    Please put the latest Education
                                    Qualification first
                                  </span>
                                </h2>
                                <div className="">
                                  <FieldArray
                                    id="educationalQualification"
                                    name="learnerQualification"
                                    onChange={handleChange}
                                    render={(arrayHelpers) => (
                                      <div>
                                        {values.learnerQualification &&
                                        values.learnerQualification.length >
                                          0 ? (
                                          <div className="table-row">
                                            <table
                                              className="table table-bordered table-hover"
                                              id="tab_logic"
                                            >
                                              <thead>
                                                <tr>
                                                  <th className="text-center">
                                                    {" "}
                                                    University/College Name
                                                    <span className="validation">
                                                      {" "}
                                                      *
                                                    </span>
                                                  </th>
                                                  <th className="text-center">
                                                    {" "}
                                                    Degree
                                                    <span className="validation">
                                                      {" "}
                                                      *
                                                    </span>{" "}
                                                  </th>
                                                  <th className="text-center">
                                                    {" "}
                                                    Passing Year
                                                    <span className="validation">
                                                      {" "}
                                                      *
                                                    </span>
                                                  </th>
                                                  <th className="text-center">
                                                    {" "}
                                                    CGPA / Percentage{" "}
                                                    <span className="validation">
                                                      {" "}
                                                      *
                                                    </span>{" "}
                                                  </th>
                                                  <th className="text-center">
                                                    {" "}
                                                    Action{" "}
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {values.learnerQualification.map(
                                                  (friend, index) => (
                                                    <tr key={index}>
                                                      <td>
                                                        <Field
                                                          name={`learnerQualification.${index}.instituteName`}
                                                          className="form-control"
                                                          // onChange={
                                                          //   handleChange
                                                          // }
                                                          onChange={(e) => {
                                                            // Update Formik
                                                            handleChange(e);

                                                            // Update component state
                                                            let updated = [
                                                              ...this.state
                                                                .learnerQualification,
                                                            ];
                                                            updated[index] = {
                                                              ...updated[index],
                                                              instituteName:
                                                                e.target.value,
                                                            };
                                                            this.setState({
                                                              learnerQualification:
                                                                updated,
                                                            });
                                                          }}
                                                          placeholder="University/College Name"
                                                          disabled={
                                                            values.disabledForCielops
                                                          }
                                                          value={
                                                            friend.instituteName
                                                              ? friend.instituteName
                                                              : ""
                                                          }
                                                          maxLength={70}
                                                          onBlur={(event) => {
                                                            this.updateCommonWeightage(
                                                              "learnerQualificationinstituteName",
                                                              event.target
                                                                .value,
                                                              values,
                                                            );
                                                          }}
                                                        />
                                                      </td>

                                                      <td>
                                                        <Field
                                                          as="select"
                                                          name={`learnerQualification.${index}.qualificationType`}
                                                          className="form-control"
                                                          disabled={
                                                            values.disabledForCielops
                                                          }
                                                          onBlur={(event) => {
                                                            this.updateCommonWeightage(
                                                              "learnerQualificationqualificationType",
                                                              event.target
                                                                .value,
                                                              values,
                                                            );
                                                          }}
                                                          onChange={(e) => {
                                                            const { value } =
                                                              e.target;

                                                            // ✅ Update Formik
                                                            setFieldValue(
                                                              `learnerQualification.${index}.qualificationType`,
                                                              value,
                                                            );
                                                            if (
                                                              value ===
                                                                "Under Graduate" ||
                                                              value ===
                                                                "under Graduate"
                                                            ) {
                                                              setFieldValue(
                                                                `learnerQualification.${index}.passingYear`,
                                                                "",
                                                              );
                                                            } else {
                                                              setFieldValue(
                                                                `learnerQualification.${index}.persuingYear`,
                                                                "",
                                                              );
                                                            }

                                                            // ✅ Update component state
                                                            let updated = [
                                                              ...this.state
                                                                .learnerQualification,
                                                            ];
                                                            updated[index] = {
                                                              ...updated[index],
                                                              qualificationType:
                                                                value,
                                                              passingYear:
                                                                value ===
                                                                  "Under Graduate" ||
                                                                value ===
                                                                  "under Graduate"
                                                                  ? ""
                                                                  : updated[
                                                                      index
                                                                    ]
                                                                      .passingYear,
                                                              persuingYear:
                                                                value !==
                                                                  "Under Graduate" &&
                                                                value !==
                                                                  "under Graduate"
                                                                  ? ""
                                                                  : updated[
                                                                      index
                                                                    ]
                                                                      .persuingYear,
                                                            };
                                                            this.setState({
                                                              learnerQualification:
                                                                updated,
                                                            });
                                                          }}
                                                        >
                                                          <option value="">
                                                            Select Education
                                                          </option>
                                                          <option value="Below Higher Secondary">
                                                            Below Higher
                                                            Secondary
                                                          </option>
                                                          <option value="Higher Secondary/diploma">
                                                            Higher
                                                            Secondary/diploma{" "}
                                                          </option>
                                                          <option value="Graduate">
                                                            Graduate
                                                          </option>
                                                          <option value="Post Graduate">
                                                            Post Graduate
                                                          </option>
                                                        </Field>
                                                      </td>
                                                      <td>
                                                        <Field
                                                          as="select"
                                                          className="form-control"
                                                          name={`learnerQualification.${index}.passingYear`}
                                                          type="number"
                                                          disabled={
                                                            values.disabledForCielops
                                                              ? true
                                                              : friend.qualificationType ==
                                                                    "Under Graduate" ||
                                                                  friend.qualificationType ==
                                                                    "under Graduate"
                                                                ? true
                                                                : false
                                                          }
                                                          onChange={(e) => {
                                                            // Update Formik
                                                            handleChange(e);

                                                            // Update component state
                                                            let updated = [
                                                              ...this.state
                                                                .learnerQualification,
                                                            ];
                                                            updated[index] = {
                                                              ...updated[index],
                                                              passingYear:
                                                                e.target.value,
                                                            };
                                                            this.setState({
                                                              learnerQualification:
                                                                updated,
                                                            });
                                                          }}
                                                          value={
                                                            friend.qualificationType ==
                                                              "Under Graduate" ||
                                                            friend.qualificationType ==
                                                              "under Graduate"
                                                              ? ""
                                                              : friend.passingYear
                                                                ? friend.passingYear
                                                                : ""
                                                          }
                                                          onBlur={(event) => {
                                                            this.updateCommonWeightage(
                                                              "learnerQualificationpassingYear",
                                                              event.target
                                                                .value,
                                                              values,
                                                            );
                                                          }}
                                                        >
                                                          <option value="">
                                                            Select
                                                          </option>
                                                          {(
                                                            this.state
                                                              .listOfYear || []
                                                          ).map((year) => (
                                                            <option
                                                              value={year}
                                                            >
                                                              {year}
                                                            </option>
                                                          ))}
                                                        </Field>
                                                      </td>

                                                      <td>
                                                        <Field
                                                          type="number"
                                                          className="form-control"
                                                          disabled={
                                                            values.disabledForCielops
                                                          }
                                                          name={`learnerQualification.${index}.percentage`}
                                                          value={
                                                            friend.percentage
                                                              ? friend.percentage
                                                              : ""
                                                          }
                                                          onChange={(e) => {
                                                            // Update Formik
                                                            handleChange(e);

                                                            // Update component state
                                                            let updated = [
                                                              ...this.state
                                                                .learnerQualification,
                                                            ];
                                                            updated[index] = {
                                                              ...updated[index],
                                                              percentage:
                                                                e.target.value,
                                                            };
                                                            this.setState({
                                                              learnerQualification:
                                                                updated,
                                                            });
                                                          }}
                                                          placeholder="CGPA/Percentage"
                                                          onBlur={(event) => {
                                                            this.updateCommonWeightage(
                                                              "learnerQualificationpercentage",
                                                              event.target
                                                                .value,
                                                              values,
                                                            );
                                                          }}
                                                        />
                                                      </td>
                                                      <td>
                                                        <button
                                                          type="button"
                                                          disabled={
                                                            values.disabledForCielops
                                                          }
                                                          className="btn-8 ml-5 mr-5 mt-10"
                                                          onClick={() => {
                                                            arrayHelpers.insert(
                                                              index + 1,
                                                              "",
                                                            );
                                                          }}
                                                        >
                                                          <i
                                                            className="fa fa-plus"
                                                            aria-hidden="true"
                                                          />
                                                        </button>
                                                        <button
                                                          type="button"
                                                          disabled={
                                                            values.disabledForCielops
                                                          }
                                                          className="btn-8 ml-5 mr-5 mt-10"
                                                          onClick={() => {
                                                            arrayHelpers.remove(
                                                              index,
                                                            );
                                                          }}
                                                        >
                                                          <i
                                                            className="fa fa-minus"
                                                            aria-hidden="true"
                                                          />
                                                        </button>
                                                      </td>
                                                    </tr>
                                                  ),
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        ) : (
                                          <button
                                            type="button"
                                            className="btn-4"
                                            onClick={() => {
                                              arrayHelpers.push("");
                                            }}
                                          >
                                            Add Educational Qualification
                                          </button>
                                        )}
                                      </div>
                                    )}
                                  />
                                </div>
                              </div>
                              <p
                                className="hidden-md hidden-lg"
                                style={{ paddingLeft: "15px" }}
                              >
                                Scroll to the right for more fields.
                              </p>
                            </div>
                          </section>

                          <section
                            className="create-qualification page-section profile-box"
                            id="create-qualification"
                            style={{ display: "block" }}
                          >
                            <div className="row">
                              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <h2 className="sub-header">
                                  Occupation Details
                                  <span className="validation">*</span>
                                </h2>
                                <div className="">
                                  <FieldArray
                                    id="professionalQualification"
                                    name="professionalQualification"
                                    onChange={handleChange}
                                    render={(arrayHelpers1) => (
                                      <div>
                                        {values.professionalQualification &&
                                        values.professionalQualification
                                          .length > 0 ? (
                                          <div className="table-row table-responsive">
                                            <table
                                              className="table table-bordered table-hover"
                                              id="tab_logic"
                                            >
                                              <thead>
                                                <tr>
                                                  <th className="text-center">
                                                    {" "}
                                                    Occupation
                                                    <span className="validation">
                                                      {" "}
                                                      *
                                                    </span>
                                                  </th>
                                                  <th className="text-center">
                                                    {" "}
                                                    Company Name
                                                    <span className="validation">
                                                      {" "}
                                                      *
                                                    </span>
                                                    <a
                                                      href="#"
                                                      id="tooltip-icon"
                                                      data-toggle="tooltip"
                                                      lable="Name of Personal Assessment"
                                                      title=" 1. Fresher: In case you are a Fresher, then the rest of the fields in the row will be disabled. &#13;&#10;
                                                          2. Employed: Mention name of the current company. &#13;&#10;
                                                          3. Self Employed: Mention legal entity name under which you are conducting business.In case no name registered, mention “Self”. &#13;&#10;
                                                          4. Not Employed: Mention name of the last company you were employed"
                                                    >
                                                      <i
                                                        className="fa fa-info-circle"
                                                        aria-hidden="true"
                                                        style={{
                                                          fontSize: "14px",
                                                          paddingLeft: "5px",
                                                          paddingright: "8px",
                                                        }}
                                                      />{" "}
                                                    </a>
                                                  </th>
                                                  <th className="text-center">
                                                    {" "}
                                                    Designation{" "}
                                                    <span className="validation">
                                                      *
                                                    </span>
                                                  </th>
                                                  <th className="text-center">
                                                    {" "}
                                                    Total Experience (Years)
                                                    <span className="validation">
                                                      {" "}
                                                      *
                                                    </span>{" "}
                                                  </th>
                                                  <th className="text-center">
                                                    {" "}
                                                    Date of Joining
                                                    <span className="validation">
                                                      *
                                                    </span>
                                                  </th>
                                                  <th className="text-center">
                                                    {" "}
                                                    Action{" "}
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {values.professionalQualification.map(
                                                  (friend, index) => (
                                                    <tr key={index}>
                                                      <td>
                                                        <Field
                                                          as="select"
                                                          name={`professionalQualification.${index}.occupation`}
                                                          id="occupation"
                                                          className="form-control"
                                                          disabled={
                                                            values.disabledForCielops
                                                          }
                                                          value={
                                                            friend.occupation ||
                                                            ""
                                                          }
                                                          // onChange={(e) => {
                                                          //   if (
                                                          //     e.target.value ==
                                                          //     "1021"
                                                          //   ) {
                                                          //     if (
                                                          //       friend == ""
                                                          //     ) {
                                                          //       values.professionalQualification.splice(
                                                          //         index,
                                                          //         1
                                                          //       );
                                                          //       let obj = {};
                                                          //       obj[
                                                          //         "occupation"
                                                          //       ] = "";
                                                          //       obj[
                                                          //         "companyName"
                                                          //       ] = "";
                                                          //       obj[
                                                          //         "designation"
                                                          //       ] = "";

                                                          //       obj[
                                                          //         "totalExperience"
                                                          //       ] = "";

                                                          //       obj[
                                                          //         "dateOfJoining"
                                                          //       ] = "";

                                                          //       values.professionalQualification.push(
                                                          //         obj
                                                          //       );
                                                          //     }

                                                          //     setFieldValue(
                                                          //       (values.professionalQualification[
                                                          //         index
                                                          //       ].occupation =
                                                          //         e.target.value)
                                                          //     );

                                                          //     setFieldValue(
                                                          //       (values.professionalQualification[
                                                          //         index
                                                          //       ].totalExperience =
                                                          //         "0")
                                                          //     );

                                                          //     setFieldValue(
                                                          //       (values.professionalQualification[
                                                          //         index
                                                          //       ].dateOfJoining =
                                                          //         "0")
                                                          //     );

                                                          //     setFieldValue(
                                                          //       (values.professionalQualification[
                                                          //         index
                                                          //       ].companyName =
                                                          //         "")
                                                          //     );

                                                          //     setFieldValue(
                                                          //       (values.professionalQualification[
                                                          //         index
                                                          //       ].designation =
                                                          //         "")
                                                          //     );

                                                          //     setFieldValue(
                                                          //       (values.professionalQualification[
                                                          //         index
                                                          //       ].totalExperience =
                                                          //         "")
                                                          //     );
                                                          //   } else if (
                                                          //     e.target.value ==
                                                          //     "1025"
                                                          //   ) {
                                                          //     if (
                                                          //       friend == ""
                                                          //     ) {
                                                          //       values.professionalQualification.splice(
                                                          //         index,
                                                          //         1
                                                          //       );
                                                          //       let obj = {};
                                                          //       obj[
                                                          //         "occupation"
                                                          //       ] = "";
                                                          //       obj[
                                                          //         "companyName"
                                                          //       ] = "";
                                                          //       obj[
                                                          //         "designation"
                                                          //       ] = "";

                                                          //       obj[
                                                          //         "totalExperience"
                                                          //       ] = "";

                                                          //       obj[
                                                          //         "dateOfJoining"
                                                          //       ] = "";

                                                          //       values.professionalQualification.push(
                                                          //         obj
                                                          //       );
                                                          //     }

                                                          //     setFieldValue(
                                                          //       (values.professionalQualification[
                                                          //         index
                                                          //       ].occupation =
                                                          //         e.target.value)
                                                          //     );
                                                          //   } else if (
                                                          //     e.target.value ==
                                                          //       "1022" ||
                                                          //     e.target.value ==
                                                          //       "1024"
                                                          //   ) {
                                                          //     if (
                                                          //       friend == ""
                                                          //     ) {
                                                          //       values.professionalQualification.splice(
                                                          //         index,
                                                          //         1
                                                          //       );
                                                          //       let obj = {};
                                                          //       obj[
                                                          //         "occupation"
                                                          //       ] = "";
                                                          //       obj[
                                                          //         "companyName"
                                                          //       ] = "";
                                                          //       obj[
                                                          //         "designation"
                                                          //       ] = "";

                                                          //       obj[
                                                          //         "totalExperience"
                                                          //       ] = "";

                                                          //       obj[
                                                          //         "dateOfJoining"
                                                          //       ] = "";

                                                          //       values.professionalQualification.push(
                                                          //         obj
                                                          //       );
                                                          //     }
                                                          //     let date =
                                                          //       new Date();
                                                          //     let date1 =
                                                          //       moment(
                                                          //         date
                                                          //       ).format(
                                                          //         "D-M-YYYY"
                                                          //       );
                                                          //     setFieldValue(
                                                          //       (values.professionalQualification[
                                                          //         index
                                                          //       ].occupation =
                                                          //         e.target.value)
                                                          //     );
                                                          //   } else {
                                                          //     if (
                                                          //       values
                                                          //         .professionalQualification[
                                                          //         index
                                                          //       ] == ""
                                                          //     ) {
                                                          //       values.professionalQualification.splice(
                                                          //         index,
                                                          //         1
                                                          //       );
                                                          //       let obj = {};
                                                          //       obj[
                                                          //         "occupation"
                                                          //       ] = "";
                                                          //       obj[
                                                          //         "companyName"
                                                          //       ] = "";
                                                          //       obj[
                                                          //         "designation"
                                                          //       ] = "";

                                                          //       obj[
                                                          //         "totalExperience"
                                                          //       ] = "";

                                                          //       obj[
                                                          //         "dateOfJoining"
                                                          //       ] = "";

                                                          //       values.professionalQualification.push(
                                                          //         obj
                                                          //       );
                                                          //     }

                                                          //     setFieldValue(
                                                          //       (values.professionalQualification[
                                                          //         index
                                                          //       ].occupation =
                                                          //         e.target.value)
                                                          //     );
                                                          //   }
                                                          // }}
                                                          onChange={(e) => {
                                                            const value =
                                                              e.target.value;
                                                            const updated = [
                                                              ...this.state
                                                                .professionalQualification2,
                                                            ]; // copy state
                                                            let row = {
                                                              ...updated[index],
                                                            }; // current row copy

                                                            if (
                                                              value === "1021"
                                                            ) {
                                                              // Occupation 1021 → reset fields
                                                              row = {
                                                                ...row,
                                                                occupation:
                                                                  value,
                                                                companyName: "",
                                                                designation: "",
                                                                totalExperience:
                                                                  "",
                                                                dateOfJoining:
                                                                  "",
                                                              };

                                                              // ✅ Formik updates
                                                              setFieldValue(
                                                                `professionalQualification.${index}.occupation`,
                                                                value,
                                                              );
                                                              setFieldValue(
                                                                `professionalQualification.${index}.companyName`,
                                                                "",
                                                              );
                                                              setFieldValue(
                                                                `professionalQualification.${index}.designation`,
                                                                "",
                                                              );
                                                              setFieldValue(
                                                                `professionalQualification.${index}.totalExperience`,
                                                                "",
                                                              );
                                                              setFieldValue(
                                                                `professionalQualification.${index}.dateOfJoining`,
                                                                "",
                                                              );
                                                            } else if (
                                                              value === "1025"
                                                            ) {
                                                              // Occupation 1025 → just set occupation
                                                              row = {
                                                                ...row,
                                                                occupation:
                                                                  value,
                                                              };

                                                              setFieldValue(
                                                                `professionalQualification.${index}.occupation`,
                                                                value,
                                                              );
                                                            } else if (
                                                              value ===
                                                                "1022" ||
                                                              value === "1024"
                                                            ) {
                                                              // Occupation 1022/1024 → set today’s date
                                                              const today =
                                                                moment().format(
                                                                  "YYYY-MM-DD",
                                                                );

                                                              row = {
                                                                ...row,
                                                                occupation:
                                                                  value,
                                                                dateOfJoining:
                                                                  today,
                                                              };

                                                              setFieldValue(
                                                                `professionalQualification.${index}.occupation`,
                                                                value,
                                                              );
                                                              setFieldValue(
                                                                `professionalQualification.${index}.dateOfJoining`,
                                                                today,
                                                              );
                                                            } else {
                                                              // All other occupations → just update occupation
                                                              row = {
                                                                ...row,
                                                                occupation:
                                                                  value,
                                                              };

                                                              setFieldValue(
                                                                `professionalQualification.${index}.occupation`,
                                                                value,
                                                              );
                                                            }

                                                            // ✅ Update state
                                                            updated[index] =
                                                              row;
                                                            this.setState({
                                                              professionalQualification2:
                                                                updated,
                                                            });
                                                          }}
                                                          onBlur={(event) => {
                                                            this.updateCommonWeightage(
                                                              "professionalQualificationoccupation",
                                                              event.target
                                                                .value,
                                                              values,
                                                            );
                                                          }}
                                                        >
                                                          <option value="">
                                                            ---Select----
                                                          </option>
                                                          {(
                                                            this.state
                                                              .occupation || []
                                                          ).map((team) => (
                                                            <option
                                                              key={
                                                                team.codeValueId
                                                              }
                                                              value={
                                                                team.codeValueId
                                                              }
                                                            >
                                                              {team.codeValue}
                                                            </option>
                                                          ))}
                                                        </Field>
                                                      </td>
                                                      <td>
                                                        <Field
                                                          name={`professionalQualification.${index}.companyName`}
                                                          className="form-control"
                                                          disabled={
                                                            values.disabledForCielops ||
                                                            friend.occupation ===
                                                              "1021"
                                                          }
                                                          maxLength={250}
                                                          value={
                                                            friend.companyName ||
                                                            ""
                                                          }
                                                          onChange={(e) => {
                                                            const value =
                                                              e.target.value;

                                                            // Formik update
                                                            setFieldValue(
                                                              `professionalQualification.${index}.companyName`,
                                                              value,
                                                            );

                                                            // State update
                                                            const updated = [
                                                              ...this.state
                                                                .professionalQualification2,
                                                            ];
                                                            updated[index] = {
                                                              ...updated[index],
                                                              companyName:
                                                                value,
                                                            };
                                                            this.setState({
                                                              professionalQualification2:
                                                                updated,
                                                            });
                                                          }}
                                                          placeholder="Company Name"
                                                          onBlur={(event) => {
                                                            this.updateCommonWeightage(
                                                              "professionalQualificationcompanyName",
                                                              event.target
                                                                .value,
                                                              values,
                                                            );
                                                          }}
                                                        />
                                                      </td>
                                                      <td>
                                                        <Field
                                                          name={`professionalQualification.${index}.designation`}
                                                          className="form-control"
                                                          disabled={
                                                            values.disabledForCielops ||
                                                            friend.occupation ===
                                                              "1021"
                                                          }
                                                          maxLength={50}
                                                          value={
                                                            friend.designation ||
                                                            ""
                                                          }
                                                          onChange={(e) => {
                                                            const value =
                                                              e.target.value;

                                                            // Formik update
                                                            setFieldValue(
                                                              `professionalQualification.${index}.designation`,
                                                              value,
                                                            );

                                                            // State update
                                                            const updated = [
                                                              ...this.state
                                                                .professionalQualification2,
                                                            ];
                                                            updated[index] = {
                                                              ...updated[index],
                                                              designation:
                                                                value,
                                                            };
                                                            this.setState({
                                                              professionalQualification2:
                                                                updated,
                                                            });
                                                          }}
                                                          placeholder="Designation"
                                                          onBlur={(event) => {
                                                            this.updateCommonWeightage(
                                                              "professionalQualificationdesignation",
                                                              event.target
                                                                .value,
                                                              values,
                                                            );
                                                          }}
                                                        />
                                                      </td>

                                                      <td>
                                                        <Field
                                                          as="select"
                                                          id="totalExperience"
                                                          name={`professionalQualification.${index}.totalExperience`}
                                                          className="form-control"
                                                          disabled={
                                                            values.disabledForCielops ||
                                                            friend.occupation ===
                                                              "1021"
                                                          }
                                                          value={
                                                            friend.totalExperience ||
                                                            ""
                                                          }
                                                          onChange={(e) => {
                                                            const value =
                                                              e.target.value;

                                                            // Formik update
                                                            setFieldValue(
                                                              `professionalQualification.${index}.totalExperience`,
                                                              value,
                                                            );

                                                            // State update
                                                            const updated = [
                                                              ...this.state
                                                                .professionalQualification2,
                                                            ];
                                                            updated[index] = {
                                                              ...updated[index],
                                                              totalExperience:
                                                                value,
                                                            };
                                                            this.setState({
                                                              professionalQualification2:
                                                                updated,
                                                            });
                                                          }}
                                                          onBlur={(e) => {
                                                            this.updateCommonWeightage(
                                                              "professionalQualificationtotalExperience",
                                                              e.target.value,
                                                              values,
                                                            );
                                                          }}
                                                        >
                                                          <option value="">
                                                            ---Select----
                                                          </option>
                                                          {this.state.getExperienceList?.map(
                                                            (item) => (
                                                              <option
                                                                key={
                                                                  item.experienceValue
                                                                }
                                                                value={
                                                                  item.experienceValue
                                                                }
                                                              >
                                                                {
                                                                  item.experienceDisplay
                                                                }
                                                              </option>
                                                            ),
                                                          )}
                                                        </Field>
                                                      </td>
                                                      <td
                                                        style={{
                                                          display: "",
                                                          width: "150px",
                                                        }}
                                                      >
                                                        <Field
                                                          type="date"
                                                          name={`professionalQualification.${index}.dateOfJoining`}
                                                          id="dateOfJoining"
                                                          className="custom-input form-control"
                                                          style={{
                                                            paddingTop: "5px",
                                                          }}
                                                          disabled={
                                                            values.disabledForCielops ||
                                                            friend.occupation ===
                                                              "1021"
                                                          }
                                                          value={
                                                            friend.dateOfJoining ||
                                                            ""
                                                          }
                                                          onChange={(e) => {
                                                            const value =
                                                              e.target.value;

                                                            // Formik update
                                                            setFieldValue(
                                                              `professionalQualification.${index}.dateOfJoining`,
                                                              value,
                                                            );

                                                            // State update
                                                            const updated = [
                                                              ...this.state
                                                                .professionalQualification2,
                                                            ];
                                                            updated[index] = {
                                                              ...updated[index],
                                                              dateOfJoining:
                                                                value,
                                                            };
                                                            this.setState({
                                                              professionalQualification2:
                                                                updated,
                                                            });
                                                          }}
                                                          onBlur={(e) => {
                                                            this.updateCommonWeightage(
                                                              "professionalQualificationdateOfJoining",
                                                              e.target.value,
                                                              values,
                                                            );
                                                          }}
                                                        />
                                                      </td>
                                                      <td>
                                                        {values.professionalQualification &&
                                                        values
                                                          .professionalQualification
                                                          .length < 3 ? (
                                                          <button
                                                            type="button"
                                                            className="btn-8 ml-5 mr-5 mt-10"
                                                            disabled={
                                                              values.disabledForCielops
                                                            }
                                                            onClick={() => {
                                                              arrayHelpers1.insert(
                                                                index + 1,
                                                                "",
                                                              );
                                                            }}
                                                          >
                                                            <i
                                                              className="fa fa-plus"
                                                              aria-hidden="true"
                                                            />
                                                          </button>
                                                        ) : (
                                                          ""
                                                        )}
                                                        <button
                                                          type="button"
                                                          className="btn-8 ml-5 mr-5 mt-10"
                                                          disabled={
                                                            values.disabledForCielops
                                                          }
                                                          onClick={() => {
                                                            arrayHelpers1.remove(
                                                              index,
                                                            );
                                                          }}
                                                        >
                                                          <i
                                                            className="fa fa-minus"
                                                            aria-hidden="true"
                                                          />
                                                        </button>
                                                      </td>
                                                    </tr>
                                                  ),
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        ) : (
                                          <button
                                            type="button"
                                            className="btn-4"
                                            onClick={() => {
                                              arrayHelpers1.push("");
                                            }}
                                          >
                                            Add Occupation Details
                                          </button>
                                        )}
                                      </div>
                                    )}
                                  />
                                </div>
                              </div>
                              <p
                                className="hidden-md hidden-lg"
                                style={{ paddingLeft: "15px" }}
                              >
                                Scroll to the right for more fields.
                              </p>
                            </div>
                          </section>
                          {/* banking */}
                          <section
                            className="create-user page-section profile-box"
                            id="banking-details"
                            style={{ display: "none" }}
                          >
                            <div className="row">
                              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <h2 className="sub-header">Banking Details</h2>
                                <div className="form-group">
                                  <div className="row">
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        IFSC Code
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="ifscCode"
                                        pattern="[A-Z0-9]{11}"
                                        disabled={true}
                                        maxlength="11"
                                        autocapitalize="characters"
                                        onChange={(event) => {
                                          let ifscCode = event.target.value;
                                          ifscCode = ifscCode.toUpperCase();
                                          setFieldValue(
                                            (values.ifscCode = ifscCode),
                                          );
                                        }}
                                        onBlur={(event) => {
                                          fetch(
                                            "https://ifsc.razorpay.com/" +
                                              event.target.value,
                                          )
                                            .then((response) => response.json())
                                            .then((records) => {
                                              let arr = [
                                                "Vijaya Bank",
                                                "Dena Bank",
                                                "Syndicate Bank",
                                                "Allahabad Bank",
                                                "Oriental Bank of Commerce",
                                                "United Bank of India",
                                                "State Bank of Bikaner & Jaipur",
                                                "State Bank of Hyderabad",
                                                "State Bank of Indore",
                                                "State Bank of Mysore",
                                                "State Bank of Patiala",
                                                "State Bank of Saurashtra",
                                                "State Bank of Travancore",
                                                "Bhartiya Mahila Bank",
                                                "Andhra Bank",
                                                "Corporation Bank",
                                              ];
                                              if (
                                                arr.includes(records.BANK) ===
                                                false
                                              ) {
                                                this.updateCommonWeightage(
                                                  "bankName",
                                                  records.BANK,
                                                  values,
                                                );
                                                this.updateCommonWeightage(
                                                  "branch",
                                                  records.BRANCH.replace(
                                                    /r/g,
                                                    "",
                                                  ),
                                                  values,
                                                );
                                                this.updateCommonWeightage(
                                                  "branchAddress",
                                                  records.ADDRESS.replace(
                                                    /r/g,
                                                    "",
                                                  ),
                                                  values,
                                                );
                                                setFieldValue(
                                                  (values.bankName =
                                                    records.BANK),
                                                );
                                                setFieldValue(
                                                  (values.branch =
                                                    records.BRANCH),
                                                );
                                                setFieldValue(
                                                  (values.branchAddress =
                                                    records.ADDRESS),
                                                );
                                              } else {
                                                warning(
                                                  "IFSC code is Not in Use. This Bank is already merged in to another bank. Please use different IFSC Code",
                                                  warningNotification,
                                                );
                                                this.updateCommonWeightage(
                                                  "bankName",
                                                  "",
                                                  values,
                                                );
                                                this.updateCommonWeightage(
                                                  "branch",
                                                  "",
                                                  values,
                                                );
                                                this.updateCommonWeightage(
                                                  "branchAddress",
                                                  "",
                                                  values,
                                                );
                                                this.updateCommonWeightage(
                                                  "accountType",
                                                  "",
                                                  values,
                                                );
                                                this.updateCommonWeightage(
                                                  "acccountNumber",
                                                  "",
                                                  values,
                                                );

                                                setFieldValue(
                                                  (values.bankName = ""),
                                                );
                                                setFieldValue(
                                                  (values.branch = ""),
                                                );
                                                setFieldValue(
                                                  (values.branchAddress = ""),
                                                );
                                                setFieldValue(
                                                  (values.accountType = ""),
                                                );
                                                setFieldValue(
                                                  (values.acccountNumber = ""),
                                                );
                                              }
                                            })
                                            .catch((error) => {
                                              this.updateCommonWeightage(
                                                "bankName",
                                                "",
                                                values,
                                              );
                                              this.updateCommonWeightage(
                                                "branch",
                                                "",
                                                values,
                                              );
                                              this.updateCommonWeightage(
                                                "branchAddress",
                                                "",
                                                values,
                                              );
                                              this.updateCommonWeightage(
                                                "accountType",
                                                "",
                                                values,
                                              );
                                              this.updateCommonWeightage(
                                                "acccountNumber",
                                                "",
                                                values,
                                              );
                                              setFieldValue(
                                                (values.bankName = ""),
                                              );
                                              setFieldValue(
                                                (values.branch = ""),
                                              );
                                              setFieldValue(
                                                (values.branchAddress = ""),
                                              );
                                              setFieldValue(
                                                (values.accountType = ""),
                                              );
                                              setFieldValue(
                                                (values.acccountNumber = ""),
                                              );
                                            });
                                        }}
                                        className="form-control"
                                      />
                                      {errors.ifscCode && (
                                        <div className="validation">
                                          {errors.ifscCode}
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Name Of The Bank
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="bankName"
                                        disabled={true}
                                        onBlur={(event) => {}}
                                        className="form-control"
                                      />
                                      {errors.bankName && (
                                        <div className="validation">
                                          {errors.bankName}
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Branch
                                        <span className="validation"> *</span>
                                      </label>

                                      <Field
                                        type="text"
                                        name="branch"
                                        disabled={true}
                                        onBlur={(event) => {}}
                                        className="form-control"
                                      />
                                      {errors.branch && (
                                        <div className="validation">
                                          {errors.branch}
                                        </div>
                                      )}
                                    </div>

                                    <div className="col-md-12 col-sm-12 col-xs-12" />
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Branch Address
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="branchAddress"
                                        disabled={true}
                                        onBlur={(event) => {}}
                                        className="form-control"
                                      />
                                      {errors.branchAddress && (
                                        <div className="validation">
                                          {errors.branchAddress}
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Account Type
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        as="select"
                                        name="accountType"
                                        disabled={true}
                                        onBlur={(event) => {
                                          this.updateCommonWeightage(
                                            event.target.name,
                                            event.target.value,
                                            values,
                                          );
                                        }}
                                        className="form-control"
                                      >
                                        <option value="1">Saving</option>
                                        <option value="2">Current</option>
                                      </Field>
                                      {errors.accountType && (
                                        <div className="validation">
                                          {errors.accountType}
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Account Number
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="acccountNumber"
                                        minLength="9"
                                        maxlength="18"
                                        disabled={true}
                                        onBlur={(event) => {
                                          this.updateCommonWeightage(
                                            event.target.name,
                                            event.target.value,
                                            values,
                                          );
                                        }}
                                        className="form-control"
                                      />
                                      {errors.acccountNumber && (
                                        <div className="validation">
                                          {errors.acccountNumber}
                                        </div>
                                      )}
                                    </div>

                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>Upload Cheque Image</label>
                                      <div className="profile-detail">
                                        <div className="circle">
                                          <img
                                            className="profile-pic"
                                            src={values.chequePhotoURL}
                                          />
                                          <div className="profile">
                                            <i
                                              className="fa fa-user"
                                              aria-hidden="true"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="hidden-md hidden-lg hidden-sm col-xs-12">
                                        <div className="profile-add">
                                          <a
                                            className="icon btn-file"
                                            disabled={values.disabledForCielops}
                                          >
                                            <FileBase64
                                              multiple={true}
                                              onChange={handleChange}
                                              onDone={(event) => {
                                                if (
                                                  [
                                                    "image/jpg",
                                                    "image/jpeg",
                                                    "image/png",
                                                  ].indexOf(event[0].type) < 0
                                                ) {
                                                  setFieldValue(
                                                    (values.documentTypeCheckForChequeImage = true),
                                                  );
                                                } else if (
                                                  event[0].file.size <= 1000000
                                                ) {
                                                  if (
                                                    this.checkName(
                                                      event[0].name,
                                                    )
                                                  ) {
                                                    values.document.push({
                                                      documentHash:
                                                        event[0].base64,

                                                      documentType:
                                                        "ChequeImage",
                                                      documentName:
                                                        event[0].name,
                                                    });
                                                    setFieldValue(
                                                      (values.documentTypeCheckForChequeImage = false),
                                                    );
                                                    setFieldValue(
                                                      (values.documentSizeCheckForChequeCheck = false),
                                                    );
                                                    setFieldValue(
                                                      (values.chequeImageDocumentNameValidation = false),
                                                    );

                                                    values.chequePhotoURL =
                                                      event[0].base64;
                                                    setFieldValue(
                                                      (values.chequePhotoURL =
                                                        event[0].base64),
                                                    );
                                                  } else {
                                                    setFieldValue(
                                                      (values.chequeImageDocumentNameValidation = true),
                                                    );
                                                  }
                                                } else {
                                                  setFieldValue(
                                                    (values.chequeImageDocumentNameValidation = false),
                                                  );

                                                  setFieldValue(
                                                    (values.documentSizeCheckForChequeCheck = true),
                                                  );
                                                }
                                              }}
                                            />{" "}
                                          </a>

                                          <div className="col-md-12 col-sm-12"></div>
                                          {values.documentSizeCheckForChequeCheck ? (
                                            <p style={{ color: "red" }}>
                                              File Size is too large(Maximum
                                              File Size:1MB).
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                          {values.documentTypeCheckForChequeImage ? (
                                            <p style={{ color: "red" }}>
                                              Invalid image format
                                            </p>
                                          ) : (
                                            ""
                                          )}

                                          {values.chequeImageDocumentNameValidation ? (
                                            <p style={{ color: "red" }}>
                                              File/Document name can only
                                              contain number, letter, hyphens,
                                              space.
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-md-12 col-sm-12">
                                          <div className="profile-add">
                                            <a
                                              className="icon btn-file"
                                              style={{
                                                pointerEvents: "none",
                                                cursor: "default",
                                              }}
                                            >
                                              <i
                                                className="fa fa-plus-circle"
                                                aria-hidden="true"
                                              />
                                              <FileBase64
                                                multiple={true}
                                                onChange={handleChange}
                                                onDone={(event) => {
                                                  if (
                                                    [
                                                      "image/jpg",
                                                      "image/jpeg",
                                                      "image/png",
                                                    ].indexOf(event[0].type) < 0
                                                  ) {
                                                    setFieldValue(
                                                      (values.documentTypeCheckForChequeImage = true),
                                                    );
                                                  } else if (
                                                    event[0].file.size <=
                                                    1000000
                                                  ) {
                                                    if (
                                                      this.checkName(
                                                        event[0].name,
                                                      )
                                                    ) {
                                                      values.document.push({
                                                        documentHash:
                                                          event[0].base64,

                                                        documentName:
                                                          event[0].name,
                                                        documentType:
                                                          "ChequeImage",
                                                      });

                                                      setFieldValue(
                                                        (values.documentTypeCheckForChequeImage = false),
                                                      );
                                                      setFieldValue(
                                                        (values.documentSizeCheckForChequeCheck = false),
                                                      );
                                                      setFieldValue(
                                                        (values.chequeImageDocumentNameValidation = false),
                                                      );

                                                      values.chequePhotoURL =
                                                        event[0].base64;
                                                      setFieldValue(
                                                        (values.chequePhotoURL =
                                                          event[0].base64),
                                                      );
                                                    } else {
                                                      setFieldValue(
                                                        (values.chequeImageDocumentNameValidation = true),
                                                      );
                                                    }
                                                  } else {
                                                    setFieldValue(
                                                      (values.chequeImageDocumentNameValidation = false),
                                                    );

                                                    setFieldValue(
                                                      (values.documentSizeCheckForChequeCheck = true),
                                                    );
                                                  }
                                                }}
                                              />{" "}
                                              <h4 style={{ color: "black" }}>
                                                Add Image
                                              </h4>
                                            </a>

                                            <div className="col-md-12 col-sm-12">
                                              <span className="file-size-limit">
                                                Please upload your latest
                                                colored cheque image in
                                                jpg/jpeg, png format. <br />
                                                File Size: Max 1 MB
                                              </span>
                                            </div>
                                            {values.documentSizeCheckForChequeCheck ? (
                                              <p style={{ color: "red" }}>
                                                File Size is too large(Maximum
                                                File Size:1MB).
                                              </p>
                                            ) : (
                                              ""
                                            )}
                                            {values.documentTypeCheckForChequeImage ? (
                                              <p style={{ color: "red" }}>
                                                Invalid image format
                                              </p>
                                            ) : (
                                              ""
                                            )}
                                            {values.chequeImageDocumentNameValidation ? (
                                              <p style={{ color: "red" }}>
                                                File/Document name can only
                                                contain number, letter, hyphens,
                                                space.
                                              </p>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                          {/* CPE Details */}
                          <section
                            className="create-qualification page-section profile-box"
                            id="CPE-details"
                            style={
                              this.state.processType !== "1003"
                                ? { display: "none" }
                                : { display: "block" }
                            }
                          >
                            <div className="row">
                              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <h2 className="sub-header">
                                  NISM Certificate Details
                                </h2>

                                <div className="">
                                  <FieldArray
                                    name="CPEDetails"
                                    onChange={handleChange}
                                    render={(arrayHelpers1) => (
                                      <div>
                                        {values.CPEDetails &&
                                        values.CPEDetails.length > 0 ? (
                                          <div className="table-row">
                                            <table
                                              className="table table-bordered table-hover"
                                              id="tab_logic"
                                            >
                                              <thead>
                                                <tr>
                                                  <th className="text-center">
                                                    {" "}
                                                    Passing Certificate No.
                                                  </th>
                                                  <th className="text-center">
                                                    {" "}
                                                    Date Of Passing Test
                                                  </th>
                                                  <th className="text-center">
                                                    {" "}
                                                    CPE Certificate No.{" "}
                                                  </th>
                                                  <th className="text-center">
                                                    {" "}
                                                    Expiry Date Of CPE{" "}
                                                  </th>

                                                  <th className="text-center">
                                                    {" "}
                                                    Action{" "}
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {values.CPEDetails.map(
                                                  (friend, index) => (
                                                    <tr key={index}>
                                                      <td>
                                                        <Field
                                                          type="text"
                                                          disabled={
                                                            values.disabledForCielops
                                                          }
                                                          name={`CPEDetails.${index}.passingCertificateNo`}
                                                          onBlur={(event) => {
                                                            this.updateCommonWeightage(
                                                              "CPEDetailspassingCertificateNo",
                                                              event.target
                                                                .value,
                                                              values,
                                                            );
                                                          }}
                                                          className="form-control"
                                                        />

                                                        <ErrorMessage
                                                          name={`CPEDetails.${index}.passingCertificateNo`}
                                                          component="div"
                                                          className="validation"
                                                        />
                                                      </td>
                                                      <td>
                                                        <Field
                                                          type="date"
                                                          disabled={
                                                            values.disabledForCielops
                                                          }
                                                          name={`CPEDetails.${index}.dateOfPassingTest`}
                                                          onBlur={(event) => {
                                                            this.updateCommonWeightage(
                                                              "CPEDetailsdateOfPassingTest",
                                                              event.target
                                                                .value,
                                                              values,
                                                            );
                                                          }}
                                                          value={
                                                            moment(
                                                              moment(
                                                                friend.dateOfPassingTest,
                                                                "YYYY-MM-DD",
                                                              ).format(
                                                                "DD/MM/YYYY HH:mm:ss",
                                                              ),
                                                              "DD/MM/YYYY HH:mm:ss",
                                                            )
                                                              .format(
                                                                "YYYY-MM-DD[T]HH:mm:ss",
                                                              )
                                                              .split("T")[0]
                                                          }
                                                          className="custom-input"
                                                        />
                                                        <ErrorMessage
                                                          name={`CPEDetails.${index}.dateOfPassingTest`}
                                                          component="div"
                                                          className="validation"
                                                        />
                                                      </td>
                                                      <td>
                                                        <Field
                                                          type="text"
                                                          disabled={
                                                            values.disabledForCielops
                                                          }
                                                          name={`CPEDetails.${index}.cpeCertificateNo`}
                                                          className="form-control"
                                                          onBlur={(event) => {
                                                            this.updateCommonWeightage(
                                                              "CPEDetailscpeCertificateNo",
                                                              event.target
                                                                .value,
                                                              values,
                                                            );
                                                          }}
                                                        />
                                                        <ErrorMessage
                                                          name={`CPEDetails.${index}.cpeCertificateNo`}
                                                          component="div"
                                                          className="validation"
                                                        />
                                                      </td>

                                                      <td>
                                                        <Field
                                                          type="date"
                                                          disabled={
                                                            values.disabledForCielops
                                                          }
                                                          name={`CPEDetails.${index}.dateOfCpe`}
                                                          onBlur={(event) => {
                                                            this.updateCommonWeightage(
                                                              "PEDetailsdateOfCpe",
                                                              event.target
                                                                .value,
                                                              values,
                                                            );
                                                          }}
                                                          value={
                                                            moment(
                                                              moment(
                                                                friend.dateOfCpe,
                                                                "YYYY-MM-DD",
                                                              ).format(
                                                                "DD/MM/YYYY HH:mm:ss",
                                                              ),
                                                              "DD/MM/YYYY HH:mm:ss",
                                                            )
                                                              .format(
                                                                "YYYY-MM-DD[T]HH:mm:ss",
                                                              )
                                                              .split("T")[0]
                                                          }
                                                          className="custom-input"
                                                        />
                                                        <ErrorMessage
                                                          name={`CPEDetails.${index}.dateOfCpe`}
                                                          component="div"
                                                          className="validation"
                                                        />
                                                      </td>

                                                      <td>
                                                        <button
                                                          type="button"
                                                          className="btn-8 ml-5 mr-5 mt-10"
                                                          disabled={
                                                            values.disabledForCielops
                                                          }
                                                          onClick={() => {
                                                            arrayHelpers1.insert(
                                                              index + 1,
                                                              "",
                                                            );
                                                          }}
                                                        >
                                                          <i
                                                            className="fa fa-plus"
                                                            aria-hidden="true"
                                                          />
                                                        </button>
                                                        <button
                                                          type="button"
                                                          className="btn-8 ml-5 mr-5 mt-10"
                                                          disabled={
                                                            values.disabledForCielops
                                                          }
                                                          onClick={() => {
                                                            arrayHelpers1.remove(
                                                              index,
                                                            );
                                                          }}
                                                        >
                                                          <i
                                                            className="fa fa-minus"
                                                            aria-hidden="true"
                                                          />
                                                        </button>
                                                      </td>
                                                    </tr>
                                                  ),
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        ) : (
                                          <button
                                            type="button"
                                            className="btn-4"
                                            onClick={() => {
                                              arrayHelpers1.push("");
                                            }}
                                          >
                                            Add CPE Details
                                          </button>
                                        )}
                                      </div>
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                          </section>

                          {this.state.assignedUserMandateName !== undefined &&
                          this.state.assignedUserMandateName !== "NISM" &&
                          this.state?.newLearnerDetails?.learnerEuinOption &&
                          ![null, undefined, "null", "undefined"].includes(
                            this.state?.newLearnerDetails?.learnerEuinOption,
                          ) &&
                          this.state?.newLearnerDetails?.learnerEuinOption !==
                            "NISM" ? (
                            <section
                              className="create-parent page-section profile-box"
                              id="NISMCertificate"
                            >
                              <div className="row">
                                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                  <h2 className="sub-header">
                                    NISM Certificate Details
                                    <br />
                                    <span
                                      className="validation"
                                      style={{
                                        fontSize: "13px",
                                        textTransform: "capitalize",
                                        color: "#999",
                                      }}
                                    >
                                      THIS SECTION IS TO BE FILLED ONLY IF YOU
                                      ARE APPLYING FOR AN EUIN NUMBER (FRESH OR
                                      RENEWAL).
                                    </span>
                                  </h2>
                                  <h5>
                                    To apply for a fresh EUIN number, you must
                                    have a VALID NISM CERTIFCATE (valid for more
                                    than 6 months). Please fill VALID NISM
                                    certificate details below. The EUIN tab will
                                    get activated only if NISM certificate
                                    details filled below are VALID and not
                                    expired.
                                  </h5>
                                  <div className="address-border">
                                    <div className="form-group">
                                      <div className="row">
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          <label>
                                            NISM Certificate Number/ Enrollment
                                            Number{" "}
                                          </label>

                                          <Field
                                            type="text"
                                            name="certificateNumber"
                                            id="certificateNumber"
                                            maxlength="20"
                                            disabled={
                                              values.disabledForCielops === true
                                                ? false
                                                : this.state
                                                      .certificateNumber ===
                                                      "" ||
                                                    this.state
                                                      .certificateNumber ===
                                                      undefined
                                                  ? false
                                                  : true
                                            }
                                            onChange={(event) => {
                                              handleChange(event);
                                              let certificate =
                                                event.target.value;
                                              setFieldValue(
                                                (values.certificateNumber =
                                                  certificate),
                                              );
                                            }}
                                            autoComplete="certificateNumber"
                                            className="form-control"
                                            placeholder="NISM Certificate Number"
                                          />
                                          {errors.certificateNumber && (
                                            <div className="validation">
                                              {errors.certificateNumber}
                                            </div>
                                          )}
                                        </div>
                                        <div
                                          className="col-md-4 col-sm-4 col-xs-12"
                                          style={{ marginTop: "1.3em" }}
                                        >
                                          <label>Valid Upto</label>
                                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                            <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pl pr">
                                              <Field
                                                as="select"
                                                name="nismday"
                                                id="nismday"
                                                disabled={
                                                  values.disabledForCielops ===
                                                  true
                                                    ? false
                                                    : this.state
                                                          .certificateValidUpto ===
                                                          "" ||
                                                        this.state
                                                          .certificateValidUpto ===
                                                          undefined
                                                      ? false
                                                      : true
                                                }
                                                onChange={(e) => {
                                                  var listOfMonth = [];
                                                  setFieldValue(
                                                    (values.nismday =
                                                      e.target.value),
                                                  );
                                                  if (e.target.value == 31) {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },

                                                      { key: 3, value: "Mar" },

                                                      { key: 5, value: "May" },

                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },

                                                      { key: 10, value: "Oct" },

                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  } else if (
                                                    e.target.value == 30
                                                  ) {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },

                                                      { key: 3, value: "Mar" },
                                                      { key: 4, value: "Apr" },
                                                      { key: 5, value: "May" },
                                                      { key: 6, value: "Jun" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 9, value: "Sep" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 11, value: "Nov" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  } else if (
                                                    e.target.value == 28 ||
                                                    e.target.value == 29
                                                  ) {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },
                                                      { key: 2, value: "Feb" },
                                                      { key: 3, value: "Mar" },
                                                      { key: 4, value: "Apr" },
                                                      { key: 5, value: "May" },
                                                      { key: 6, value: "Jun" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 9, value: "Sep" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 11, value: "Nov" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  } else {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },
                                                      { key: 2, value: "Feb" },
                                                      { key: 3, value: "Mar" },
                                                      { key: 4, value: "Apr" },
                                                      { key: 5, value: "May" },
                                                      { key: 6, value: "Jun" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 9, value: "Sep" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 11, value: "Nov" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  }
                                                  setFieldValue(
                                                    (values.listOfMonth =
                                                      listOfMonth),
                                                  );
                                                }}
                                                className={
                                                  "form-control" +
                                                  (errors.nismday &&
                                                  touched.nismday
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                              >
                                                <option value="">DD</option>
                                                {(values.listOfDay || []).map(
                                                  (d) => (
                                                    <option value={d}>
                                                      {d}
                                                    </option>
                                                  ),
                                                )}
                                              </Field>
                                            </div>
                                            <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                              <Field
                                                as="select"
                                                name="nismmonth"
                                                id="nismmonth"
                                                disabled={
                                                  values.disabledForCielops ===
                                                  true
                                                    ? false
                                                    : this.state
                                                          .certificateValidUpto ===
                                                          "" ||
                                                        this.state
                                                          .certificateValidUpto ===
                                                          undefined
                                                      ? false
                                                      : true
                                                }
                                                onChange={(e) => {
                                                  setFieldValue(
                                                    (values.nismmonth =
                                                      e.target.value),
                                                  );
                                                  if (e.target.value == 2) {
                                                    var listOfDay = [];
                                                    for (
                                                      var i = 1;
                                                      i <= 29;
                                                      i++
                                                    ) {
                                                      listOfDay.push(i);
                                                    }
                                                  } else if (
                                                    e.target.value == 1 ||
                                                    e.target.value == 3 ||
                                                    e.target.value == 5 ||
                                                    e.target.value == 7 ||
                                                    e.target.value == 8 ||
                                                    e.target.value == 10 ||
                                                    e.target.value == 12
                                                  ) {
                                                    var listOfDay = [];
                                                    for (
                                                      var i = 1;
                                                      i <= 31;
                                                      i++
                                                    ) {
                                                      listOfDay.push(i);
                                                    }
                                                  } else {
                                                    var listOfDay = [];
                                                    for (
                                                      var i = 1;
                                                      i <= 30;
                                                      i++
                                                    ) {
                                                      listOfDay.push(i);
                                                    }
                                                  }
                                                  setFieldValue(
                                                    (values.listOfDay =
                                                      listOfDay),
                                                  );
                                                }}
                                                className={
                                                  "form-control" +
                                                  (errors.nismmonth &&
                                                  touched.nismmonth
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                              >
                                                <option value="">MM</option>
                                                {(values.listOfMonth || []).map(
                                                  (m) => (
                                                    <option value={m.key}>
                                                      {m.value}
                                                    </option>
                                                  ),
                                                )}
                                              </Field>
                                            </div>
                                            <div className="col-md-5 col-lg-5 col-sm-5 col-xs-5 pl pr">
                                              <Field
                                                as="select"
                                                name="nismyear"
                                                id="nismyear"
                                                className={
                                                  "form-control" +
                                                  (errors.nismyear &&
                                                  touched.nismyear
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                                disabled={
                                                  values.disabledForCielops ===
                                                  true
                                                    ? false
                                                    : this.state
                                                          .certificateValidUpto ===
                                                          "" ||
                                                        this.state
                                                          .certificateValidUpto ===
                                                          undefined
                                                      ? false
                                                      : true
                                                }
                                              >
                                                <option value="">YYYY</option>
                                                {(
                                                  this.state.certificateYear ||
                                                  []
                                                ).map((nismyear) => (
                                                  <option value={nismyear}>
                                                    {nismyear}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                          </div>

                                          {errors.certificateValidUpto && (
                                            <div className="validation">
                                              {errors.certificateValidUpto}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          <label style={{ marginBottom: 0 }}>
                                            Enrollment Number{" "}
                                          </label>
                                          <br />
                                          <span
                                            className="validation"
                                            style={{
                                              fontSize: "10px",
                                              color: "#999",
                                            }}
                                          >
                                            For office purpose only
                                          </span>
                                          <Field
                                            type="text"
                                            name="enrollmentNumber"
                                            id="enrollmentNumber"
                                            maxlength="20"
                                            disabled={
                                              values.disabledForCielops === true
                                                ? false
                                                : this.state
                                                      .enrollmentNumber ===
                                                      "" ||
                                                    this.state
                                                      .enrollmentNumber ===
                                                      undefined
                                                  ? false ||
                                                    this.state
                                                      ?.newLearnerDetails
                                                      ?.learnerEuinOption ===
                                                      "Fresh EUIN" ||
                                                    this.state
                                                      ?.newLearnerDetails
                                                      ?.learnerEuinOption ===
                                                      "Only EUIN Renewal"
                                                  : true
                                            }
                                            onChange={(event) => {
                                              handleChange(event);
                                              let certificate =
                                                event.target.value;
                                              setFieldValue(
                                                (values.enrollmentNumber =
                                                  certificate),
                                              );
                                            }}
                                            autoComplete="enrollmentNumber"
                                            className="form-control"
                                            placeholder="Enrollment Number"
                                          />
                                          {errors.enrollmentNumber && (
                                            <div className="validation">
                                              {errors.enrollmentNumber}
                                            </div>
                                          )}
                                        </div>
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          <label style={{ marginBottom: 0 }}>
                                            Enrollment Date
                                          </label>
                                          <br />
                                          <span
                                            className="validation"
                                            style={{
                                              fontSize: "10px",
                                              color: "#999",
                                            }}
                                          >
                                            For office purpose only
                                          </span>
                                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                            <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pl pr">
                                              <Field
                                                as="select"
                                                name="enrollmentday"
                                                id="enrollmentday"
                                                disabled={
                                                  values.disabledForCielops ===
                                                  true
                                                    ? false
                                                    : this.state
                                                          .enrollmentDate ===
                                                          "" ||
                                                        this.state
                                                          .enrollmentDate ===
                                                          undefined
                                                      ? false ||
                                                        this.state
                                                          .newLearnerDetails
                                                          .learnerEuinOption ===
                                                          "Fresh EUIN" ||
                                                        this.state
                                                          .newLearnerDetails
                                                          .learnerEuinOption ===
                                                          "Only EUIN Renewal"
                                                      : true
                                                }
                                                onChange={(e) => {
                                                  var listOfMonth = [];
                                                  setFieldValue(
                                                    (values.enrollmentday =
                                                      e.target.value),
                                                  );
                                                  if (e.target.value == 31) {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },

                                                      { key: 3, value: "Mar" },

                                                      { key: 5, value: "May" },

                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },

                                                      { key: 10, value: "Oct" },

                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  } else if (
                                                    e.target.value == 30
                                                  ) {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },

                                                      { key: 3, value: "Mar" },
                                                      { key: 4, value: "Apr" },
                                                      { key: 5, value: "May" },
                                                      { key: 6, value: "Jun" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 9, value: "Sep" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 11, value: "Nov" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  } else if (
                                                    e.target.value == 28 ||
                                                    e.target.value == 29
                                                  ) {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },
                                                      { key: 2, value: "Feb" },
                                                      { key: 3, value: "Mar" },
                                                      { key: 4, value: "Apr" },
                                                      { key: 5, value: "May" },
                                                      { key: 6, value: "Jun" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 9, value: "Sep" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 11, value: "Nov" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  } else {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },
                                                      { key: 2, value: "Feb" },
                                                      { key: 3, value: "Mar" },
                                                      { key: 4, value: "Apr" },
                                                      { key: 5, value: "May" },
                                                      { key: 6, value: "Jun" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 9, value: "Sep" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 11, value: "Nov" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  }
                                                  setFieldValue(
                                                    (values.listOfMonth =
                                                      listOfMonth),
                                                  );
                                                }}
                                                className={
                                                  "form-control" +
                                                  (errors.enrollmentday &&
                                                  touched.enrollmentday
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                              >
                                                <option value="">DD</option>
                                                {(values.listOfDay || []).map(
                                                  (d) => (
                                                    <option value={d}>
                                                      {d}
                                                    </option>
                                                  ),
                                                )}
                                              </Field>
                                            </div>
                                            <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                              <Field
                                                as="select"
                                                name="enrollmentmonth"
                                                id="enrollmentmonth"
                                                disabled={
                                                  values.disabledForCielops ===
                                                  true
                                                    ? false
                                                    : this.state
                                                          .enrollmentDate ===
                                                          "" ||
                                                        this.state
                                                          .enrollmentDate ===
                                                          undefined
                                                      ? false ||
                                                        this.state
                                                          .newLearnerDetails
                                                          .learnerEuinOption ===
                                                          "Fresh EUIN" ||
                                                        this.state
                                                          .newLearnerDetails
                                                          .learnerEuinOption ===
                                                          "Only EUIN Renewal"
                                                      : true
                                                }
                                                onChange={(e) => {
                                                  setFieldValue(
                                                    (values.enrollmentmonth =
                                                      e.target.value),
                                                  );
                                                  if (e.target.value == 2) {
                                                    var listOfDay = [];
                                                    for (
                                                      var i = 1;
                                                      i <= 29;
                                                      i++
                                                    ) {
                                                      listOfDay.push(i);
                                                    }
                                                  } else if (
                                                    e.target.value == 1 ||
                                                    e.target.value == 3 ||
                                                    e.target.value == 5 ||
                                                    e.target.value == 7 ||
                                                    e.target.value == 8 ||
                                                    e.target.value == 10 ||
                                                    e.target.value == 12
                                                  ) {
                                                    var listOfDay = [];
                                                    for (
                                                      var i = 1;
                                                      i <= 31;
                                                      i++
                                                    ) {
                                                      listOfDay.push(i);
                                                    }
                                                  } else {
                                                    var listOfDay = [];
                                                    for (
                                                      var i = 1;
                                                      i <= 30;
                                                      i++
                                                    ) {
                                                      listOfDay.push(i);
                                                    }
                                                  }
                                                  setFieldValue(
                                                    (values.listOfDay =
                                                      listOfDay),
                                                  );
                                                }}
                                                className={
                                                  "form-control" +
                                                  (errors.enrollmentmonth &&
                                                  touched.enrollmentmonth
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                              >
                                                <option value="">MM</option>
                                                {(values.listOfMonth || []).map(
                                                  (m) => (
                                                    <option value={m.key}>
                                                      {m.value}
                                                    </option>
                                                  ),
                                                )}
                                              </Field>
                                            </div>
                                            <div className="col-md-5 col-lg-5 col-sm-5 col-xs-5 pl pr">
                                              <Field
                                                as="select"
                                                name="enrollmentyear"
                                                id="enrollmentyear"
                                                className={
                                                  "form-control" +
                                                  (errors.enrollmentyear &&
                                                  touched.enrollmentyear
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                                disabled={
                                                  values.disabledForCielops ===
                                                  true
                                                    ? false
                                                    : this.state
                                                          .enrollmentDate ===
                                                          "" ||
                                                        this.state
                                                          .enrollmentDate ===
                                                          undefined
                                                      ? false ||
                                                        this.state
                                                          .newLearnerDetails
                                                          .learnerEuinOption ===
                                                          "Fresh EUIN" ||
                                                        this.state
                                                          .newLearnerDetails
                                                          .learnerEuinOption ===
                                                          "Only EUIN Renewal"
                                                      : true
                                                }
                                              >
                                                <option value="">YYYY</option>
                                                {(
                                                  this.state.certificateYear ||
                                                  []
                                                ).map((enrollmentyear) => (
                                                  <option
                                                    value={enrollmentyear}
                                                  >
                                                    {enrollmentyear}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                          </div>

                                          {errors.enrollmentDate && (
                                            <div className="validation">
                                              {errors.enrollmentDate}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          ) : (
                            ""
                          )}

                          {this.state.assignedUserMandateName !== undefined &&
                          this.state.assignedUserMandateName !== "NISM" &&
                          this.state?.newLearnerDetails?.learnerEuinOption &&
                          ![null, undefined, "null", "undefined"].includes(
                            this.state?.newLearnerDetails?.learnerEuinOption,
                          ) &&
                          this.state?.newLearnerDetails?.learnerEuinOption !==
                            "NISM" ? (
                            <section
                              className="create-parent page-section profile-box"
                              id="EUINDetails"
                            >
                              <div className="row">
                                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                  <h2 className="sub-header">
                                    EUIN Details
                                    <br />
                                    <span
                                      className="validation"
                                      style={{
                                        fontSize: "13px",
                                        textTransform: "capitalize",
                                        color: "#999",
                                      }}
                                    >
                                      THIS SECTION IS TO BE FILLED ONLY IF YOU
                                      WANT TO RENEW YOUR EXISTING EUIN NUMBER.
                                    </span>
                                  </h2>
                                  <h5>
                                    <p>
                                      To renew your existing EUIN, you need to
                                      provide us with your EUIN number. EUIN
                                      number can be renewed only when you have
                                      renewed your NISM certificate.
                                    </p>
                                    <p>
                                      Please note in case your EUIN is not
                                      mapped to your current organisation, you
                                      will need to fill a physical mapping and
                                      renewal form and send it to CIEL office.
                                      You could write to us at
                                      euinsupport@ciel.co.in for any queries.
                                    </p>
                                  </h5>
                                  <div className="address-border">
                                    <div className="form-group">
                                      <div className="row">
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          <label>EUIN Number </label>
                                          <Field
                                            type="text"
                                            name="euinNumber"
                                            id="euinNumber"
                                            maxlength="20"
                                            disabled={
                                              values.disabledForCielops === true
                                                ? false
                                                : this.state.euinNumber ===
                                                      "" ||
                                                    this.state.euinNumber ===
                                                      undefined
                                                  ? false
                                                  : true
                                            }
                                            onChange={handleChange}
                                            className={
                                              "form-control" +
                                              (errors.euinNumber &&
                                              touched.euinNumber
                                                ? " is-invalid"
                                                : "")
                                            }
                                            placeholder="EUIN Number"
                                          />
                                          {errors.euinNumber && (
                                            <div className="validation">
                                              {errors.euinNumber}
                                            </div>
                                          )}
                                        </div>
                                        <div
                                          className="col-md-4 col-sm-4 col-xs-12"
                                          style={{ visibility: "hidden" }}
                                        >
                                          <label>Valid Upto</label>
                                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                            <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pl pr">
                                              <Field
                                                as="select"
                                                name="euinday"
                                                id="euinday"
                                                disabled={
                                                  values.disabledForCielops ===
                                                  true
                                                    ? false
                                                    : this.props.personnelData
                                                          .euinValidUpto ===
                                                          "" ||
                                                        this.props.personnelData
                                                          .euinValidUpto ===
                                                          undefined
                                                      ? false
                                                      : true
                                                }
                                                onChange={(e) => {
                                                  var listOfMonth = [];
                                                  setFieldValue(
                                                    (values.euinday =
                                                      e.target.value),
                                                  );
                                                  if (e.target.value == 31) {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },

                                                      { key: 3, value: "Mar" },

                                                      { key: 5, value: "May" },

                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },

                                                      { key: 10, value: "Oct" },

                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  } else if (
                                                    e.target.value == 30
                                                  ) {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },

                                                      { key: 3, value: "Mar" },
                                                      { key: 4, value: "Apr" },
                                                      { key: 5, value: "May" },
                                                      { key: 6, value: "Jun" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 9, value: "Sep" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 11, value: "Nov" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  } else if (
                                                    e.target.value == 28 ||
                                                    e.target.value == 29
                                                  ) {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },
                                                      { key: 2, value: "Feb" },
                                                      { key: 3, value: "Mar" },
                                                      { key: 4, value: "Apr" },
                                                      { key: 5, value: "May" },
                                                      { key: 6, value: "Jun" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 9, value: "Sep" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 11, value: "Nov" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  } else {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },
                                                      { key: 2, value: "Feb" },
                                                      { key: 3, value: "Mar" },
                                                      { key: 4, value: "Apr" },
                                                      { key: 5, value: "May" },
                                                      { key: 6, value: "Jun" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 9, value: "Sep" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 11, value: "Nov" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  }
                                                  setFieldValue(
                                                    (values.listOfMonth =
                                                      listOfMonth),
                                                  );
                                                }}
                                                className={
                                                  "form-control" +
                                                  (errors.euinday &&
                                                  touched.euinday
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                              >
                                                <option value="">DD</option>
                                                {(values.listOfDay || []).map(
                                                  (d) => (
                                                    <option value={d}>
                                                      {d}
                                                    </option>
                                                  ),
                                                )}
                                              </Field>
                                            </div>
                                            <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                              <Field
                                                as="select"
                                                name="euinmonth"
                                                id="euinmonth"
                                                disabled={
                                                  values.disabledForCielops ===
                                                  true
                                                    ? false
                                                    : this.props.personnelData
                                                          .euinValidUpto ===
                                                          "" ||
                                                        this.props.personnelData
                                                          .euinValidUpto ===
                                                          undefined
                                                      ? false
                                                      : true
                                                }
                                                onChange={(e) => {
                                                  setFieldValue(
                                                    (values.euinmonth =
                                                      e.target.value),
                                                  );
                                                  if (e.target.value == 2) {
                                                    var listOfDay = [];
                                                    for (
                                                      var i = 1;
                                                      i <= 29;
                                                      i++
                                                    ) {
                                                      listOfDay.push(i);
                                                    }
                                                  } else if (
                                                    e.target.value == 1 ||
                                                    e.target.value == 3 ||
                                                    e.target.value == 5 ||
                                                    e.target.value == 7 ||
                                                    e.target.value == 8 ||
                                                    e.target.value == 10 ||
                                                    e.target.value == 12
                                                  ) {
                                                    var listOfDay = [];
                                                    for (
                                                      var i = 1;
                                                      i <= 31;
                                                      i++
                                                    ) {
                                                      listOfDay.push(i);
                                                    }
                                                  } else {
                                                    var listOfDay = [];
                                                    for (
                                                      var i = 1;
                                                      i <= 30;
                                                      i++
                                                    ) {
                                                      listOfDay.push(i);
                                                    }
                                                  }
                                                  setFieldValue(
                                                    (values.listOfDay =
                                                      listOfDay),
                                                  );
                                                }}
                                                className={
                                                  "form-control" +
                                                  (errors.euinmonth &&
                                                  touched.euinmonth
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                              >
                                                <option value="">MM</option>
                                                {(values.listOfMonth || []).map(
                                                  (m) => (
                                                    <option value={m.key}>
                                                      {m.value}
                                                    </option>
                                                  ),
                                                )}
                                              </Field>
                                            </div>
                                            <div className="col-md-5 col-lg-5 col-sm-5 col-xs-5 pl pr">
                                              <Field
                                                as="select"
                                                name="euinyear"
                                                id="euinyear"
                                                disabled={
                                                  values.disabledForCielops ===
                                                  true
                                                    ? false
                                                    : this.props.personnelData
                                                          .euinValidUpto ===
                                                          "" ||
                                                        this.props.personnelData
                                                          .euinValidUpto ===
                                                          undefined
                                                      ? false
                                                      : true
                                                }
                                                className={
                                                  "form-control" +
                                                  (errors.euinyear &&
                                                  touched.euinyear
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                              >
                                                <option value="">YYYY</option>
                                                {(
                                                  this.state.certificateYear ||
                                                  []
                                                ).map((euinyear) => (
                                                  <option value={euinyear}>
                                                    {euinyear}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                          </div>

                                          {errors.dob && (
                                            <div className="validation">
                                              {errors.dob}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          ) : (
                            ""
                          )}
                          {(values.preferredMandateName === "NISM" ||
                            ["", null].includes(values.learnerEuinOption)) && (
                            <section
                              className="create-parent page-section profile-box"
                              id="Preferred-NISM-Exam-Location"
                            >
                              <div className="row">
                                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                  <h2 className="sub-header">
                                    Preferred NISM Exam Location
                                  </h2>
                                  <div className="address-border">
                                    <div className="form-group">
                                      <div className="row">
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          <label>
                                            Preferred Exam Location
                                            <span className="validation">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <Field
                                            as="select"
                                            name="preferredExamLocation"
                                            id="preferredExamLocation"
                                            disabled={values.disabledForCielops}
                                            value={
                                              values.preferredExamLocation || ""
                                            } // always bind to Formik
                                            onChange={(e) => {
                                              handleChange(e);
                                              const value = e.target.value;

                                              if (value !== "") {
                                                setFieldValue(
                                                  "preferredExamLocationState",
                                                  e.target.selectedOptions[0]
                                                    .label,
                                                );
                                                setFieldValue(
                                                  "preferredExamLocation",
                                                  value,
                                                );
                                                this.setState({
                                                  preferredExamLocationState:
                                                    e.target.selectedOptions[0]
                                                      .label,
                                                  preferredExamLocation: value,
                                                });
                                                RegionManagementService.getCenter(
                                                  "stateId=" + value,
                                                  (res) => {
                                                    if (
                                                      res.status === "success"
                                                    ) {
                                                      setFieldValue(
                                                        "preferredExamCenterList",
                                                        res.responseListObject,
                                                      );
                                                      this.setState({
                                                        preferredExamCenterList:
                                                          res.responseListObject,
                                                      });
                                                    } else {
                                                      warning(
                                                        res.reasonText,
                                                        warningNotification,
                                                      );
                                                    }
                                                  },
                                                );
                                              }
                                            }}
                                            onBlur={this.handleNormalizeOnBlur(
                                              "preferredExamLocation",
                                              setFieldValue,
                                              values,
                                            )}
                                            className={
                                              "form-control" +
                                              (errors.preferredExamLocation &&
                                              touched.preferredExamLocation
                                                ? " is-invalid"
                                                : "")
                                            }
                                          >
                                            <option value="">
                                              --- Select ---
                                            </option>
                                            {(
                                              values.preferredExamLocationList ||
                                              []
                                            ).map((location) => (
                                              <option
                                                key={location.stateId}
                                                value={location.stateId}
                                              >
                                                {this.titleCase(
                                                  location.stateName,
                                                )}
                                              </option>
                                            ))}
                                          </Field>
                                          {errors.preferredExamLocation && (
                                            <div className="validation">
                                              {errors.preferredExamLocation}
                                            </div>
                                          )}
                                        </div>
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          <label>
                                            Preferred Exam Center
                                            <span className="validation">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <Field
                                            as="select"
                                            name="preferredExamCenter"
                                            id="preferredExamCenter"
                                            disabled={values.disabledForCielops}
                                            value={
                                              values.preferredExamCenter || ""
                                            } // always bind to Formik
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              handleChange(e);
                                              setFieldValue(
                                                "preferredExamCenter",
                                                value,
                                              );
                                              this.setState({
                                                preferredExamCenter: value,
                                              });
                                            }}
                                            onBlur={this.handleNormalizeOnBlur(
                                              "preferredExamCenter",
                                              setFieldValue,
                                              values,
                                            )}
                                            className={
                                              "form-control" +
                                              (errors.preferredExamCenter &&
                                              touched.preferredExamCenter
                                                ? " is-invalid"
                                                : "")
                                            }
                                          >
                                            <option value="">
                                              --- Select ---
                                            </option>
                                            {(
                                              values.preferredExamCenterList ||
                                              []
                                            ).map((team) => (
                                              <option
                                                key={team.centerName}
                                                value={team.centerName}
                                              >
                                                {team.centerName}
                                              </option>
                                            ))}
                                          </Field>
                                          {errors.preferredExamCenter && (
                                            <div className="validation">
                                              {errors.preferredExamCenter}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          )}
                          <section
                            className="create-parent page-section profile-box"
                            id="ARNDetails"
                          >
                            <div className="row">
                              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <h2 className="sub-header">ARN Details</h2>
                                <div className="address-border">
                                  <div className="form-group">
                                    <div className="row">
                                      <div className="col-md-4 col-sm-4 col-xs-12">
                                        <label>ARN Number </label>
                                        <Field
                                          type="text"
                                          name="ARNNO"
                                          id="ARNNO"
                                          disabled={
                                            this.state.isMandateUser === 1
                                              ? true
                                              : false
                                          }
                                          maxlength="20"
                                          className="form-control"
                                          placeholder="ARN Number"
                                          onChange={handleChange}
                                        />
                                        {errors.ARNNO && (
                                          <div className="validation">
                                            {errors.ARNNO}
                                          </div>
                                        )}
                                      </div>
                                      <div className="col-md-4 col-sm-4 col-xs-12">
                                        <label>Company Name </label>
                                        <Field
                                          type="text"
                                          name="orgCompanyName"
                                          disabled
                                          id="orgCompanyName"
                                          onChange={handleChange}
                                          autoComplete="otherCompanyName"
                                          className="form-control"
                                          placeholder="Company Name"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                          <section
                            className="create-profile page-section profile-box"
                            id="create-profile"
                          >
                            <h2 className="sub-header">Profile Details</h2>
                            <div className="form-group">
                              <div className="row">
                                <div className="col-md-4 col-sm-4 col-xs-12">
                                  <label>Upload Profile Image</label>
                                  <span className="validation">*</span>

                                  <div className="profile-detail">
                                    <div className="circle">
                                      {values.profilePhotoURL && (
                                        <>
                                          <img
                                            className="profile-pic"
                                            src={values.profilePhotoURL}
                                          />
                                          <div className="profile">
                                            <i
                                              className="fa fa-user"
                                              aria-hidden="true"
                                            />
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                  {/* <div className="hidden-md hidden-lg hidden-sm col-xs-12">
                                    <div className="profile-add">
                                      <a
                                        className="icon btn-file"
                                        disabled={values.disabledForCielops}
                                      >
                                        <i
                                          className="fa fa-plus-circle"
                                          aria-hidden="true"
                                        />
                                        <FileBase64
                                          id="profilePhoto"
                                          multiple={true}
                                          onChange={handleChange}
                                          onDone={(event) => {
                                            if (
                                              [
                                                "image/jpg",
                                                "image/jpeg",
                                                "image/png",
                                              ].indexOf(event[0].type) < 0
                                            ) {
                                              setFieldValue(
                                                (values.documentTypeCheckForProfileImage = true)
                                              );
                                            } else if (
                                              event[0].file.size <= 1048576
                                            ) {
                                              if (
                                                this.checkName(event[0].name)
                                              ) {
                                                values.document.push({
                                                  documentHash: event[0].base64,
                                                  documentType: "ProfilePhoto",
                                                  documentName: event[0].name,
                                                });

                                                setFieldValue(
                                                  (values.documentTypeCheckForProfileImage = false)
                                                );
                                                setFieldValue(
                                                  (values.documentSizeCheckForProfileCheck = false)
                                                );
                                                setFieldValue(
                                                  (values.profileImageDocumentNameValidation = false)
                                                );
                                                setFieldValue(
                                                  (values.profilePhotoName =
                                                    event[0].name)
                                                );
                                                values.profilePhotoURL =
                                                  event[0].base64;
                                                setFieldValue(
                                                  (values.profilePhotoURL =
                                                    event[0].base64)
                                                );
                                                this.updateCommonWeightage(
                                                  "profilePhotoURL",
                                                  event[0].name,
                                                  values
                                                );
                                              } else {
                                                setFieldValue(
                                                  (values.profileImageDocumentNameValidation = true)
                                                );
                                              }
                                            } else {
                                              setFieldValue(
                                                (values.profileImageDocumentNameValidation = false)
                                              );

                                              setFieldValue(
                                                (values.documentSizeCheckForProfileCheck = true)
                                              );
                                            }
                                          }}
                                        />{" "}
                                        <h4>Add Image</h4>
                                      </a>
                                      <div className="col-md-12 col-sm-12">
                                        <span className="file-size-limit">
                                          Please upload your latest colored
                                          passport size photo in jpg/jpeg,png
                                          format.
                                          <br />
                                          File Size: Max 1 MB
                                          <br />
                                          Photo should be preferably with white
                                          background (similar to a passport size
                                          photo)
                                        </span>
                                      </div>
                                      {values.documentSizeCheckForProfileCheck ? (
                                        <p style={{ color: "red" }}>
                                          File Size is too large(Maximum File
                                          Size:1MB).
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                      {values.documentTypeCheckForProfileImage ? (
                                        <p style={{ color: "red" }}>
                                          Invalid image format
                                        </p>
                                      ) : (
                                        ""
                                      )}

                                      {values.profileImageDocumentNameValidation ? (
                                        <p style={{ color: "red" }}>
                                          File/Document name can only contain
                                          number, letter, hyphens, space.
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div> */}
                                </div>

                                <div
                                  className="col-md-4 col-sm-4 col-xs-12"
                                  style={{ display: "none" }}
                                >
                                  <label>Upload Text Resume</label>
                                  <div className="text-resume">
                                    <h3>Select File To Upload</h3>
                                  </div>
                                  <div
                                    className="profile-add text-center"
                                    style={{
                                      wordBreak: "break-all",
                                      padding: "11px 25px 11px 6px",
                                    }}
                                  >
                                    {values.resumeDocumentNameDuringEdit !=
                                    "" ? (
                                      <span>
                                        {
                                          values.resumeDocumentNameDuringEditName
                                        }
                                      </span>
                                    ) : values.resumeDocumentName ? (
                                      <span>{values.resumeDocumentName}</span>
                                    ) : (
                                      <span>
                                        <span className="icon">
                                          <i
                                            className="fa fa-times-circle"
                                            aria-hidden="true"
                                          />
                                        </span>
                                        <h4>No File Chosen</h4>
                                      </span>
                                    )}

                                    <div>
                                      <a className="icon btn-file text-center">
                                        <i
                                          className="fa fa-paperclip color_magento"
                                          aria-hidden="true"
                                        />
                                        {values.documentSizeCheckForResume ? (
                                          <p style={{ color: "red" }}>
                                            File Size is too large(Maximum File
                                            Size:2MB).
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                        {values.documentTypeCheckForResume ? (
                                          <p style={{ color: "red" }}>
                                            Invalid Format
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                        <FileBase64
                                          multiple={true}
                                          name="resumeDocumentURL"
                                          onChange={handleChange}
                                          onDone={(event) => {
                                            const checkType =
                                              event[0].name.split(
                                                /\.(?=[^\.]+$)/,
                                              );

                                            var regexp1 = new RegExp(
                                              "^[p{L},-s‘’]+(?!.)$",
                                            );

                                            let result = !regexp1.test(
                                              event[0].name,
                                            );

                                            if (result == true) {
                                              if (
                                                [
                                                  "pdf",
                                                  "docx",
                                                  "rtf",
                                                  "doc",
                                                ].indexOf(checkType[1]) < 0
                                              ) {
                                                setFieldValue(
                                                  (values.documentTypeCheckForResume = true),
                                                );
                                              } else if (
                                                event[0].file.size <= 2000000
                                              ) {
                                                if (
                                                  this.checkName(event[0].name)
                                                ) {
                                                  values.document.push({
                                                    documentHash:
                                                      event[0].base64,
                                                    documentType:
                                                      "ResumeDocument",
                                                    documentName: event[0].name,
                                                  });
                                                  this.updateCommonWeightage(
                                                    "resumeDocumentURL",
                                                    event[0].name,
                                                    values,
                                                  );

                                                  setFieldValue(
                                                    (values.documentTypeCheckForResume = false),
                                                  );
                                                  setFieldValue(
                                                    (values.documentSizeCheckForResume = false),
                                                  );
                                                  setFieldValue(
                                                    (values.resumeDocumentNameValidation = false),
                                                  );

                                                  setFieldValue(
                                                    (values.resumeDocumentName =
                                                      event[0].name),
                                                  );
                                                  setFieldValue(
                                                    (values.resumeDocumentNameDuringEdit =
                                                      ""),
                                                  );
                                                  setFieldValue(
                                                    (values.downloadResumeAfterSelecting =
                                                      event[0].base64),
                                                  );
                                                } else {
                                                  setFieldValue(
                                                    (values.resumeDocumentNameValidation = true),
                                                  );
                                                }
                                              } else {
                                                setFieldValue(
                                                  (values.resumeDocumentNameValidation = false),
                                                );

                                                setFieldValue(
                                                  (values.documentSizeCheckForResume = true),
                                                );
                                              }
                                            } else {
                                              setFieldValue(
                                                (values.resumeDocumentNameValidation = true),
                                              );
                                            }
                                          }}
                                        />
                                      </a>
                                    </div>
                                  </div>
                                  <div className="hidden-md hidden-lg hidden-sm col-xs-12">
                                    <div className="profile-add">
                                      <a className="icon btn-file">
                                        {values.downloadResumeAfterSelecting ? (
                                          <a
                                            href={
                                              values.downloadResumeAfterSelecting
                                            }
                                            className="download"
                                            download={values.resumeDocumentName}
                                          >
                                            <i
                                              className="fa fa-download"
                                              aria-hidden="true"
                                            />
                                            <h4> Download Resume </h4>
                                          </a>
                                        ) : (
                                            values.resumeDocumentURL || ""
                                          ).includes("pdf") ? (
                                          <a
                                            href={values.resumeDocumentURL}
                                            className="download"
                                            target="_blank"
                                          >
                                            <i
                                              className="fa fa-download"
                                              aria-hidden="true"
                                            />
                                            <h4> Download Resume </h4>
                                          </a>
                                        ) : values.resumeDocumentURL ? (
                                          <a
                                            href={values.resumeDocumentURL}
                                            className="download"
                                          >
                                            <i
                                              className="fa fa-download"
                                              aria-hidden="true"
                                            />
                                            <h4> Download Resume </h4>
                                          </a>
                                        ) : (
                                          <span>
                                            <i
                                              className="fa fa-download"
                                              aria-hidden="true"
                                            />
                                            <h4> Download Resume </h4>
                                          </span>
                                        )}
                                      </a>
                                      <div className="col-md-12 col-sm-12">
                                        <span className="file-size-limit">
                                          Supported Formats: .doc,.docx, .pdf,
                                          .rtf only. File Size: Max 2 MB
                                        </span>

                                        {values.resumeDocumentNameValidation ? (
                                          <p style={{ color: "red" }}>
                                            File/Document name can only contain
                                            number, letter, hyphens, space.
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="col-md-4 col-sm-4 col-xs-12"
                                  style={{ display: "none" }}
                                >
                                  <label>Upload Video Resume</label>
                                  <div className="profile-detail">
                                    <div className="circle">
                                      <div className="profile-pic">
                                        <div className="profile">
                                          <ReactPlayer
                                            width="100%"
                                            height="90"
                                            url={values.resumeVideoURL}
                                            playing={false}
                                            controls
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="hidden-md hidden-lg hidden-sm col-xs-12">
                                    <div className="profile-add">
                                      <a>
                                        <span
                                          className="icon btn-file text-center"
                                          disabled={values.disabledForCielops}
                                        >
                                          <i
                                            className="fa fa-plus-circle"
                                            aria-hidden="true"
                                          />
                                          <FileBase64
                                            multiple={true}
                                            name="resumeVideoURL"
                                            onChange={handleChange}
                                            onDone={(event) => {
                                              if (
                                                [
                                                  "video/mp4",
                                                  "video/avi",
                                                  "video/mpeg",
                                                ].indexOf(event[0].type) < 0
                                              ) {
                                                setFieldValue(
                                                  (values.documentTypeCheckForVideo = true),
                                                );
                                              } else if (
                                                event[0].file.size <= 3000000
                                              ) {
                                                if (
                                                  this.checkName(event[0].name)
                                                ) {
                                                  values.document.push({
                                                    documentHash:
                                                      event[0].base64,
                                                    documentType: "VideoResume",
                                                    documentName: event[0].name,
                                                  });
                                                  this.updateCommonWeightage(
                                                    "resumeVideoURL",
                                                    event[0].name,
                                                    values,
                                                  );

                                                  setFieldValue(
                                                    (values.documentTypeCheckForVideo = false),
                                                  );
                                                  setFieldValue(
                                                    (values.documentSizeCheckForVideoCheck = false),
                                                  );
                                                  setFieldValue(
                                                    (values.VideodocumentNameValidation = false),
                                                  );
                                                  setFieldValue(
                                                    (values.resumeVideoURL =
                                                      event[0].base64),
                                                  );
                                                } else {
                                                  setFieldValue(
                                                    (values.VideodocumentNameValidation = true),
                                                  );
                                                }
                                              } else {
                                                setFieldValue(
                                                  (values.VideodocumentNameValidation = false),
                                                );
                                                setFieldValue(
                                                  (values.documentSizeCheckForVideoCheck = true),
                                                );
                                              }
                                            }}
                                          />

                                          <h4>Add Video</h4>
                                        </span>
                                      </a>
                                      {values.documentSizeCheckForVideoCheck ? (
                                        <p style={{ color: "red" }}>
                                          File Size is too large(Maximum File
                                          Size:3MB).
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                      {values.documentTypeCheckForVideo ? (
                                        <p style={{ color: "red" }}>
                                          Invalid Format
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                      {values.VideodocumentNameValidation ? (
                                        <p style={{ color: "red" }}>
                                          Video name should contains numbers,
                                          letters, hypens, spaces.
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                      <div className="col-md-12 col-sm-12">
                                        <span className="file-size-limit">
                                          Supported Formats: .mp4, .avi, .mpeg
                                          only. <br />
                                          File Size: Max 3 MB
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    display: [
                                      "",
                                      null,
                                      undefined,
                                      "NISM",
                                    ].includes(
                                      this.state?.mandateDetails?.mandateName,
                                    )
                                      ? "none"
                                      : "",
                                  }}
                                  className="col-md-4 col-sm-4 col-xs-12"
                                >
                                  <label>
                                    Signature Image
                                    <span className="validation"> *</span>
                                  </label>
                                  <div className="profile-detail">
                                    <div className="circle">
                                      {values.signatureImgUrl && (
                                        <>
                                          <img
                                            className="profile-pic"
                                            src={values.signatureImgUrl}
                                          />
                                          <div className="profile">
                                            <i
                                              className="fa fa-user"
                                              aria-hidden="true"
                                            />
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                  {/* <div className="hidden-md hidden-lg hidden-sm profile-add">
                                    <a>
                                      <span className="icon btn-file text-center">
                                        <i
                                          className="fa fa-plus-circle"
                                          aria-hidden="true"
                                        />
                                        <FileBase64
                                          multiple={true}
                                          name="signatureImgUrl"
                                          onChange={handleChange}
                                          onDone={(event) => {
                                            const checkType =
                                              event[0].name.split(
                                                /\.(?=[^\.]+$)/
                                              );
                                            if (
                                              [
                                                "jpg",
                                                "JPG",
                                                "jpeg",
                                                "JPEG",
                                                "png",
                                                "PNG",
                                              ].indexOf(checkType[1]) < 0
                                            ) {
                                              setFieldValue(
                                                (values.documentTypeCheckForSignature = true)
                                              );
                                              setFieldValue(
                                                (values.documentSizeCheckForSignature = false)
                                              );
                                            } else if (
                                              event[0].file.size <= 1048576
                                            ) {
                                              values.document.push({
                                                documentHash: event[0].base64,
                                                documentType:
                                                  "LearnerSignature",
                                                documentName: event[0].name,
                                              });
                                              this.updateCommonWeightage(
                                                "signatureImgUrl",
                                                event[0].name,
                                                values
                                              );
                                              setFieldValue(
                                                (values.documentTypeCheckForSignature = false)
                                              );
                                              setFieldValue(
                                                (values.signatureImgName =
                                                  event[0].name)
                                              );
                                              setFieldValue(
                                                (values.documentSizeCheckForSignature = false)
                                              );
                                              setFieldValue(
                                                (values.signatureImgUrl =
                                                  event[0].base64)
                                              );
                                            } else {
                                              setFieldValue(
                                                (values.documentSizeCheckForSignature = true)
                                              );
                                              setFieldValue(
                                                (values.documentTypeCheckForSignature = false)
                                              );
                                            }
                                          }}
                                        />
                                        <h4>Add File</h4>
                                      </span>
                                    </a>
                                    <div className="col-md-12 col-sm-12">
                                      <span className="file-size-limit">
                                        Signature as per PAN Card <br />
                                        The file should be in jpg/jpeg, png
                                        format. <br />
                                        File Size: Max 1 MB
                                      </span>
                                    </div>
                                    {values.documentSizeCheckForSignature ? (
                                      <p style={{ color: "red" }}>
                                        File Size is too large(Maximum File
                                        Size:1MB).
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                    {values.documentTypeCheckForSignature ? (
                                      <p style={{ color: "red" }}>
                                        Invalid image format
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div> */}
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-4 col-sm-4 col-xs-12">
                                  <div className="profile-add">
                                    <a
                                      href
                                      className="icon btn-file"
                                      disabled={values.disabledForCielops}
                                    >
                                      <i
                                        className="fa fa-plus-circle"
                                        aria-hidden="true"
                                      />
                                      <FileBase64
                                        key={this.state.profileFileKey} // 👈 add key
                                        id="profilePhoto"
                                        multiple={true}
                                        onChange={handleChange}
                                        // onDone={(event) => {
                                        //   if (
                                        //     [
                                        //       "image/jpg",
                                        //       "image/jpeg",
                                        //       "image/png",
                                        //     ].indexOf(event[0].type) < 0
                                        //   ) {
                                        //     setFieldValue(
                                        //       (values.documentTypeCheckForProfileImage = true)
                                        //     );
                                        //   } else if (
                                        //     event[0].file.size <= 1048576
                                        //   ) {
                                        //     if (this.checkName(event[0].name)) {
                                        //       values.document.push({
                                        //         documentHash: event[0].base64,
                                        //         documentType: "ProfilePhoto",
                                        //         documentName: event[0].name,
                                        //       });
                                        //       this.updateCommonWeightage(
                                        //         "profilePhotoURL",
                                        //         event[0].name,
                                        //         values
                                        //       );
                                        //       setFieldValue(
                                        //         (values.documentTypeCheckForProfileImage = false)
                                        //       );
                                        //       setFieldValue(
                                        //         (values.documentSizeCheckForProfileCheck = false)
                                        //       );
                                        //       setFieldValue(
                                        //         (values.profileImageDocumentNameValidation = false)
                                        //       );
                                        //       setFieldValue(
                                        //         (values.profilePhotoName =
                                        //           event[0].name)
                                        //       );
                                        //       values.profilePhotoURL =
                                        //         event[0].base64;
                                        //       setFieldValue(
                                        //         (values.profilePhotoURL =
                                        //           event[0].base64)
                                        //       );
                                        //     } else {
                                        //       setFieldValue(
                                        //         (values.profileImageDocumentNameValidation = true)
                                        //       );
                                        //     }
                                        //   } else {
                                        //     setFieldValue(
                                        //       (values.profileImageDocumentNameValidation = false)
                                        //     );

                                        //     setFieldValue(
                                        //       (values.documentSizeCheckForProfileCheck = true)
                                        //     );
                                        //   }
                                        // }}
                                        onDone={(event) => {
                                          const file = event[0]; // FileBase64 gives an array
                                          if (!file) return;
                                          if (file) {
                                            const fileName = file.name;
                                            const fileSize = file.file.size;
                                            const base64 = file.base64;
                                            const validExtensions = [
                                              "jpg",
                                              "jpeg",
                                              "png",
                                            ];
                                            const ext = fileName
                                              .split(".")
                                              .pop()
                                              .toLowerCase();
                                            const maxSize = 1048576; // 1MB
                                            // ❌ Invalid extension
                                            if (
                                              !validExtensions.includes(ext)
                                            ) {
                                              warning(
                                                `Invalid Image Format - Profile Photo`,
                                                warningNotification,
                                              );
                                              this.setState({
                                                profileFileKey: Date.now(), // 🔑 force re-render FileBase64
                                              });
                                              return;
                                            }
                                            // ❌ Invalid size
                                            if (fileSize > maxSize) {
                                              warning(
                                                `File size exceeds 1MB - Profile Photo`,
                                                warningNotification,
                                              );
                                              this.setState({
                                                profileFileKey: Date.now(), // 🔑 reset
                                              });
                                              return;
                                            }
                                            // ❌ Double extensions (abc.jpg.png)
                                            const regex = new RegExp(
                                              `^[^.]+\\.(${validExtensions.join(
                                                "|",
                                              )})$`,
                                              "i",
                                            );
                                            if (!regex.test(fileName)) {
                                              warning(
                                                `Only single extension is allowed - Profile Photo`,
                                                warningNotification,
                                              );
                                              this.setState({
                                                profileFileKey: Date.now(), // 🔑 reset
                                              });
                                              return;
                                            }
                                            if (!this.checkName(fileName)) {
                                              warning(
                                                `File/Document name can only contain
                                                number, letter, hyphens, space. - Profile Photo`,
                                                warningNotification,
                                              );
                                              this.setState({
                                                profileFileKey: Date.now(), // 🔑 reset
                                              });
                                              return;
                                            }
                                            // ❌ Invalid name
                                            if (!this.checkName(fileName)) {
                                              this.setState({
                                                profileImageDocumentNameValidation: true,
                                                documentTypeCheckForProfileImage: false,
                                                documentSizeCheckForProfileCheck: false,
                                                profileFileKey: Date.now(), // 🔑 reset
                                              });
                                              return;
                                            }
                                            // ✅ Passed all checks → Save file
                                            const newDoc = {
                                              documentHash: base64,
                                              documentType: "ProfilePhoto",
                                              documentName: fileName,
                                            };
                                            this.setState(
                                              (prevState) => ({
                                                document: [
                                                  ...prevState.document,
                                                  newDoc,
                                                ],
                                                profilePhotoName: fileName,
                                                profilePhotoURL: base64,
                                                documentTypeCheckForProfileImage: false,
                                                documentSizeCheckForProfileCheck: false,
                                                profileImageDocumentNameValidation: false,
                                                profileFileKey: Date.now(), // 🔑 reset so same file can still trigger
                                              }),
                                              () => {
                                                this.updateCommonWeightage(
                                                  "profilePhotoURL",
                                                  fileName,
                                                  this.state,
                                                );
                                              },
                                            );
                                          }
                                        }}
                                      />{" "}
                                      <h4>Add Image</h4>
                                    </a>

                                    <div className="col-md-12 col-sm-12">
                                      <span className="file-size-limit">
                                        Please upload your latest colored
                                        passport size photo in jpg/jpeg, png
                                        format. <br />
                                        File Size: Max 1 MB
                                        <br />
                                        Photo should be preferably with white
                                        background (similar to a passport size
                                        photo)
                                      </span>
                                    </div>
                                    {values.documentSizeCheckForProfileCheck ? (
                                      <p style={{ color: "red" }}>
                                        File Size is too large(Maximum File
                                        Size:1MB).
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                    {values.documentTypeCheckForProfileImage ? (
                                      <p style={{ color: "red" }}>
                                        Invalid image format
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                    {values.profileImageDocumentNameValidation ? (
                                      <p style={{ color: "red" }}>
                                        File/Document name can only contain
                                        number, letter, hyphens, space.
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>

                                <div
                                  className="col-md-4 col-sm-4 hidden-xs"
                                  style={{ display: "none" }}
                                >
                                  <div className="profile-add">
                                    <a className="icon btn-file">
                                      {values.downloadResumeAfterSelecting ? (
                                        <a
                                          href={
                                            values.downloadResumeAfterSelecting
                                          }
                                          className="download"
                                          download={values.resumeDocumentName}
                                        >
                                          <i
                                            className="fa fa-download"
                                            aria-hidden="true"
                                          />
                                          <h4> Download Resume </h4>
                                        </a>
                                      ) : (
                                          values.resumeDocumentURL || ""
                                        ).includes("pdf") ? (
                                        <a
                                          href={values.resumeDocumentURL}
                                          className="download"
                                          target="_blank"
                                        >
                                          <i
                                            className="fa fa-download"
                                            aria-hidden="true"
                                          />
                                          <h4> Download Resume </h4>
                                        </a>
                                      ) : values.resumeDocumentURL ? (
                                        <a
                                          href={values.resumeDocumentURL}
                                          className="download"
                                        >
                                          <i
                                            className="fa fa-download"
                                            aria-hidden="true"
                                          />
                                          <h4> Download Resume </h4>
                                        </a>
                                      ) : (
                                        <span>
                                          <i
                                            className="fa fa-download"
                                            aria-hidden="true"
                                          />
                                          <h4> Download Resume </h4>
                                        </span>
                                      )}
                                    </a>
                                    <div className="col-md-12 col-sm-12">
                                      <span className="file-size-limit">
                                        Supported Formats: .doc,.docx, .pdf,
                                        .rtf only. File Size: Max 2 MB
                                      </span>
                                      {values.resumeDocumentNameValidation ? (
                                        <p style={{ color: "red" }}>
                                          File/Document name can only contain
                                          number, letter, hyphens, space.
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div
                                  style={{ display: "none" }}
                                  className="col-md-4 col-sm-4 hidden-xs"
                                >
                                  <div className="profile-add">
                                    <a
                                      style={
                                        values.disabledForCielops
                                          ? {
                                              pointerEvents: "none",
                                              cursor: "default",
                                            }
                                          : {}
                                      }
                                    >
                                      <span className="icon btn-file text-center">
                                        <i
                                          className="fa fa-plus-circle"
                                          aria-hidden="true"
                                        />
                                        <FileBase64
                                          multiple={true}
                                          name="resumeVideoURL"
                                          onChange={handleChange}
                                          onDone={(event) => {
                                            if (
                                              [
                                                "video/mp4",
                                                "video/avi",
                                                "video/mpeg",
                                              ].indexOf(event[0].type) < 0
                                            ) {
                                              setFieldValue(
                                                (values.documentTypeCheckForVideo = true),
                                              );
                                            } else if (
                                              event[0].file.size <= 3000000
                                            ) {
                                              if (
                                                this.checkName(event[0].name)
                                              ) {
                                                values.document.push({
                                                  documentHash: event[0].base64,
                                                  documentType: "VideoResume",
                                                  documentName: event[0].name,
                                                });
                                                this.updateCommonWeightage(
                                                  "resumeVideoURL",
                                                  event[0].name,
                                                  values,
                                                );
                                                setFieldValue(
                                                  (values.documentTypeCheckForVideo = false),
                                                );
                                                setFieldValue(
                                                  (values.documentSizeCheckForVideoCheck = false),
                                                );
                                                setFieldValue(
                                                  (values.VideodocumentNameValidation = false),
                                                );

                                                setFieldValue(
                                                  (values.resumeVideoURL =
                                                    event[0].base64),
                                                );
                                              } else {
                                                setFieldValue(
                                                  (values.VideodocumentNameValidation = true),
                                                );
                                              }
                                            } else {
                                              setFieldValue(
                                                (values.VideodocumentNameValidation = false),
                                              );

                                              setFieldValue(
                                                (values.documentSizeCheckForVideoCheck = true),
                                              );
                                            }
                                          }}
                                        />

                                        <h4>Add Video</h4>
                                      </span>
                                    </a>
                                    {values.documentSizeCheckForVideoCheck ? (
                                      <p style={{ color: "red" }}>
                                        File Size is too large(Maximum File
                                        Size:3MB).
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                    {values.documentTypeCheckForVideo ? (
                                      <p style={{ color: "red" }}>
                                        Invalid Format
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                    {values.VideodocumentNameValidation ? (
                                      <p style={{ color: "red" }}>
                                        Video name should contains numbers,
                                        letters, hypens, spaces.
                                      </p>
                                    ) : (
                                      ""
                                    )}

                                    <div className="col-md-12 col-sm-12">
                                      <span className="file-size-limit">
                                        Supported Formats: .mp4, .avi, .mpeg
                                        only. <br />
                                        File Size: Max 3 MB
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="col-md-4 col-sm-4 col-xs-12"
                                  style={{
                                    display: [
                                      "",
                                      null,
                                      undefined,
                                      "NISM",
                                    ].includes(
                                      this.state?.mandateDetails?.mandateName,
                                    )
                                      ? "none"
                                      : "",
                                  }}
                                >
                                  <div className="profile-add">
                                    <a>
                                      <span className="icon btn-file text-center">
                                        <i
                                          className="fa fa-plus-circle"
                                          aria-hidden="true"
                                        />
                                        <FileBase64
                                          multiple={true}
                                          key={this.state.signatureFileKey} // 👈 add key
                                          id="signatureImgUrl"
                                          name="signatureImgUrl"
                                          onChange={handleChange}
                                          // onDone={(event) => {
                                          //   const checkType =
                                          //     event[0].name.split(
                                          //       /\.(?=[^\.]+$)/
                                          //     );
                                          //   if (
                                          //     [
                                          //       "jpg",
                                          //       "JPG",
                                          //       "jpeg",
                                          //       "JPEG",
                                          //       "png",
                                          //       "PNG",
                                          //     ].indexOf(checkType[1]) < 0
                                          //   ) {
                                          //     setFieldValue(
                                          //       (values.documentTypeCheckForSignature = true)
                                          //     );
                                          //     setFieldValue(
                                          //       (values.documentSizeCheckForSignature = false)
                                          //     );
                                          //   } else if (
                                          //     event[0].file.size <= 1048576
                                          //   ) {
                                          //     values.document.push({
                                          //       documentHash: event[0].base64,
                                          //       documentType:
                                          //         "LearnerSignature",
                                          //       documentName: event[0].name,
                                          //     });
                                          //     this.updateCommonWeightage(
                                          //       "signatureImgUrl",
                                          //       event[0].name,
                                          //       values
                                          //     );
                                          //     setFieldValue(
                                          //       (values.documentTypeCheckForSignature = false)
                                          //     );
                                          //     setFieldValue(
                                          //       (values.signatureImgName =
                                          //         event[0].name)
                                          //     );
                                          //     setFieldValue(
                                          //       (values.documentSizeCheckForSignature = false)
                                          //     );
                                          //     setFieldValue(
                                          //       (values.signatureImgUrl =
                                          //         event[0].base64)
                                          //     );
                                          //   } else {
                                          //     setFieldValue(
                                          //       (values.documentSizeCheckForSignature = true)
                                          //     );
                                          //     setFieldValue(
                                          //       (values.documentTypeCheckForSignature = false)
                                          //     );
                                          //   }
                                          // }}
                                          onDone={(event) => {
                                            const file = event[0]; // FileBase64 gives an array
                                            if (!file) return;
                                            if (file) {
                                              const fileName = file.name;
                                              const fileSize = file.file.size;
                                              const base64 = file.base64;
                                              const validExtensions = [
                                                "jpg",
                                                "jpeg",
                                                "png",
                                              ];
                                              const ext = fileName
                                                .split(".")
                                                .pop()
                                                .toLowerCase();
                                              const maxSize = 1048576; // 1MB
                                              // ❌ Invalid extension
                                              if (
                                                !validExtensions.includes(ext)
                                              ) {
                                                warning(
                                                  `Invalid Image Format - Learner Signature`,
                                                  warningNotification,
                                                );
                                                this.setState({
                                                  signatureFileKey: Date.now(), // 🔑 force re-render FileBase64
                                                });
                                                return;
                                              }
                                              // ❌ Invalid size
                                              if (fileSize > maxSize) {
                                                warning(
                                                  `File size exceeds 1MB - Learner Signature`,
                                                  warningNotification,
                                                );
                                                this.setState({
                                                  signatureFileKey: Date.now(), // 🔑 reset
                                                });
                                                return;
                                              }
                                              // ❌ Double extensions (abc.jpg.png)
                                              const regex = new RegExp(
                                                `^[^.]+\\.(${validExtensions.join(
                                                  "|",
                                                )})$`,
                                                "i",
                                              );
                                              if (!regex.test(fileName)) {
                                                warning(
                                                  `Only single extension is allowed - Learner Signature`,
                                                  warningNotification,
                                                );
                                                this.setState({
                                                  signatureFileKey: Date.now(), // 🔑 reset
                                                });
                                                return;
                                              }
                                              // ✅ Passed all checks → Save file
                                              const newDoc = {
                                                documentHash: base64,
                                                documentType:
                                                  "LearnerSignature",
                                                documentName: fileName,
                                              };
                                              this.setState(
                                                (prevState) => ({
                                                  document: [
                                                    ...prevState.document,
                                                    newDoc,
                                                  ],
                                                  signatureImgName: fileName,
                                                  signatureImgUrl: base64,
                                                  documentTypeCheckForSignature: false,
                                                  documentSizeCheckForSignature: false,
                                                  signatureFileKey: Date.now(), // 🔑 reset so same file can still trigger
                                                }),
                                                () => {
                                                  this.updateCommonWeightage(
                                                    "signatureImgUrl",
                                                    fileName,
                                                    this.state,
                                                  );
                                                },
                                              );
                                            }
                                          }}
                                        />
                                        <h4>Add File</h4>
                                      </span>
                                    </a>
                                    <div className="col-md-12 col-sm-12">
                                      <span className="file-size-limit">
                                        Signature as per PAN Card <br />
                                        The file should be in jpg/jpeg, png
                                        format. <br />
                                        File Size: Max 1 MB
                                      </span>
                                    </div>
                                    {values.documentSizeCheckForSignature ? (
                                      <p style={{ color: "red" }}>
                                        File Size is too large(Maximum File
                                        Size:1MB).
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                    {values.documentTypeCheckForSignature ? (
                                      <p style={{ color: "red" }}>
                                        Invalid image format
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-20 pl pr profile-footer">
                            {roledata.map((item, key) =>
                              item.description === "Update User Profile" ? (
                                item.objectActionId
                                  .applicationObjectActionName ===
                                "My User Profile" ? (
                                  item.objectActionId.applicationObjectId
                                    .applicationObjectName === "Save" ? (
                                    <div>
                                      <button
                                        onClick={async () => {
                                          if (
                                            values.orgCompanyName ===
                                            "HDFC Bank Limited"
                                          ) {
                                            window
                                              .$("#Hdfc-Mandate")
                                              .modal("show");
                                          } else {
                                            setFieldValue(
                                              (values.submitStatus =
                                                "SUBMITTED"),
                                            );

                                            const curErrors =
                                              await formikProps.validateForm();
                                            console.log(curErrors);
                                            let errorData = [];
                                            errorData.push(curErrors);

                                            const curErrorsKeys =
                                              Object.keys(curErrors);

                                            if (curErrorsKeys.length) {
                                              if (errorData.length > 0) {
                                                warning(
                                                  "You have either not filled all mandatory fields or not uploaded all document for NISM. In case you don't have your documents ready, please save your profile as 'Save Draft'. Add the documents to move to the next section",
                                                  warningNotification,
                                                );
                                              }
                                              console.log(
                                                "eeee",
                                                curErrorsKeys,
                                              );
                                              const el =
                                                document.getElementById(
                                                  curErrorsKeys[0],
                                                );

                                              if (el) {
                                                el.focus();
                                              }
                                            } else {
                                              handleSubmit();
                                            }
                                          }
                                        }}
                                        className="btn-4 pull-right"
                                        name="submitForm"
                                        type="button"
                                        disabled={this.state.submitBtnDisabled}
                                      >
                                        Submit
                                      </button>
                                      {values.applicationStatus ==
                                      "SUBMITTED" ? (
                                        ""
                                      ) : (
                                        <button
                                          onClick={async (event) => {
                                            if (
                                              values.orgCompanyName ===
                                              "HDFC Bank Limited"
                                            ) {
                                              window
                                                .$("#Hdfc-Mandate")
                                                .modal("show");
                                            } else {
                                              setFieldValue(
                                                (values.submitStatus =
                                                  "DRAFTED"),
                                              );

                                              const curErrors =
                                                await formikProps.validateForm();
                                              const curErrorsKeys =
                                                Object.keys(curErrors);

                                              if (curErrorsKeys.length) {
                                                const el =
                                                  document.getElementById(
                                                    curErrorsKeys[0],
                                                  );

                                                if (el) {
                                                  el.focus();
                                                }
                                              } else {
                                                handleSubmit();
                                              }
                                            }
                                          }}
                                          className="btn-4 pull-right"
                                          name="submitForm"
                                          type="button"
                                          disabled={
                                            this.state.saveDraftBtnDisabled
                                          }
                                        >
                                          Save Draft
                                        </button>
                                      )}
                                    </div>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              ),
                            )}
                            <button
                              onClick={async () => {
                                if (localStorage.getItem("roleId") == 5) {
                                  window.location.href = "/learnerDashboard";
                                } else {
                                  this.props.history.push("/dashboard");
                                }
                              }}
                              className="btn-4 pull-right"
                              name="submitForm"
                              type="button"
                            >
                              Cancel
                            </button>

                            {localStorage.getItem("roleId") == 6 ? (
                              <button
                                onClick={async () => {
                                  if (
                                    values.orgCompanyName ===
                                    "HDFC Bank Limited"
                                  ) {
                                    window.$("#Hdfc-Mandate").modal("show");
                                  } else {
                                    setFieldValue(
                                      (values.submitStatus = "SUBMITTED"),
                                    );

                                    const curErrors =
                                      await formikProps.validateForm();
                                    console.log(curErrors);
                                    let errorData = [];
                                    errorData.push(curErrors);

                                    const curErrorsKeys =
                                      Object.keys(curErrors);

                                    if (curErrorsKeys.length) {
                                      if (errorData.length > 0) {
                                        warning(
                                          "You have either not filled all mandatory fields or not uploaded all document for NISM. In case you don't have your documents ready, please save your profile as 'Save Draft'. Add the documents to move to the next section",
                                          warningNotification,
                                        );
                                      }
                                      const el = document.getElementById(
                                        curErrorsKeys[0],
                                      );

                                      if (el) {
                                        el.focus();
                                      }
                                    } else {
                                      handleSubmit();
                                    }
                                  }
                                }}
                                className="btn-4 pull-right"
                                name="submitForm"
                                type="button"
                              >
                                Submit
                              </button>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </Form>
                    </main>
                  </div>
                </div>
              </div>

              {/* HDFC MANDATE POPUP STARTS */}

              <div
                className="modal fade"
                id="Hdfc-Mandate"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="myModalLabel"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={this.handleClose}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <span style={{ fontSize: "17px" }}>
                        In case you experience difficulty in submitting the
                        profile due to your corporate machine, please use your
                        personal laptop/desktop OR your mobile device and submit
                        profile again.
                      </span>
                    </div>
                    <div className="modal-footer text-center">
                      {roledata.map((item, key) =>
                        item.description === "Update User Profile" ? (
                          item.objectActionId.applicationObjectActionName ===
                          "My User Profile" ? (
                            item.objectActionId.applicationObjectId
                              .applicationObjectName === "Save" ? (
                              <div>
                                <button
                                  onClick={async () => {
                                    window.$("#Hdfc-Mandate").modal("hide");
                                    setFieldValue(
                                      (values.submitStatus = "SUBMITTED"),
                                    );

                                    const curErrors =
                                      await formikProps.validateForm();
                                    console.log(curErrors);
                                    let errorData = [];
                                    errorData.push(curErrors);

                                    const curErrorsKeys =
                                      Object.keys(curErrors);

                                    if (curErrorsKeys.length) {
                                      if (errorData.length > 0) {
                                        warning(
                                          "You have either not filled all mandatory fields or not uploaded all document for NISM. In case you don't have your documents ready, please save your profile as 'Save Draft'. Add the documents to move to the next section",
                                          warningNotification,
                                        );
                                      }
                                      console.log("eeee", curErrorsKeys);
                                      const el = document.getElementById(
                                        curErrorsKeys[0],
                                      );
                                      if (el) {
                                        el.focus();
                                      }
                                    } else {
                                      handleSubmit();
                                    }
                                  }}
                                  className="btn-4 pull-right"
                                  name="submitForm"
                                  type="submit"
                                  disabled={this.state.submitHDFCBtnDisabled}
                                >
                                  Submit
                                </button>
                                {values.applicationStatus == "SUBMITTED" ? (
                                  ""
                                ) : (
                                  <button
                                    onClick={async (event) => {
                                      window.$("#Hdfc-Mandate").modal("hide");
                                      setFieldValue(
                                        (values.submitStatus = "DRAFTED"),
                                      );

                                      const curErrors =
                                        await formikProps.validateForm();
                                      const curErrorsKeys =
                                        Object.keys(curErrors);

                                      if (curErrorsKeys.length) {
                                        const el = document.getElementById(
                                          curErrorsKeys[0],
                                        );
                                        if (el) {
                                          el.focus();
                                        }
                                      } else {
                                        handleSubmit();
                                      }
                                    }}
                                    className="btn-4 pull-right"
                                    name="submitForm"
                                    type="submit"
                                    disabled={
                                      this.state.saveDraftHDFCBtnDisabled
                                    }
                                  >
                                    Save Draft
                                  </button>
                                )}
                              </div>
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        ),
                      )}
                      {localStorage.getItem("roleId") == 6 ? (
                        <button
                          onClick={async () => {
                            window.$("#Hdfc-Mandate").modal("hide");
                            setFieldValue((values.submitStatus = "SUBMITTED"));

                            const curErrors = await formikProps.validateForm();
                            console.log(curErrors);
                            let errorData = [];
                            errorData.push(curErrors);

                            const curErrorsKeys = Object.keys(curErrors);

                            if (curErrorsKeys.length) {
                              if (errorData.length > 0) {
                                warning(
                                  "You have either not filled all mandatory fields or not uploaded all document for NISM. In case you don't have your documents ready, please save your profile as 'Save Draft'. Add the documents to move to the next section",
                                  warningNotification,
                                );
                              }
                              const el = document.getElementById(
                                curErrorsKeys[0],
                              );

                              if (el) {
                                el.focus();
                              }
                            } else {
                              handleSubmit();
                            }
                          }}
                          className="btn-4 pull-right"
                          name="submitForm"
                          type="submit"
                        >
                          Submit
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* HDFC MANDATE POPUP ENDS */}
              <Modal
                open={this.state.showWhyTheFillForm}
                onClose={this.onWhyTheFillFormCloseModal}
                center
              >
                <div
                  className=""
                  id="roadmap"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="modalLabel"
                  data-keyboard="true"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-md" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <div className="scr-board">
                          <h2>Why Fill The Form? </h2>
                          <div className="bottom-line" />
                        </div>
                      </div>
                      <div className="modal-body">
                        The Profile Form is a means of gathering your
                        information which would help us in serving you more
                        efficiently through your journey towards becoming a
                        Mutual Fund Advisor.
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn-5 mt-40"
                          name="btnNo"
                          onClick={this.onWhyTheFillFormCloseModal}
                        >
                          Ok
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>
            </section>
          </React.Fragment>
        )}
      />
    );
  }
}

export default UserProfile;
